(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("jquery"), require("hammerjs"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "jquery", "hammerjs"], factory);
	else if(typeof exports === 'object')
		exports["ui"] = factory(require("base"), require("core"), require("jquery"), require("hammerjs"));
	else
		root["ui"] = factory(root["base"], root["core"], root["jquery"], root["hammerjs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_26__, __WEBPACK_EXTERNAL_MODULE_69__, __WEBPACK_EXTERNAL_MODULE_79__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(14);
	module.exports = __webpack_require__(18);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(15);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(17)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../../../../../usr/local/lib/node_modules/bb-lp-cli/node_modules/css-loader/index.js!./../../../../../../../../../usr/local/lib/node_modules/bb-lp-cli/node_modules/less-loader/index.js!./../../../../../../../../../usr/local/lib/node_modules/bb-lp-cli/node_modules/postcss-loader/index.js!./base.less", function() {
				var newContent = require("!!./../../../../../../../../../usr/local/lib/node_modules/bb-lp-cli/node_modules/css-loader/index.js!./../../../../../../../../../usr/local/lib/node_modules/bb-lp-cli/node_modules/less-loader/index.js!./../../../../../../../../../usr/local/lib/node_modules/bb-lp-cli/node_modules/postcss-loader/index.js!./base.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(16)();
	// imports


	// module
	exports.push([module.id, ".list-group .list-group-container .list-group-item{border-radius:0;padding:10px 0}.list-group .list-group-container~.list-group-container .list-group-item{border-top:0;border-bottom:1px solid #ddd}.wizard-wrapper .wizard-header{padding:0}.wizard-wrapper .wizard-header .wizard-header-title{margin-bottom:15px;margin-top:0;text-align:left}.wizard-wrapper .wizard-steps{position:relative;padding-bottom:15px}.wizard-wrapper .wizard-step{margin:0 5px;color:#777;white-space:nowrap;width:1.6em}.wizard-wrapper .wizard-step-number{margin-right:5px;border:1px solid #777;border-radius:.8em;display:inline-block;text-align:center;width:1.6em}.wizard-wrapper .wizard-step-number-active{background-color:#fff;color:#333}.wizard-wrapper .wizard-step-heading{position:absolute;left:5px;width:100%}.wizard-wrapper .wizard-step-arrow{color:#a4a5a0;top:3px}.wizard-wrapper .wizard-step-done{background-color:#5cb85c;border-color:#4cae4c;color:#fff}.wizard-wrapper .wizard-future-step{border:1px solid #777}.wizard-wrapper .wizard-active-step{color:#333;border-color:#333}@media (min-width:768px){.wizard-wrapper .wizard-step{width:auto}.wizard-wrapper .wizard-steps{padding-bottom:0}.wizard-wrapper .wizard-step-heading{position:relative;left:auto}}@media (max-width:768px){.wizard-wrapper .wizard-step-container{display:inline-block}.wizard-wrapper .wizard-header .wizard-header-title{text-align:center}}.lp-input-overflow .lp-input-overflow-indicator{height:inherit;top:2px;right:2px;bottom:2px;display:inherit;padding-left:3px;z-index:1;opacity:1}.lp-input-overflow .lp-input-overflow-indicator.inactive{display:none}.lp-input-overflow .lp-input-overflow-elipsis{font-size:21px;margin:-3px 2px 0 0;line-height:0;color:#777;position:absolute;top:0;bottom:0}.lp-input-overflow .lp-input-overflow-elipsis:after{content:\"\";display:inline-block;height:100%;vertical-align:middle;background:red}.lp-input-overflow .lp-input-overflow-input-text{display:none;white-space:nowrap}.contract-trigger:before,.responsive-shadow,.responsive-shadow>div{content:\" \";display:block;position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}.responsive-shadow{visibility:hidden}.responsive-shadow>div{overflow:auto}.contract-trigger:before{width:200%;height:200%}.custom-select{display:block;height:34px;text-align:left;width:100%}.custom-select,.custom-select .custom-select-placeholder,.custom-select .custom-select-value{position:relative}.custom-select .custom-select-input{border:none;bottom:0;cursor:pointer;height:100%;left:0;opacity:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";position:absolute;right:0;top:0;width:100%;-webkit-appearance:none}.custom-select .custom-select-caret{margin-top:-1px;pointer-events:none;position:absolute;right:12px;top:50%}.custom-radio{display:block;position:relative;text-align:left;line-height:14px;width:100%}.custom-radio input[type=radio]{position:absolute;margin:0;top:3px;left:5px;opacity:0}.custom-radio .custom-radio-wrapper{position:absolute;width:14px;height:14px;top:0;left:0;border-radius:50%;background:#fff;border:2px solid #a8adb4;display:none\\9}.custom-radio .custom-radio-check{position:absolute;top:4px;left:4px;width:6px;height:6px;border-radius:50%;background:#1375bc;display:none\\9}.custom-radio .custom-radio-label{cursor:pointer;padding-left:19px;color:#a8adb4;font-size:1em;font-weight:400}.custom-radio.active .custom-radio-wrapper,.custom-radio.checked .custom-radio-wrapper,.custom-radio.focus .custom-radio-wrapper,.custom-radio:active .custom-radio-wrapper,.custom-radio:focus .custom-radio-wrapper,.custom-radio:hover .custom-radio-wrapper{border-color:#1375bc}.custom-radio.active .custom-radio-label,.custom-radio.checked .custom-radio-label,.custom-radio.focus .custom-radio-label,.custom-radio:active .custom-radio-label,.custom-radio:focus .custom-radio-label,.custom-radio:hover .custom-radio-label{color:#616161}.custom-radio.disabled.active .custom-radio-wrapper,.custom-radio.disabled.checked .custom-radio-wrapper,.custom-radio.disabled.focus .custom-radio-wrapper,.custom-radio.disabled:active .custom-radio-wrapper,.custom-radio.disabled:focus .custom-radio-wrapper,.custom-radio.disabled:hover .custom-radio-wrapper{cursor:default;border-color:#a8adb4}.custom-radio.disabled.active .custom-radio-label,.custom-radio.disabled.checked .custom-radio-label,.custom-radio.disabled.focus .custom-radio-label,.custom-radio.disabled:active .custom-radio-label,.custom-radio.disabled:focus .custom-radio-label,.custom-radio.disabled:hover .custom-radio-label{cursor:default;color:#a8adb4}.custom-radio.disabled.active .custom-radio-check,.custom-radio.disabled.checked .custom-radio-check,.custom-radio.disabled.focus .custom-radio-check,.custom-radio.disabled:active .custom-radio-check,.custom-radio.disabled:focus .custom-radio-check,.custom-radio.disabled:hover .custom-radio-check{background-color:#a8adb4}.custom-radio.disabled .custom-radio-label,.custom-radio.disabled .custom-radio-wrapper{opacity:.5}.custom-radio-sm .custom-radio{line-height:12px}.custom-radio-sm .custom-radio .custom-radio-wrapper{width:12px;height:12px}.custom-radio-sm .custom-radio .custom-radio-check{top:4px;left:4px;width:4px;height:4px}.custom-radio-sm .custom-radio .custom-radio-label{padding-left:17px;font-size:.9em}.custom-radio-lg .custom-radio{line-height:20px}.custom-radio-lg .custom-radio .custom-radio-wrapper{width:20px;height:20px}.custom-radio-lg .custom-radio .custom-radio-check{top:4px;left:4px;width:12px;height:12px}.custom-radio-lg .custom-radio .custom-radio-label{padding-left:25px}.custom-checkbox{display:block;position:relative;text-align:left;line-height:14px;width:100%}.custom-checkbox input[type=checkbox]{position:absolute;margin:0;top:3px;left:5px;opacity:0}.custom-checkbox .custom-checkbox-box{position:absolute;width:14px;height:14px;top:0;left:0;border-radius:4px;background:#fff;border:2px solid #363636;display:none\\9}.custom-checkbox .custom-checkbox-checkmark{position:absolute;top:-2px;left:2px;width:10px;height:10px;-webkit-transform:rotate(45deg);transform:rotate(45deg);display:none\\9}.custom-checkbox .custom-checkbox-stem{position:absolute;width:2px;height:8px;border-radius:4px;background-color:#1375bc;left:8px;top:3px;display:none\\9}.custom-checkbox .custom-checkbox-kick{position:absolute;width:5px;height:2px;border-radius:4px;background-color:#1375bc;left:5px;top:9px;display:none\\9}.custom-checkbox .custom-checkbox-label{cursor:pointer;padding-left:19px;color:#616161;font-size:1em;font-weight:400}.custom-checkbox.active .custom-checkbox-box,.custom-checkbox.checked .custom-checkbox-box,.custom-checkbox:active .custom-checkbox-box,.custom-checkbox:hover .custom-checkbox-box{border-color:#1375bc}.custom-checkbox.disabled{opacity:.5}.custom-checkbox.disabled.active .custom-checkbox-box,.custom-checkbox.disabled.checked .custom-checkbox-box,.custom-checkbox.disabled .custom-checkbox-box,.custom-checkbox.disabled:active .custom-checkbox-box,.custom-checkbox.disabled:hover .custom-checkbox-box{border-color:#a8adb4}.custom-checkbox.disabled.active .custom-checkbox-kick,.custom-checkbox.disabled.active .custom-checkbox-stem,.custom-checkbox.disabled.checked .custom-checkbox-kick,.custom-checkbox.disabled.checked .custom-checkbox-stem,.custom-checkbox.disabled .custom-checkbox-kick,.custom-checkbox.disabled .custom-checkbox-stem,.custom-checkbox.disabled:active .custom-checkbox-kick,.custom-checkbox.disabled:active .custom-checkbox-stem,.custom-checkbox.disabled:hover .custom-checkbox-kick,.custom-checkbox.disabled:hover .custom-checkbox-stem{background-color:#a8adb4}.custom-checkbox.disabled.active .custom-checkbox-label,.custom-checkbox.disabled.checked .custom-checkbox-label,.custom-checkbox.disabled .custom-checkbox-label,.custom-checkbox.disabled:active .custom-checkbox-label,.custom-checkbox.disabled:hover .custom-checkbox-label{color:#a8adb4;cursor:default}.custom-checkbox-sm .custom-checkbox{line-height:12px}.custom-checkbox-sm .custom-checkbox .custom-checkbox-box{width:12px;height:12px}.custom-checkbox-sm .custom-checkbox .custom-checkbox-checkmark{left:1px;width:8px;height:8px}.custom-checkbox-sm .custom-checkbox .custom-checkbox-stem{width:2px;height:6px;left:7px;top:3px}.custom-checkbox-sm .custom-checkbox .custom-checkbox-kick{width:3px;height:2px;left:5px;top:7px}.custom-checkbox-sm .custom-checkbox .custom-checkbox-label{padding-left:17px;font-size:.9em}.custom-checkbox-lg .custom-checkbox{line-height:20px}.custom-checkbox-lg .custom-checkbox .custom-checkbox-box{width:20px;height:20px}.custom-checkbox-lg .custom-checkbox .custom-checkbox-checkmark{width:16px;height:16px}.custom-checkbox-lg .custom-checkbox .custom-checkbox-stem{width:3px;height:11px;left:11px;top:4px}.custom-checkbox-lg .custom-checkbox .custom-checkbox-kick{width:5px;height:3px;left:7px;top:12px}.custom-checkbox-lg .custom-checkbox .custom-checkbox-label{padding-left:25px}.lp-floating-label{position:relative}.lp-floating-label label{background:none;position:absolute;left:15px;top:15px;z-index:0}.lp-floating-label label.float-top{margin-top:-6px;transition:margin-top .2s ease-out;font-size:12px;font-weight:400;z-index:2}.lp-floating-label input,.lp-floating-label textarea{background-color:transparent;position:relative;width:100%;border:none;min-height:50px;padding-left:15px;padding-bottom:0;z-index:1}.lp-floating-label input:focus,.lp-floating-label textarea:focus{background-color:transparent}.lp-floating-label input{padding-top:14px}.lp-floating-label textarea{max-width:100%;border-top:22px solid transparent;margin-bottom:-5px}", ""]);

	// exports


/***/ },
/* 16 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}

	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui';

	    var base = __webpack_require__(20);

	    // 3rd party vendor
	    // Using angular boostrap
	    __webpack_require__(21);

	    var deps = [
	    'ui.bootstrap',
	    __webpack_require__(23).name,
	    __webpack_require__(25).name,
	    __webpack_require__(28).name,
	    __webpack_require__(30).name,
	    __webpack_require__(34).name,
	    __webpack_require__(37).name,
	    __webpack_require__(40).name,
	    __webpack_require__(42).name,
	    __webpack_require__(44).name,
	    __webpack_require__(46).name,
	    __webpack_require__(48).name,
	    __webpack_require__(50).name,
	    __webpack_require__(52).name,
	    __webpack_require__(55).name,
	    __webpack_require__(57).name,
	    __webpack_require__(60).name,
	    __webpack_require__(62).name,
	    __webpack_require__(64).name,
	    __webpack_require__(67).name,
	    __webpack_require__(77).name,
	    __webpack_require__(80).name,
	    __webpack_require__(83).name,
	    __webpack_require__(86).name,
	    __webpack_require__(88).name,
	    __webpack_require__(90).name,
	    __webpack_require__(92).name,
	    __webpack_require__(94).name,
	    __webpack_require__(96).name,
	    __webpack_require__(98).name,
	    __webpack_require__(104).name,
	    __webpack_require__(110).name,
	    // ui utils
	    __webpack_require__(114).name];


	    module.exports = base.createModule(module.name, deps).
	    config(__webpack_require__(22));

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /* eslint-disable*/
	// todo: remove this - it's required for requirejs to know to load
	// angular before loading this.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	  'use strict';

	  var angular = __webpack_require__(20).ng;
	  __webpack_require__(22);

	  /*
	                                                    * angular-ui-bootstrap
	                                                    * http://angular-ui.github.io/bootstrap/
	                                                   
	                                                    * Version: 1.2.2 - 2016-03-03
	                                                    * License: MIT
	                                                    */
	  angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.debounce", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
	  angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/popup.html", "uib/template/datepicker/year.html", "uib/template/modal/backdrop.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
	  angular.module('ui.bootstrap.collapse', []).

	  directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function link(scope, element, attrs) {
	        var expandingExpr = $parse(attrs.expanding),
	        expandedExpr = $parse(attrs.expanded),
	        collapsingExpr = $parse(attrs.collapsing),
	        collapsedExpr = $parse(attrs.collapsed);

	        if (!scope.$eval(attrs.uibCollapse)) {
	          element.addClass('in').
	          addClass('collapse').
	          attr('aria-expanded', true).
	          attr('aria-hidden', false).
	          css({ height: 'auto' });
	        }

	        function expand() {
	          if (element.hasClass('collapse') && element.hasClass('in')) {
	            return;
	          }

	          $q.resolve(expandingExpr(scope)).
	          then(function () {
	            element.removeClass('collapse').
	            addClass('collapsing').
	            attr('aria-expanded', true).
	            attr('aria-hidden', false);

	            if ($animateCss) {
	              $animateCss(element, {
	                addClass: 'in',
	                easing: 'ease',
	                to: { height: element[0].scrollHeight + 'px' } }).
	              start()['finally'](expandDone);
	            } else {
	              $animate.addClass(element, 'in', {
	                to: { height: element[0].scrollHeight + 'px' } }).
	              then(expandDone);
	            }
	          });
	        }

	        function expandDone() {
	          element.removeClass('collapsing').
	          addClass('collapse').
	          css({ height: 'auto' });
	          expandedExpr(scope);
	        }

	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }

	          $q.resolve(collapsingExpr(scope)).
	          then(function () {
	            element
	            // IMPORTANT: The height must be set before adding "collapsing" class.
	            // Otherwise, the browser attempts to animate from height 0 (in
	            // collapsing class) to the given height here.
	            .css({ height: element[0].scrollHeight + 'px' })
	            // initially all panel collapse have the collapse class, this removal
	            // prevents the animation from jumping to collapsed state
	            .removeClass('collapse').
	            addClass('collapsing').
	            attr('aria-expanded', false).
	            attr('aria-hidden', true);

	            if ($animateCss) {
	              $animateCss(element, {
	                removeClass: 'in',
	                to: { height: '0' } }).
	              start()['finally'](collapseDone);
	            } else {
	              $animate.removeClass(element, 'in', {
	                to: { height: '0' } }).
	              then(collapseDone);
	            }
	          });
	        }

	        function collapseDone() {
	          element.css({ height: '0' }); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing').
	          addClass('collapse');
	          collapsedExpr(scope);
	        }

	        scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      } };

	  }]);

	  angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse']).

	  constant('uibAccordionConfig', {
	    closeOthers: true }).


	  controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
	    // This array keeps track of the accordion groups
	    this.groups = [];

	    // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	    this.closeOthers = function (openGroup) {
	      var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	      if (closeOthers) {
	        angular.forEach(this.groups, function (group) {
	          if (group !== openGroup) {
	            group.isOpen = false;
	          }
	        });
	      }
	    };

	    // This is called from the accordion-group directive to add itself to the accordion
	    this.addGroup = function (groupScope) {
	      var that = this;
	      this.groups.push(groupScope);

	      groupScope.$on('$destroy', function (event) {
	        that.removeGroup(groupScope);
	      });
	    };

	    // This is called from the accordion-group directive when to remove itself
	    this.removeGroup = function (group) {
	      var index = this.groups.indexOf(group);
	      if (index !== -1) {
	        this.groups.splice(index, 1);
	      }
	    };
	  }])

	  // The accordion directive simply sets up the directive controller
	  // and adds an accordion CSS class to itself element.
	  .directive('uibAccordion', function () {
	    return {
	      controller: 'UibAccordionController',
	      controllerAs: 'accordion',
	      transclude: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	      } };

	  })

	  // The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	  .directive('uibAccordionGroup', function () {
	    return {
	      require: '^uibAccordion', // We need this directive to be inside an accordion
	      transclude: true, // It transcludes the contents of the directive into the template
	      replace: true, // The element containing the directive will be replaced with the template
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	      },
	      scope: {
	        heading: '@', // Interpolate the heading attribute onto this scope
	        isOpen: '=?',
	        isDisabled: '=?' },

	      controller: function controller() {
	        this.setHeading = function (element) {
	          this.heading = element;
	        };
	      },
	      link: function link(scope, element, attrs, accordionCtrl) {
	        accordionCtrl.addGroup(scope);

	        scope.openClass = attrs.openClass || 'panel-open';
	        scope.panelClass = attrs.panelClass || 'panel-default';
	        scope.$watch('isOpen', function (value) {
	          element.toggleClass(scope.openClass, !!value);
	          if (value) {
	            accordionCtrl.closeOthers(scope);
	          }
	        });

	        scope.toggleOpen = function ($event) {
	          if (!scope.isDisabled) {
	            if (!$event || $event.which === 32) {
	              scope.isOpen = !scope.isOpen;
	            }
	          }
	        };

	        var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	        scope.headingId = id + '-tab';
	        scope.panelId = id + '-panel';
	      } };

	  })

	  // Use accordion-heading below an accordion-group to provide a heading containing HTML
	  .directive('uibAccordionHeading', function () {
	    return {
	      transclude: true, // Grab the contents to be used as the heading
	      template: '', // In effect remove this element!
	      replace: true,
	      require: '^uibAccordionGroup',
	      link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
	        // Pass the heading to the accordion-group controller
	        // so that it can be transcluded into the right place in the template
	        // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	        accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	      } };

	  })

	  // Use in the accordion-group template to indicate where you want the heading to be transcluded
	  // You must provide the property on the accordion-group controller that will hold the transcluded element
	  .directive('uibAccordionTransclude', function () {
	    return {
	      require: '^uibAccordionGroup',
	      link: function link(scope, element, attrs, controller) {
	        scope.$watch(function () {return controller[attrs.uibAccordionTransclude];}, function (heading) {
	          if (heading) {
	            var elem = angular.element(element[0].querySelector('[uib-accordion-header]'));
	            elem.html('');
	            elem.append(heading);
	          }
	        });
	      } };

	  });

	  angular.module('ui.bootstrap.alert', []).

	  controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function ($scope, $attrs, $interpolate, $timeout) {
	    $scope.closeable = !!$attrs.close;

	    var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

	    if (dismissOnTimeout) {
	      $timeout(function () {
	        $scope.close();
	      }, parseInt(dismissOnTimeout, 10));
	    }
	  }]).

	  directive('uibAlert', function () {
	    return {
	      controller: 'UibAlertController',
	      controllerAs: 'alert',
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/alert/alert.html';
	      },
	      transclude: true,
	      replace: true,
	      scope: {
	        type: '@',
	        close: '&' } };


	  });

	  angular.module('ui.bootstrap.buttons', []).

	  constant('uibButtonConfig', {
	    activeClass: 'active',
	    toggleEvent: 'click' }).


	  controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
	    this.activeClass = buttonConfig.activeClass || 'active';
	    this.toggleEvent = buttonConfig.toggleEvent || 'click';
	  }]).

	  directive('uibBtnRadio', ['$parse', function ($parse) {
	    return {
	      require: ['uibBtnRadio', 'ngModel'],
	      controller: 'UibButtonsController',
	      controllerAs: 'buttons',
	      link: function link(scope, element, attrs, ctrls) {
	        var buttonsCtrl = ctrls[0],ngModelCtrl = ctrls[1];
	        var uncheckableExpr = $parse(attrs.uibUncheckable);

	        element.find('input').css({ display: 'none' });

	        //model -> UI
	        ngModelCtrl.$render = function () {
	          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	        };

	        //ui->model
	        element.on(buttonsCtrl.toggleEvent, function () {
	          if (attrs.disabled) {
	            return;
	          }

	          var isActive = element.hasClass(buttonsCtrl.activeClass);

	          if (!isActive || angular.isDefined(attrs.uncheckable)) {
	            scope.$apply(function () {
	              ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	              ngModelCtrl.$render();
	            });
	          }
	        });

	        if (attrs.uibUncheckable) {
	          scope.$watch(uncheckableExpr, function (uncheckable) {
	            attrs.$set('uncheckable', uncheckable ? '' : undefined);
	          });
	        }
	      } };

	  }]).

	  directive('uibBtnCheckbox', function () {
	    return {
	      require: ['uibBtnCheckbox', 'ngModel'],
	      controller: 'UibButtonsController',
	      controllerAs: 'button',
	      link: function link(scope, element, attrs, ctrls) {
	        var buttonsCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	        element.find('input').css({ display: 'none' });

	        function getTrueValue() {
	          return getCheckboxValue(attrs.btnCheckboxTrue, true);
	        }

	        function getFalseValue() {
	          return getCheckboxValue(attrs.btnCheckboxFalse, false);
	        }

	        function getCheckboxValue(attribute, defaultValue) {
	          return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	        }

	        //model -> UI
	        ngModelCtrl.$render = function () {
	          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	        };

	        //ui->model
	        element.on(buttonsCtrl.toggleEvent, function () {
	          if (attrs.disabled) {
	            return;
	          }

	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	            ngModelCtrl.$render();
	          });
	        });
	      } };

	  });

	  angular.module('ui.bootstrap.carousel', []).

	  controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
	    var self = this,
	    slides = self.slides = $scope.slides = [],
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = $scope.active,
	    currentInterval,isPlaying,bufferedTransitions = [];

	    var destroyed = false;

	    self.addSlide = function (slide, element) {
	      slides.push({
	        slide: slide,
	        element: element });

	      slides.sort(function (a, b) {
	        return +a.slide.index > +b.slide.index;
	      });
	      //if this is the first slide or the slide is set to active, select it
	      if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
	        if ($scope.$currentTransition) {
	          $scope.$currentTransition = null;
	        }

	        currentIndex = slide.index;
	        $scope.active = slide.index;
	        setActive(currentIndex);
	        self.select(slides[findSlideIndex(slide)]);
	        if (slides.length === 1) {
	          $scope.play();
	        }
	      }
	    };

	    self.getCurrentIndex = function () {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide.index === currentIndex) {
	          return i;
	        }
	      }
	    };

	    self.next = $scope.next = function () {
	      var newIndex = (self.getCurrentIndex() + 1) % slides.length;

	      if (newIndex === 0 && $scope.noWrap()) {
	        $scope.pause();
	        return;
	      }

	      return self.select(slides[newIndex], 'next');
	    };

	    self.prev = $scope.prev = function () {
	      var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

	      if ($scope.noWrap() && newIndex === slides.length - 1) {
	        $scope.pause();
	        return;
	      }

	      return self.select(slides[newIndex], 'prev');
	    };

	    self.removeSlide = function (slide) {
	      var index = findSlideIndex(slide);

	      var bufferedIndex = bufferedTransitions.indexOf(slides[index]);
	      if (bufferedIndex !== -1) {
	        bufferedTransitions.splice(bufferedIndex, 1);
	      }

	      //get the index of the slide inside the carousel
	      slides.splice(index, 1);
	      if (slides.length > 0 && currentIndex === index) {
	        if (index >= slides.length) {
	          currentIndex = slides.length - 1;
	          $scope.active = currentIndex;
	          setActive(currentIndex);
	          self.select(slides[slides.length - 1]);
	        } else {
	          currentIndex = index;
	          $scope.active = currentIndex;
	          setActive(currentIndex);
	          self.select(slides[index]);
	        }
	      } else if (currentIndex > index) {
	        currentIndex--;
	        $scope.active = currentIndex;
	      }

	      //clean the active value when no more slide
	      if (slides.length === 0) {
	        currentIndex = null;
	        $scope.active = null;
	        clearBufferedTransitions();
	      }
	    };

	    /* direction: "prev" or "next" */
	    self.select = $scope.select = function (nextSlide, direction) {
	      var nextIndex = findSlideIndex(nextSlide.slide);
	      //Decide direction if it's not given
	      if (direction === undefined) {
	        direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	      }
	      //Prevent this user-triggered transition from occurring if there is already one in progress
	      if (nextSlide.slide.index !== currentIndex &&
	      !$scope.$currentTransition) {
	        goNext(nextSlide.slide, nextIndex, direction);
	      } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {
	        bufferedTransitions.push(slides[nextIndex]);
	      }
	    };

	    /* Allow outside people to call indexOf on slides array */
	    $scope.indexOfSlide = function (slide) {
	      return +slide.slide.index;
	    };

	    $scope.isActive = function (slide) {
	      return $scope.active === slide.slide.index;
	    };

	    $scope.pause = function () {
	      if (!$scope.noPause) {
	        isPlaying = false;
	        resetTimer();
	      }
	    };

	    $scope.play = function () {
	      if (!isPlaying) {
	        isPlaying = true;
	        restartTimer();
	      }
	    };

	    $scope.$on('$destroy', function () {
	      destroyed = true;
	      resetTimer();
	    });

	    $scope.$watch('noTransition', function (noTransition) {
	      $animate.enabled($element, !noTransition);
	    });

	    $scope.$watch('interval', restartTimer);

	    $scope.$watchCollection('slides', resetTransition);

	    $scope.$watch('active', function (index) {
	      if (angular.isNumber(index) && currentIndex !== index) {
	        for (var i = 0; i < slides.length; i++) {
	          if (slides[i].slide.index === index) {
	            index = i;
	            break;
	          }
	        }

	        var slide = slides[index];
	        if (slide) {
	          currentIndex = index;
	          setActive(index);
	          self.select(slides[index]);
	        }
	      }
	    });

	    function clearBufferedTransitions() {
	      while (bufferedTransitions.length) {
	        bufferedTransitions.shift();
	      }
	    }

	    function getSlideByIndex(index) {
	      for (var i = 0, l = slides.length; i < l; ++i) {
	        if (slides[i].index === index) {
	          return slides[i];
	        }
	      }
	    }

	    function setActive(index) {
	      for (var i = 0; i < slides.length; i++) {
	        slides[i].slide.active = i === index;
	      }
	    }

	    function goNext(slide, index, direction) {
	      if (destroyed) {
	        return;
	      }

	      angular.extend(slide, { direction: direction });
	      angular.extend(slides[currentIndex].slide || {}, { direction: direction });
	      if ($animate.enabled($element) && !$scope.$currentTransition &&
	      slides[index].element && self.slides.length > 1) {
	        slides[index].element.data(SLIDE_DIRECTION, slide.direction);
	        var currentIdx = self.getCurrentIndex();

	        if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
	          slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
	        }

	        $scope.$currentTransition = true;
	        $animate.on('addClass', slides[index].element, function (element, phase) {
	          if (phase === 'close') {
	            $scope.$currentTransition = null;
	            $animate.off('addClass', element);
	            if (bufferedTransitions.length) {
	              var nextSlide = bufferedTransitions.pop().slide;
	              var nextIndex = nextSlide.index;
	              var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	              clearBufferedTransitions();

	              goNext(nextSlide, nextIndex, nextDirection);
	            }
	          }
	        });
	      }

	      $scope.active = slide.index;
	      currentIndex = slide.index;
	      setActive(index);

	      //every time you change slides, reset the timer
	      restartTimer();
	    }

	    function findSlideIndex(slide) {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide === slide) {
	          return i;
	        }
	      }
	    }

	    function resetTimer() {
	      if (currentInterval) {
	        $interval.cancel(currentInterval);
	        currentInterval = null;
	      }
	    }

	    function resetTransition(slides) {
	      if (!slides.length) {
	        $scope.$currentTransition = null;
	        clearBufferedTransitions();
	      }
	    }

	    function restartTimer() {
	      resetTimer();
	      var interval = +$scope.interval;
	      if (!isNaN(interval) && interval > 0) {
	        currentInterval = $interval(timerFn, interval);
	      }
	    }

	    function timerFn() {
	      var interval = +$scope.interval;
	      if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	        $scope.next();
	      } else {
	        $scope.pause();
	      }
	    }
	  }]).

	  directive('uibCarousel', function () {
	    return {
	      transclude: true,
	      replace: true,
	      controller: 'UibCarouselController',
	      controllerAs: 'carousel',
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/carousel/carousel.html';
	      },
	      scope: {
	        active: '=',
	        interval: '=',
	        noTransition: '=',
	        noPause: '=',
	        noWrap: '&' } };


	  }).

	  directive('uibSlide', function () {
	    return {
	      require: '^uibCarousel',
	      transclude: true,
	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/carousel/slide.html';
	      },
	      scope: {
	        actual: '=?',
	        index: '=?' },

	      link: function link(scope, element, attrs, carouselCtrl) {
	        carouselCtrl.addSlide(scope, element);
	        //when the scope is destroyed then remove the slide from the current slides array
	        scope.$on('$destroy', function () {
	          carouselCtrl.removeSlide(scope);
	        });
	      } };

	  }).

	  animation('.item', ['$animateCss',
	  function ($animateCss) {
	    var SLIDE_DIRECTION = 'uib-slideDirection';

	    function removeClass(element, className, callback) {
	      element.removeClass(className);
	      if (callback) {
	        callback();
	      }
	    }

	    return {
	      beforeAddClass: function beforeAddClass(element, className, done) {
	        if (className === 'active') {
	          var stopped = false;
	          var direction = element.data(SLIDE_DIRECTION);
	          var directionClass = direction === 'next' ? 'left' : 'right';
	          var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	          element.addClass(direction);

	          $animateCss(element, { addClass: directionClass }).
	          start().
	          done(removeClassFn);

	          return function () {
	            stopped = true;
	          };
	        }
	        done();
	      },
	      beforeRemoveClass: function beforeRemoveClass(element, className, done) {
	        if (className === 'active') {
	          var stopped = false;
	          var direction = element.data(SLIDE_DIRECTION);
	          var directionClass = direction === 'next' ? 'left' : 'right';
	          var removeClassFn = removeClass.bind(this, element, directionClass, done);

	          $animateCss(element, { addClass: directionClass }).
	          start().
	          done(removeClassFn);

	          return function () {
	            stopped = true;
	          };
	        }
	        done();
	      } };

	  }]);

	  angular.module('ui.bootstrap.dateparser', []).

	  service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function ($log, $locale, dateFilter, orderByFilter) {
	    // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	    var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

	    var localeId;
	    var formatCodeToRegex;

	    this.init = function () {
	      localeId = $locale.id;

	      this.parsers = {};
	      this.formatters = {};

	      formatCodeToRegex = [
	      {
	        key: 'yyyy',
	        regex: '\\d{4}',
	        apply: function apply(value) {this.year = +value;},
	        formatter: function formatter(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yyyy');
	        } },

	      {
	        key: 'yy',
	        regex: '\\d{2}',
	        apply: function apply(value) {this.year = +value + 2000;},
	        formatter: function formatter(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yy');
	        } },

	      {
	        key: 'y',
	        regex: '\\d{1,4}',
	        apply: function apply(value) {this.year = +value;},
	        formatter: function formatter(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'y');
	        } },

	      {
	        key: 'M!',
	        regex: '0?[1-9]|1[0-2]',
	        apply: function apply(value) {this.month = value - 1;},
	        formatter: function formatter(date) {
	          var value = date.getMonth();
	          if (/^[0-9]$/.test(value)) {
	            return dateFilter(date, 'MM');
	          }

	          return dateFilter(date, 'M');
	        } },

	      {
	        key: 'MMMM',
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function apply(value) {this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);},
	        formatter: function formatter(date) {return dateFilter(date, 'MMMM');} },

	      {
	        key: 'MMM',
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function apply(value) {this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);},
	        formatter: function formatter(date) {return dateFilter(date, 'MMM');} },

	      {
	        key: 'MM',
	        regex: '0[1-9]|1[0-2]',
	        apply: function apply(value) {this.month = value - 1;},
	        formatter: function formatter(date) {return dateFilter(date, 'MM');} },

	      {
	        key: 'M',
	        regex: '[1-9]|1[0-2]',
	        apply: function apply(value) {this.month = value - 1;},
	        formatter: function formatter(date) {return dateFilter(date, 'M');} },

	      {
	        key: 'd!',
	        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function apply(value) {this.date = +value;},
	        formatter: function formatter(date) {
	          var value = date.getDate();
	          if (/^[1-9]$/.test(value)) {
	            return dateFilter(date, 'dd');
	          }

	          return dateFilter(date, 'd');
	        } },

	      {
	        key: 'dd',
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function apply(value) {this.date = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'dd');} },

	      {
	        key: 'd',
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function apply(value) {this.date = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'd');} },

	      {
	        key: 'EEEE',
	        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	        formatter: function formatter(date) {return dateFilter(date, 'EEEE');} },

	      {
	        key: 'EEE',
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	        formatter: function formatter(date) {return dateFilter(date, 'EEE');} },

	      {
	        key: 'HH',
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function apply(value) {this.hours = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'HH');} },

	      {
	        key: 'hh',
	        regex: '0[0-9]|1[0-2]',
	        apply: function apply(value) {this.hours = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'hh');} },

	      {
	        key: 'H',
	        regex: '1?[0-9]|2[0-3]',
	        apply: function apply(value) {this.hours = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'H');} },

	      {
	        key: 'h',
	        regex: '[0-9]|1[0-2]',
	        apply: function apply(value) {this.hours = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'h');} },

	      {
	        key: 'mm',
	        regex: '[0-5][0-9]',
	        apply: function apply(value) {this.minutes = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'mm');} },

	      {
	        key: 'm',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function apply(value) {this.minutes = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'm');} },

	      {
	        key: 'sss',
	        regex: '[0-9][0-9][0-9]',
	        apply: function apply(value) {this.milliseconds = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'sss');} },

	      {
	        key: 'ss',
	        regex: '[0-5][0-9]',
	        apply: function apply(value) {this.seconds = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 'ss');} },

	      {
	        key: 's',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function apply(value) {this.seconds = +value;},
	        formatter: function formatter(date) {return dateFilter(date, 's');} },

	      {
	        key: 'a',
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function apply(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }

	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        },
	        formatter: function formatter(date) {return dateFilter(date, 'a');} },

	      {
	        key: 'Z',
	        regex: '[+-]\\d{4}',
	        apply: function apply(value) {
	          var matches = value.match(/([+-])(\d{2})(\d{2})/),
	          sign = matches[1],
	          hours = matches[2],
	          minutes = matches[3];
	          this.hours += toInt(sign + hours);
	          this.minutes += toInt(sign + minutes);
	        },
	        formatter: function formatter(date) {
	          return dateFilter(date, 'Z');
	        } },

	      {
	        key: 'ww',
	        regex: '[0-4][0-9]|5[0-3]',
	        formatter: function formatter(date) {return dateFilter(date, 'ww');} },

	      {
	        key: 'w',
	        regex: '[0-9]|[1-4][0-9]|5[0-3]',
	        formatter: function formatter(date) {return dateFilter(date, 'w');} },

	      {
	        key: 'GGGG',
	        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	        formatter: function formatter(date) {return dateFilter(date, 'GGGG');} },

	      {
	        key: 'GGG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function formatter(date) {return dateFilter(date, 'GGG');} },

	      {
	        key: 'GG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function formatter(date) {return dateFilter(date, 'GG');} },

	      {
	        key: 'G',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function formatter(date) {return dateFilter(date, 'G');} }];


	    };

	    this.init();

	    function createParser(format, func) {
	      var map = [],regex = format.split('');

	      // check for literal values
	      var quoteIndex = format.indexOf('\'');
	      if (quoteIndex > -1) {
	        var inLiteral = false;
	        format = format.split('');
	        for (var i = quoteIndex; i < format.length; i++) {
	          if (inLiteral) {
	            if (format[i] === '\'') {
	              if (i + 1 < format.length && format[i + 1] === '\'') {// escaped single quote
	                format[i + 1] = '$';
	                regex[i + 1] = '';
	              } else {// end of literal
	                regex[i] = '';
	                inLiteral = false;
	              }
	            }
	            format[i] = '$';
	          } else {
	            if (format[i] === '\'') {// start of literal
	              format[i] = '$';
	              regex[i] = '';
	              inLiteral = true;
	            }
	          }
	        }

	        format = format.join('');
	      }

	      angular.forEach(formatCodeToRegex, function (data) {
	        var index = format.indexOf(data.key);

	        if (index > -1) {
	          format = format.split('');

	          regex[index] = '(' + data.regex + ')';
	          format[index] = '$'; // Custom symbol to define consumed part of format
	          for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	            regex[i] = '';
	            format[i] = '$';
	          }
	          format = format.join('');

	          map.push({
	            index: index,
	            key: data.key,
	            apply: data[func],
	            matcher: data.regex });

	        }
	      });

	      return {
	        regex: new RegExp('^' + regex.join('') + '$'),
	        map: orderByFilter(map, 'index') };

	    }

	    this.filter = function (date, format) {
	      if (!angular.isDate(date) || isNaN(date) || !format) {
	        return '';
	      }

	      format = $locale.DATETIME_FORMATS[format] || format;

	      if ($locale.id !== localeId) {
	        this.init();
	      }

	      if (!this.formatters[format]) {
	        this.formatters[format] = createParser(format, 'formatter');
	      }

	      var parser = this.formatters[format],
	      map = parser.map;

	      var _format = format;

	      return map.reduce(function (str, mapper, i) {
	        var match = _format.match(new RegExp('(.*)' + mapper.key));
	        if (match && angular.isString(match[1])) {
	          str += match[1];
	          _format = _format.replace(match[1] + mapper.key, '');
	        }

	        var endStr = i === map.length - 1 ? _format : '';

	        if (mapper.apply) {
	          return str + mapper.apply.call(null, date) + endStr;
	        }

	        return str + endStr;
	      }, '');
	    };

	    this.parse = function (input, format, baseDate) {
	      if (!angular.isString(input) || !format) {
	        return input;
	      }

	      format = $locale.DATETIME_FORMATS[format] || format;
	      format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

	      if ($locale.id !== localeId) {
	        this.init();
	      }

	      if (!this.parsers[format]) {
	        this.parsers[format] = createParser(format, 'apply');
	      }

	      var parser = this.parsers[format],
	      regex = parser.regex,
	      map = parser.map,
	      results = input.match(regex),
	      tzOffset = false;
	      if (results && results.length) {
	        var fields, dt;
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	          fields = {
	            year: baseDate.getFullYear(),
	            month: baseDate.getMonth(),
	            date: baseDate.getDate(),
	            hours: baseDate.getHours(),
	            minutes: baseDate.getMinutes(),
	            seconds: baseDate.getSeconds(),
	            milliseconds: baseDate.getMilliseconds() };

	        } else {
	          if (baseDate) {
	            $log.warn('dateparser:', 'baseDate is not a valid date');
	          }
	          fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	        }

	        for (var i = 1, n = results.length; i < n; i++) {
	          var mapper = map[i - 1];
	          if (mapper.matcher === 'Z') {
	            tzOffset = true;
	          }

	          if (mapper.apply) {
	            mapper.apply.call(fields, results[i]);
	          }
	        }

	        var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
	        Date.prototype.setFullYear;
	        var timesetter = tzOffset ? Date.prototype.setUTCHours :
	        Date.prototype.setHours;

	        if (isValid(fields.year, fields.month, fields.date)) {
	          if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	            dt = new Date(baseDate);
	            datesetter.call(dt, fields.year, fields.month, fields.date);
	            timesetter.call(dt, fields.hours, fields.minutes,
	            fields.seconds, fields.milliseconds);
	          } else {
	            dt = new Date(0);
	            datesetter.call(dt, fields.year, fields.month, fields.date);
	            timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
	            fields.seconds || 0, fields.milliseconds || 0);
	          }
	        }

	        return dt;
	      }
	    };

	    // Check if date is valid for specific month (and year for February).
	    // Month: 0 = Jan, 1 = Feb, etc
	    function isValid(year, month, date) {
	      if (date < 1) {
	        return false;
	      }

	      if (month === 1 && date > 28) {
	        return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	      }

	      if (month === 3 || month === 5 || month === 8 || month === 10) {
	        return date < 31;
	      }

	      return true;
	    }

	    function toInt(str) {
	      return parseInt(str, 10);
	    }

	    this.toTimezone = toTimezone;
	    this.fromTimezone = fromTimezone;
	    this.timezoneToOffset = timezoneToOffset;
	    this.addDateMinutes = addDateMinutes;
	    this.convertTimezoneToLocal = convertTimezoneToLocal;

	    function toTimezone(date, timezone) {
	      return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	    }

	    function fromTimezone(date, timezone) {
	      return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	    }

	    //https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1207
	    function timezoneToOffset(timezone, fallback) {
	      var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	      return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	    }

	    function addDateMinutes(date, minutes) {
	      date = new Date(date.getTime());
	      date.setMinutes(date.getMinutes() + minutes);
	      return date;
	    }

	    function convertTimezoneToLocal(date, timezone, reverse) {
	      reverse = reverse ? -1 : 1;
	      var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
	      return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
	    }
	  }]);

	  // Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	  // at most one element.
	  angular.module('ui.bootstrap.isClass', []).
	  directive('uibIsClass', [
	  '$animate',
	  function ($animate) {
	    //                    11111111          22222222
	    var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	    //                    11111111           22222222
	    var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

	    var dataPerTracked = {};

	    return {
	      restrict: 'A',
	      compile: function compile(tElement, tAttrs) {
	        var linkedScopes = [];
	        var instances = [];
	        var expToData = {};
	        var lastActivated = null;
	        var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	        var onExp = onExpMatches[2];
	        var expsStr = onExpMatches[1];
	        var exps = expsStr.split(',');

	        return linkFn;

	        function linkFn(scope, element, attrs) {
	          linkedScopes.push(scope);
	          instances.push({
	            scope: scope,
	            element: element });


	          exps.forEach(function (exp, k) {
	            addForExp(exp, scope);
	          });

	          scope.$on('$destroy', removeScope);
	        }

	        function addForExp(exp, scope) {
	          var matches = exp.match(IS_REGEXP);
	          var clazz = scope.$eval(matches[1]);
	          var compareWithExp = matches[2];
	          var data = expToData[exp];
	          if (!data) {
	            var watchFn = function watchFn(compareWithVal) {
	              var newActivated = null;
	              instances.some(function (instance) {
	                var thisVal = instance.scope.$eval(onExp);
	                if (thisVal === compareWithVal) {
	                  newActivated = instance;
	                  return true;
	                }
	              });
	              if (data.lastActivated !== newActivated) {
	                if (data.lastActivated) {
	                  $animate.removeClass(data.lastActivated.element, clazz);
	                }
	                if (newActivated) {
	                  $animate.addClass(newActivated.element, clazz);
	                }
	                data.lastActivated = newActivated;
	              }
	            };
	            expToData[exp] = data = {
	              lastActivated: null,
	              scope: scope,
	              watchFn: watchFn,
	              compareWithExp: compareWithExp,
	              watcher: scope.$watch(compareWithExp, watchFn) };

	          }
	          data.watchFn(scope.$eval(compareWithExp));
	        }

	        function removeScope(e) {
	          var removedScope = e.targetScope;
	          var index = linkedScopes.indexOf(removedScope);
	          linkedScopes.splice(index, 1);
	          instances.splice(index, 1);
	          if (linkedScopes.length) {
	            var newWatchScope = linkedScopes[0];
	            angular.forEach(expToData, function (data) {
	              if (data.scope === removedScope) {
	                data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	                data.scope = newWatchScope;
	              }
	            });
	          } else
	          {
	            expToData = {};
	          }
	        }
	      } };

	  }]);
	  angular.module('ui.bootstrap.position', [])

	  /**
	                                               * A set of utility methods for working with the DOM.
	                                               * It is meant to be used where we need to absolute-position elements in
	                                               * relation to another element (this is the case for tooltips, popovers,
	                                               * typeahead suggestions etc.).
	                                               */.
	  factory('$uibPosition', ['$document', '$window', function ($document, $window) {
	    /**
	                                                                                   * Used by scrollbarWidth() function to cache scrollbar's width.
	                                                                                   * Do not access this variable directly, use scrollbarWidth() instead.
	                                                                                   */
	    var SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/ };

	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/ };


	    return {

	      /**
	              * Provides a raw DOM element from a jQuery/jQLite element.
	              *
	              * @param {element} elem - The element to convert.
	              *
	              * @returns {element} A HTML element.
	              */
	      getRawNode: function getRawNode(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },

	      /**
	          * Provides a parsed number for a style property.  Strips
	          * units and casts invalid numbers to 0.
	          *
	          * @param {string} value - The style value to parse.
	          *
	          * @returns {number} A valid number.
	          */
	      parseStyle: function parseStyle(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },

	      /**
	          * Provides the closest positioned ancestor.
	          *
	          * @param {element} element - The element to get the offest parent for.
	          *
	          * @returns {element} The closest positioned ancestor.
	          */
	      offsetParent: function offsetParent(elem) {
	        elem = this.getRawNode(elem);

	        var offsetParent = elem.offsetParent || $document[0].documentElement;

	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }

	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }

	        return offsetParent || $document[0].documentElement;
	      },

	      /**
	          * Provides the scrollbar width, concept from TWBS measureScrollbar()
	          * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	          *
	          * @returns {number} The width of the browser scollbar.
	          */
	      scrollbarWidth: function scrollbarWidth() {
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }

	        return SCROLLBAR_WIDTH;
	      },

	      /**
	          * Checks to see if the element is scrollable.
	          *
	          * @param {element} elem - The element to check.
	          * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	          *   default is false.
	          *
	          * @returns {boolean} Whether the element is scrollable.
	          */
	      isScrollable: function isScrollable(elem, includeHidden) {
	        elem = this.getRawNode(elem);

	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },

	      /**
	          * Provides the closest scrollable ancestor.
	          * A port of the jQuery UI scrollParent method:
	          * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	          *
	          * @param {element} elem - The element to find the scroll parent of.
	          * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	          *   default is false.
	          *
	          * @returns {element} A HTML element.
	          */
	      scrollParent: function scrollParent(elem, includeHidden) {
	        elem = this.getRawNode(elem);

	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;

	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }

	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }

	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }

	        return scrollParent;
	      },

	      /**
	          * Provides read-only equivalent of jQuery's position function:
	          * http://api.jquery.com/position/ - distance to closest positioned
	          * ancestor.  Does not account for margins by default like jQuery position.
	          *
	          * @param {element} elem - The element to caclulate the position on.
	          * @param {boolean=} [includeMargins=false] - Should margins be accounted
	          * for, default is false.
	          *
	          * @returns {object} An object with the following properties:
	          *   <ul>
	          *     <li>**width**: the width of the element</li>
	          *     <li>**height**: the height of the element</li>
	          *     <li>**top**: distance to top edge of offset parent</li>
	          *     <li>**left**: distance to left edge of offset parent</li>
	          *   </ul>
	          */
	      position: function position(elem, includeMagins) {
	        elem = this.getRawNode(elem);

	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = { top: 0, left: 0 };

	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }

	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left) };

	      },

	      /**
	          * Provides read-only equivalent of jQuery's offset function:
	          * http://api.jquery.com/offset/ - distance to viewport.  Does
	          * not account for borders, margins, or padding on the body
	          * element.
	          *
	          * @param {element} elem - The element to calculate the offset on.
	          *
	          * @returns {object} An object with the following properties:
	          *   <ul>
	          *     <li>**width**: the width of the element</li>
	          *     <li>**height**: the height of the element</li>
	          *     <li>**top**: distance to top edge of viewport</li>
	          *     <li>**right**: distance to bottom edge of viewport</li>
	          *   </ul>
	          */
	      offset: function offset(elem) {
	        elem = this.getRawNode(elem);

	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)) };

	      },

	      /**
	          * Provides offset distance to the closest scrollable ancestor
	          * or viewport.  Accounts for border and scrollbar width.
	          *
	          * Right and bottom dimensions represent the distance to the
	          * respective edge of the viewport element.  If the element
	          * edge extends beyond the viewport, a negative value will be
	          * reported.
	          *
	          * @param {element} elem - The element to get the viewport offset for.
	          * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	          * of the first scrollable element, default is false.
	          * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	          * be accounted for, default is true.
	          *
	          * @returns {object} An object with the following properties:
	          *   <ul>
	          *     <li>**top**: distance to the top content edge of viewport element</li>
	          *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	          *     <li>**left**: distance to the left content edge of viewport element</li>
	          *     <li>**right**: distance to the right content edge of viewport element</li>
	          *   </ul>
	          */
	      viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;

	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };

	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();

	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }

	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right) };

	      },

	      /**
	          * Provides an array of placement values parsed from a placement string.
	          * Along with the 'auto' indicator, supported placement strings are:
	          *   <ul>
	          *     <li>top: element on top, horizontally centered on host element.</li>
	          *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	          *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	          *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	          *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	          *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	          *     <li>left: element on left, vertically centered on host element.</li>
	          *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	          *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	          *     <li>right: element on right, vertically centered on host element.</li>
	          *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	          *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	          *   </ul>
	          * A placement string with an 'auto' indicator is expected to be
	          * space separated from the placement, i.e: 'auto bottom-left'  If
	          * the primary and secondary placement values do not match 'top,
	          * bottom, left, right' then 'top' will be the primary placement and
	          * 'center' will be the secondary placement.  If 'auto' is passed, true
	          * will be returned as the 3rd value of the array.
	          *
	          * @param {string} placement - The placement string to parse.
	          *
	          * @returns {array} An array with the following values
	          * <ul>
	          *   <li>**[0]**: The primary placement.</li>
	          *   <li>**[1]**: The secondary placement.</li>
	          *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	          * </ul>
	          */
	      parsePlacement: function parsePlacement(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }

	        placement = placement.split('-');

	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }

	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }

	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }

	        return placement;
	      },

	      /**
	          * Provides coordinates for an element to be positioned relative to
	          * another element.  Passing 'auto' as part of the placement parameter
	          * will enable smart placement - where the element fits. i.e:
	          * 'auto left-top' will check to see if there is enough space to the left
	          * of the hostElem to fit the targetElem, if not place right (same for secondary
	          * top placement).  Available space is calculated using the viewportOffset
	          * function.
	          *
	          * @param {element} hostElem - The element to position against.
	          * @param {element} targetElem - The element to position.
	          * @param {string=} [placement=top] - The placement for the targetElem,
	          *   default is 'top'. 'center' is assumed as secondary placement for
	          *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	          *   <ul>
	          *     <li>top</li>
	          *     <li>top-right</li>
	          *     <li>top-left</li>
	          *     <li>bottom</li>
	          *     <li>bottom-left</li>
	          *     <li>bottom-right</li>
	          *     <li>left</li>
	          *     <li>left-top</li>
	          *     <li>left-bottom</li>
	          *     <li>right</li>
	          *     <li>right-top</li>
	          *     <li>right-bottom</li>
	          *   </ul>
	          * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	          *   be calculated from the body element, default is false.
	          *
	          * @returns {object} An object with the following properties:
	          *   <ul>
	          *     <li>**top**: Value for targetElem top.</li>
	          *     <li>**left**: Value for targetElem left.</li>
	          *     <li>**placement**: The resolved placement.</li>
	          *   </ul>
	          */
	      positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);

	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

	        placement = this.parsePlacement(placement);

	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = { top: 0, left: 0, placement: '' };

	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem);

	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom))) };


	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	          placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	          placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	          placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	          placement[0];

	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	          placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	          placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	          placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	          placement[1];

	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }

	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;}


	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;}


	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

	        return targetElemPos;
	      },

	      /**
	         * Provides a way for positioning tooltip & dropdown
	         * arrows when using placement options beyond the standard
	         * left, right, top, or bottom.
	         *
	         * @param {element} elem - The tooltip/dropdown element.
	         * @param {string} placement - The placement for the elem.
	         */
	      positionArrow: function positionArrow(elem, placement) {
	        elem = this.getRawNode(elem);

	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }

	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }

	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: '' };


	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }

	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;}


	        arrowCss[placement[1]] = borderRadius;

	        angular.element(arrowElem).css(arrowCss);
	      } };

	  }]);

	  angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass', 'ui.bootstrap.position']).

	  value('$datepickerSuppressError', false).
	  value('uibDatepickerAttributeWarning', true).

	  constant('uibDatepickerConfig', {
	    datepickerMode: 'day',
	    formatDay: 'dd',
	    formatMonth: 'MMMM',
	    formatYear: 'yyyy',
	    formatDayHeader: 'EEE',
	    formatDayTitle: 'MMMM yyyy',
	    formatMonthTitle: 'yyyy',
	    maxDate: null,
	    maxMode: 'year',
	    minDate: null,
	    minMode: 'day',
	    ngModelOptions: {},
	    shortcutPropagation: false,
	    showWeeks: true,
	    yearColumns: 5,
	    yearRows: 4 }).


	  controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', 'uibDatepickerAttributeWarning', 'uibDateParser',
	  function ($scope, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerSuppressError, datepickerAttributeWarning, dateParser) {
	    var self = this,
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
	    ngModelOptions = {},
	    watchListeners = [],
	    optionsUsed = !!$attrs.datepickerOptions;

	    // Modes chain
	    this.modes = ['day', 'month', 'year'];

	    if (optionsUsed) {
	      [
	      'customClass',
	      'dateDisabled',
	      'datepickerMode',
	      'formatDay',
	      'formatDayHeader',
	      'formatDayTitle',
	      'formatMonth',
	      'formatMonthTitle',
	      'formatYear',
	      'initDate',
	      'maxDate',
	      'maxMode',
	      'minDate',
	      'minMode',
	      'showWeeks',
	      'shortcutPropagation',
	      'startingDay',
	      'yearColumns',
	      'yearRows'].
	      forEach(function (key) {
	        switch (key) {
	          case 'customClass':
	          case 'dateDisabled':
	            $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	            break;
	          case 'datepickerMode':
	            $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
	            $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	            break;
	          case 'formatDay':
	          case 'formatDayHeader':
	          case 'formatDayTitle':
	          case 'formatMonth':
	          case 'formatMonthTitle':
	          case 'formatYear':
	            self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	            $interpolate($scope.datepickerOptions[key])($scope.$parent) :
	            datepickerConfig[key];
	            break;
	          case 'showWeeks':
	          case 'shortcutPropagation':
	          case 'yearColumns':
	          case 'yearRows':
	            self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	            $scope.datepickerOptions[key] : datepickerConfig[key];
	            break;
	          case 'startingDay':
	            if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	              self.startingDay = $scope.datepickerOptions.startingDay;
	            } else if (angular.isNumber(datepickerConfig.startingDay)) {
	              self.startingDay = datepickerConfig.startingDay;
	            } else {
	              self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	            }

	            break;
	          case 'maxDate':
	          case 'minDate':
	            if ($scope.datepickerOptions[key]) {
	              $scope.$watch(function () {return $scope.datepickerOptions[key];}, function (value) {
	                if (value) {
	                  if (angular.isDate(value)) {
	                    self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
	                  } else {
	                    self[key] = new Date(dateFilter(value, 'medium'));
	                  }
	                } else {
	                  self[key] = null;
	                }

	                self.refreshView();
	              });
	            } else {
	              self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
	            }

	            break;
	          case 'maxMode':
	          case 'minMode':
	            if ($scope.datepickerOptions[key]) {
	              $scope.$watch(function () {return $scope.datepickerOptions[key];}, function (value) {
	                self[key] = $scope[key] = angular.isDefined(value) ? value : datepickerOptions[key];
	                if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
	                key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	                  $scope.datepickerMode = self[key];
	                  $scope.datepickerOptions.datepickerMode = self[key];
	                }
	              });
	            } else {
	              self[key] = $scope[key] = datepickerConfig[key] || null;
	            }

	            break;
	          case 'initDate':
	            if ($scope.datepickerOptions.initDate) {
	              self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();
	              $scope.$watch(function () {return $scope.datepickerOptions.initDate;}, function (initDate) {
	                if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	                  self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
	                  self.refreshView();
	                }
	              });
	            } else {
	              self.activeDate = new Date();
	            }}

	      });
	    } else {
	      // Interpolated configuration attributes
	      angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle'], function (key) {
	        self[key] = angular.isDefined($attrs[key]) ? $interpolate($attrs[key])($scope.$parent) : datepickerConfig[key];

	        if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
	          $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	        }
	      });

	      // Evaled configuration attributes
	      angular.forEach(['showWeeks', 'yearRows', 'yearColumns', 'shortcutPropagation'], function (key) {
	        self[key] = angular.isDefined($attrs[key]) ?
	        $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];

	        if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
	          $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	        }
	      });

	      angular.forEach(['dateDisabled', 'customClass'], function (key) {
	        if (angular.isDefined($attrs[key]) && datepickerAttributeWarning) {
	          $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	        }
	      });

	      if (angular.isDefined($attrs.startingDay)) {
	        if (datepickerAttributeWarning) {
	          $log.warn('uib-datepicker startingDay attribute usage is deprecated, use datepicker-options attribute instead');
	        }

	        self.startingDay = $scope.$parent.$eval($attrs.startingDay);
	      } else if (angular.isNumber(datepickerConfig.startingDay)) {
	        self.startingDay = datepickerConfig.startingDay;
	      } else {
	        self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	      }

	      // Watchable date attributes
	      angular.forEach(['minDate', 'maxDate'], function (key) {
	        if ($attrs[key]) {
	          if (datepickerAttributeWarning) {
	            $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	          }

	          watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
	            if (value) {
	              if (angular.isDate(value)) {
	                self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
	              } else {
	                self[key] = new Date(dateFilter(value, 'medium'));
	              }
	            } else {
	              self[key] = null;
	            }

	            self.refreshView();
	          }));
	        } else {
	          self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
	        }
	      });

	      angular.forEach(['minMode', 'maxMode'], function (key) {
	        if ($attrs[key]) {
	          if (datepickerAttributeWarning) {
	            $log.warn('uib-datepicker ' + key + ' attribute usage is deprecated, use datepicker-options attribute instead');
	          }

	          watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $attrs[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) ||
	            key === 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	            }
	          }));
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	      });

	      if (angular.isDefined($attrs.initDate)) {
	        if (datepickerAttributeWarning) {
	          $log.warn('uib-datepicker initDate attribute usage is deprecated, use datepicker-options attribute instead');
	        }

	        var initDate = dateParser.fromTimezone($scope.$parent.$eval($attrs.initDate), ngModelOptions.timezone);
	        this.activeDate = !isNaN(initDate) ? initDate : new Date();
	        watchListeners.push($scope.$parent.$watch($attrs.initDate, function (initDate) {
	          if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	            initDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
	            self.activeDate = !isNaN(initDate) ? initDate : new Date();
	            self.refreshView();
	          }
	        }));
	      } else {
	        this.activeDate = new Date();
	      }

	      if ($attrs.datepickerMode && datepickerAttributeWarning) {
	        $log.warn('uib-datepicker datepickerMode attribute usage is deprecated, use datepicker-options attribute instead');
	      }

	      $scope.datepickerMode = $scope.datepickerMode ||
	      datepickerConfig.datepickerMode;
	    }

	    $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

	    $scope.disabled = angular.isDefined($attrs.disabled) || false;
	    if (angular.isDefined($attrs.ngDisabled)) {
	      watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
	        $scope.disabled = disabled;
	        self.refreshView();
	      }));
	    }

	    $scope.isActive = function (dateObject) {
	      if (self.compare(dateObject.date, self.activeDate) === 0) {
	        $scope.activeDateId = dateObject.uid;
	        return true;
	      }
	      return false;
	    };

	    this.init = function (ngModelCtrl_) {
	      ngModelCtrl = ngModelCtrl_;
	      ngModelOptions = ngModelCtrl_.$options || datepickerConfig.ngModelOptions;

	      this.activeDate = ngModelCtrl.$modelValue || new Date();

	      ngModelCtrl.$render = function () {
	        self.render();
	      };
	    };

	    this.render = function () {
	      if (ngModelCtrl.$viewValue) {
	        var date = new Date(ngModelCtrl.$viewValue),
	        isValid = !isNaN(date);

	        if (isValid) {
	          this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);
	        } else if (!$datepickerSuppressError) {
	          $log.error('Datepicker directive: "ng-model" value must be a Date object');
	        }
	      }
	      this.refreshView();
	    };

	    this.refreshView = function () {
	      if (this.element) {
	        $scope.selectedDt = null;
	        this._refreshView();
	        if ($scope.activeDt) {
	          $scope.activeDateId = $scope.activeDt.uid;
	        }

	        var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	        date = dateParser.fromTimezone(date, ngModelOptions.timezone);
	        ngModelCtrl.$setValidity('dateDisabled', !date ||
	        this.element && !this.isDisabled(date));
	      }
	    };

	    this.createDateObject = function (date, format) {
	      var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      model = dateParser.fromTimezone(model, ngModelOptions.timezone);
	      var dt = {
	        date: date,
	        label: dateParser.filter(date, format),
	        selected: model && this.compare(date, model) === 0,
	        disabled: this.isDisabled(date),
	        current: this.compare(date, new Date()) === 0,
	        customClass: this.customClass(date) || null };


	      if (model && this.compare(date, model) === 0) {
	        $scope.selectedDt = dt;
	      }

	      if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	        $scope.activeDt = dt;
	      }

	      return dt;
	    };

	    this.isDisabled = function (date) {
	      return $scope.disabled ||
	      this.minDate && this.compare(date, this.minDate) < 0 ||
	      this.maxDate && this.compare(date, this.maxDate) > 0 ||
	      $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
	    };

	    this.customClass = function (date) {
	      return $scope.customClass({ date: date, mode: $scope.datepickerMode });
	    };

	    // Split array into smaller arrays
	    this.split = function (arr, size) {
	      var arrays = [];
	      while (arr.length > 0) {
	        arrays.push(arr.splice(0, size));
	      }
	      return arrays;
	    };

	    $scope.select = function (date) {
	      if ($scope.datepickerMode === self.minMode) {
	        var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
	        dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	        dt = dateParser.toTimezone(dt, ngModelOptions.timezone);
	        ngModelCtrl.$setViewValue(dt);
	        ngModelCtrl.$render();
	      } else {
	        self.activeDate = date;
	        setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

	        $scope.$emit('uib:datepicker.mode');
	      }
	    };

	    $scope.move = function (direction) {
	      var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	      month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	      self.activeDate.setFullYear(year, month, 1);
	      self.refreshView();
	    };

	    $scope.toggleMode = function (direction) {
	      direction = direction || 1;

	      if ($scope.datepickerMode === self.maxMode && direction === 1 ||
	      $scope.datepickerMode === self.minMode && direction === -1) {
	        return;
	      }

	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

	      $scope.$emit('uib:datepicker.mode');
	    };

	    // Key event mapper
	    $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

	    var focusElement = function focusElement() {
	      self.element[0].focus();
	    };

	    // Listen for focus requests from popup directive
	    $scope.$on('uib:datepicker.focus', focusElement);

	    $scope.keydown = function (evt) {
	      var key = $scope.keys[evt.which];

	      if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	        return;
	      }

	      evt.preventDefault();
	      if (!self.shortcutPropagation) {
	        evt.stopPropagation();
	      }

	      if (key === 'enter' || key === 'space') {
	        if (self.isDisabled(self.activeDate)) {
	          return; // do nothing
	        }
	        $scope.select(self.activeDate);
	      } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	        $scope.toggleMode(key === 'up' ? 1 : -1);
	      } else {
	        self.handleKeyDown(key, evt);
	        self.refreshView();
	      }
	    };

	    $scope.$on("$destroy", function () {
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });

	    function setMode(mode) {
	      $scope.datepickerMode = mode;
	      if (optionsUsed) {
	        $scope.datepickerOptions.datepickerMode = mode;
	      }
	    }
	  }]).

	  controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	    var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	    this.step = { months: 1 };
	    this.element = $element;
	    function getDaysInMonth(year, month) {
	      return month === 1 && year % 4 === 0 && (
	      year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	    }

	    this.init = function (ctrl) {
	      angular.extend(ctrl, this);
	      scope.showWeeks = ctrl.showWeeks;
	      ctrl.refreshView();
	    };

	    this.getDates = function (startDate, n) {
	      var dates = new Array(n),current = new Date(startDate),i = 0,date;
	      while (i < n) {
	        date = new Date(current);
	        dates[i++] = date;
	        current.setDate(current.getDate() + 1);
	      }
	      return dates;
	    };

	    this._refreshView = function () {
	      var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);

	      firstDayOfMonth.setFullYear(year, month, 1);

	      var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = difference > 0 ?
	      7 - difference : -difference,
	      firstDate = new Date(firstDayOfMonth);

	      if (numDisplayedFromPreviousMonth > 0) {
	        firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	      }

	      // 42 is the number of days on a six-week calendar
	      var days = this.getDates(firstDate, 42);
	      for (var i = 0; i < 42; i++) {
	        days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	          secondary: days[i].getMonth() !== month,
	          uid: scope.uniqueId + '-' + i });

	      }

	      scope.labels = new Array(7);
	      for (var j = 0; j < 7; j++) {
	        scope.labels[j] = {
	          abbr: dateFilter(days[j].date, this.formatDayHeader),
	          full: dateFilter(days[j].date, 'EEEE') };

	      }

	      scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	      scope.rows = this.split(days, 7);

	      if (scope.showWeeks) {
	        scope.weekNumbers = [];
	        var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	        numWeeks = scope.rows.length;
	        for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	          scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	        }
	      }
	    };

	    this.compare = function (date1, date2) {
	      var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	      var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	      _date1.setFullYear(date1.getFullYear());
	      _date2.setFullYear(date2.getFullYear());
	      return _date1 - _date2;
	    };

	    function getISO8601WeekNumber(date) {
	      var checkDate = new Date(date);
	      checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	      var time = checkDate.getTime();
	      checkDate.setMonth(0); // Compare with Jan 1
	      checkDate.setDate(1);
	      return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	    }

	    this.handleKeyDown = function (key, evt) {
	      var date = this.activeDate.getDate();

	      if (key === 'left') {
	        date = date - 1;
	      } else if (key === 'up') {
	        date = date - 7;
	      } else if (key === 'right') {
	        date = date + 1;
	      } else if (key === 'down') {
	        date = date + 7;
	      } else if (key === 'pageup' || key === 'pagedown') {
	        var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
	        this.activeDate.setMonth(month, 1);
	        date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	      } else if (key === 'home') {
	        date = 1;
	      } else if (key === 'end') {
	        date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	      }
	      this.activeDate.setDate(date);
	    };
	  }]).

	  controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	    this.step = { years: 1 };
	    this.element = $element;

	    this.init = function (ctrl) {
	      angular.extend(ctrl, this);
	      ctrl.refreshView();
	    };

	    this._refreshView = function () {
	      var months = new Array(12),
	      year = this.activeDate.getFullYear(),
	      date;

	      for (var i = 0; i < 12; i++) {
	        date = new Date(this.activeDate);
	        date.setFullYear(year, i, 1);
	        months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	          uid: scope.uniqueId + '-' + i });

	      }

	      scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	      scope.rows = this.split(months, 3);
	    };

	    this.compare = function (date1, date2) {
	      var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	      var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	      _date1.setFullYear(date1.getFullYear());
	      _date2.setFullYear(date2.getFullYear());
	      return _date1 - _date2;
	    };

	    this.handleKeyDown = function (key, evt) {
	      var date = this.activeDate.getMonth();

	      if (key === 'left') {
	        date = date - 1;
	      } else if (key === 'up') {
	        date = date - 3;
	      } else if (key === 'right') {
	        date = date + 1;
	      } else if (key === 'down') {
	        date = date + 3;
	      } else if (key === 'pageup' || key === 'pagedown') {
	        var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
	        this.activeDate.setFullYear(year);
	      } else if (key === 'home') {
	        date = 0;
	      } else if (key === 'end') {
	        date = 11;
	      }
	      this.activeDate.setMonth(date);
	    };
	  }]).

	  controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	    var columns, range;
	    this.element = $element;

	    function getStartingYear(year) {
	      return parseInt((year - 1) / range, 10) * range + 1;
	    }

	    this.yearpickerInit = function () {
	      columns = this.yearColumns;
	      range = this.yearRows * columns;
	      this.step = { years: range };
	    };

	    this._refreshView = function () {
	      var years = new Array(range),date;

	      for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	        date = new Date(this.activeDate);
	        date.setFullYear(start + i, 0, 1);
	        years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	          uid: scope.uniqueId + '-' + i });

	      }

	      scope.title = [years[0].label, years[range - 1].label].join(' - ');
	      scope.rows = this.split(years, columns);
	      scope.columns = columns;
	    };

	    this.compare = function (date1, date2) {
	      return date1.getFullYear() - date2.getFullYear();
	    };

	    this.handleKeyDown = function (key, evt) {
	      var date = this.activeDate.getFullYear();

	      if (key === 'left') {
	        date = date - 1;
	      } else if (key === 'up') {
	        date = date - columns;
	      } else if (key === 'right') {
	        date = date + 1;
	      } else if (key === 'down') {
	        date = date + columns;
	      } else if (key === 'pageup' || key === 'pagedown') {
	        date += (key === 'pageup' ? -1 : 1) * range;
	      } else if (key === 'home') {
	        date = getStartingYear(this.activeDate.getFullYear());
	      } else if (key === 'end') {
	        date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	      }
	      this.activeDate.setFullYear(date);
	    };
	  }]).

	  directive('uibDatepicker', function () {
	    return {
	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	      },
	      scope: {
	        datepickerMode: '=?',
	        datepickerOptions: '=?',
	        dateDisabled: '&',
	        customClass: '&',
	        shortcutPropagation: '&?' },

	      require: ['uibDatepicker', '^ngModel'],
	      controller: 'UibDatepickerController',
	      controllerAs: 'datepicker',
	      link: function link(scope, element, attrs, ctrls) {
	        var datepickerCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	        datepickerCtrl.init(ngModelCtrl);
	      } };

	  }).

	  directive('uibDaypicker', function () {
	    return {
	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/datepicker/day.html';
	      },
	      require: ['^uibDatepicker', 'uibDaypicker'],
	      controller: 'UibDaypickerController',
	      link: function link(scope, element, attrs, ctrls) {
	        var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];

	        daypickerCtrl.init(datepickerCtrl);
	      } };

	  }).

	  directive('uibMonthpicker', function () {
	    return {
	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/datepicker/month.html';
	      },
	      require: ['^uibDatepicker', 'uibMonthpicker'],
	      controller: 'UibMonthpickerController',
	      link: function link(scope, element, attrs, ctrls) {
	        var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];

	        monthpickerCtrl.init(datepickerCtrl);
	      } };

	  }).

	  directive('uibYearpicker', function () {
	    return {
	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/datepicker/year.html';
	      },
	      require: ['^uibDatepicker', 'uibYearpicker'],
	      controller: 'UibYearpickerController',
	      link: function link(scope, element, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        angular.extend(ctrl, ctrls[1]);
	        ctrl.yearpickerInit();

	        ctrl.refreshView();
	      } };

	  }).

	  value('uibDatepickerPopupAttributeWarning', true).

	  constant('uibDatepickerPopupConfig', {
	    altInputFormats: [],
	    appendToBody: false,
	    clearText: 'Clear',
	    closeOnDateSelection: true,
	    closeText: 'Done',
	    currentText: 'Today',
	    datepickerPopup: 'yyyy-MM-dd',
	    datepickerPopupTemplateUrl: 'uib/template/datepicker/popup.html',
	    datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	    html5Types: {
	      date: 'yyyy-MM-dd',
	      'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	      'month': 'yyyy-MM' },

	    onOpenFocus: true,
	    showButtonBar: true,
	    placement: 'auto bottom-left' }).


	  controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', 'uibDatepickerPopupAttributeWarning',
	  function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, datepickerPopupAttributeWarning) {
	    var cache = {},
	    isHtml5DateInput = false;
	    var dateFormat,closeOnDateSelection,appendToBody,onOpenFocus,
	    datepickerPopupTemplateUrl,datepickerTemplateUrl,popupEl,datepickerEl,scrollParentEl,
	    ngModel,ngModelOptions,$popup,altInputFormats,watchListeners = [];

	    $scope.watchData = {};

	    this.init = function (_ngModel_) {
	      ngModel = _ngModel_;
	      ngModelOptions = _ngModel_.$options || datepickerConfig.ngModelOptions;
	      closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
	      $scope.$parent.$eval($attrs.closeOnDateSelection) :
	      datepickerPopupConfig.closeOnDateSelection;
	      appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
	      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
	      datepickerPopupConfig.appendToBody;
	      onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
	      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	      datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
	      $attrs.datepickerPopupTemplateUrl :
	      datepickerPopupConfig.datepickerPopupTemplateUrl;
	      datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
	      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	      altInputFormats = angular.isDefined($attrs.altInputFormats) ?
	      $scope.$parent.$eval($attrs.altInputFormats) :
	      datepickerPopupConfig.altInputFormats;

	      $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
	      $scope.$parent.$eval($attrs.showButtonBar) :
	      datepickerPopupConfig.showButtonBar;

	      if (datepickerPopupConfig.html5Types[$attrs.type]) {
	        dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	        isHtml5DateInput = true;
	      } else {
	        dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	        $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
	          var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	          // Invalidate the $modelValue to ensure that formatters re-run
	          // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	          if (newDateFormat !== dateFormat) {
	            dateFormat = newDateFormat;
	            ngModel.$modelValue = null;

	            if (!dateFormat) {
	              throw new Error('uibDatepickerPopup must have a date format specified.');
	            }
	          }
	        });
	      }

	      if (!dateFormat) {
	        throw new Error('uibDatepickerPopup must have a date format specified.');
	      }

	      if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	        throw new Error('HTML5 date input types do not support custom formats.');
	      }

	      // popup element used to display calendar
	      popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	      $scope.ngModelOptions = angular.copy(ngModelOptions);
	      $scope.ngModelOptions.timezone = null;
	      if ($scope.ngModelOptions.updateOnDefault === true) {
	        $scope.ngModelOptions.updateOn = $scope.ngModelOptions.updateOn ?
	        $scope.ngModelOptions.updateOn + ' default' : 'default';
	      }

	      popupEl.attr({
	        'ng-model': 'date',
	        'ng-model-options': 'ngModelOptions',
	        'ng-change': 'dateSelection(date)',
	        'template-url': datepickerPopupTemplateUrl });


	      // datepicker element
	      datepickerEl = angular.element(popupEl.children()[0]);
	      datepickerEl.attr('template-url', datepickerTemplateUrl);

	      if (isHtml5DateInput) {
	        if ($attrs.type === 'month') {
	          datepickerEl.attr('datepicker-mode', '"month"');
	          datepickerEl.attr('min-mode', 'month');
	        }
	      }

	      if ($scope.datepickerOptions) {
	        datepickerEl.attr('datepicker-options', 'datepickerOptions');
	      }

	      angular.forEach(['minMode', 'maxMode', 'datepickerMode', 'shortcutPropagation'], function (key) {
	        if ($attrs[key]) {
	          if (datepickerPopupAttributeWarning) {
	            $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	          }

	          var getAttribute = $parse($attrs[key]);
	          var propConfig = {
	            get: function get() {
	              return getAttribute($scope.$parent);
	            } };


	          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

	          // Propagate changes from datepicker to outside
	          if (key === 'datepickerMode') {
	            var setAttribute = getAttribute.assign;
	            propConfig.set = function (v) {
	              setAttribute($scope.$parent, v);
	            };
	          }

	          Object.defineProperty($scope.watchData, key, propConfig);
	        }
	      });

	      angular.forEach(['minDate', 'maxDate', 'initDate'], function (key) {
	        if ($attrs[key]) {
	          if (datepickerPopupAttributeWarning) {
	            $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	          }

	          var getAttribute = $parse($attrs[key]);

	          watchListeners.push($scope.$parent.$watch(getAttribute, function (value) {
	            if (key === 'minDate' || key === 'maxDate') {
	              if (value === null) {
	                cache[key] = null;
	              } else if (angular.isDate(value)) {
	                cache[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
	              } else {
	                cache[key] = new Date(dateFilter(value, 'medium'));
	              }

	              $scope.watchData[key] = value === null ? null : cache[key];
	            } else {
	              var date = value ? new Date(value) : new Date();
	              $scope.watchData[key] = dateParser.fromTimezone(date, ngModelOptions.timezone);
	            }
	          }));

	          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	        }
	      });

	      if ($attrs.dateDisabled) {
	        if (datepickerPopupAttributeWarning) {
	          $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	        }

	        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	      }

	      angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle', 'showWeeks', 'startingDay', 'yearRows', 'yearColumns'], function (key) {
	        if (angular.isDefined($attrs[key])) {
	          if (datepickerPopupAttributeWarning) {
	            $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	          }

	          datepickerEl.attr(cameltoDash(key), $attrs[key]);
	        }
	      });

	      if ($attrs.customClass) {
	        if (datepickerPopupAttributeWarning) {
	          $log.warn('uib-datepicker settings via uib-datepicker-popup attributes are deprecated and will be removed in UI Bootstrap 1.3, use datepicker-options attribute instead');
	        }

	        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
	      }

	      if (!isHtml5DateInput) {
	        // Internal API to maintain the correct ng-invalid-[key] class
	        ngModel.$$parserName = 'date';
	        ngModel.$validators.date = validator;
	        ngModel.$parsers.unshift(parseDate);
	        ngModel.$formatters.push(function (value) {
	          if (ngModel.$isEmpty(value)) {
	            $scope.date = value;
	            return value;
	          }

	          $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);

	          if (angular.isNumber($scope.date)) {
	            $scope.date = new Date($scope.date);
	          }

	          return dateParser.filter($scope.date, dateFormat);
	        });
	      } else {
	        ngModel.$formatters.push(function (value) {
	          $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
	          return value;
	        });
	      }

	      // Detect changes in the view from the text box
	      ngModel.$viewChangeListeners.push(function () {
	        $scope.date = parseDateString(ngModel.$viewValue);
	      });

	      $element.on('keydown', inputKeydownBind);

	      $popup = $compile(popupEl)($scope);
	      // Prevent jQuery cache memory leak (template is now redundant after linking)
	      popupEl.remove();

	      if (appendToBody) {
	        $document.find('body').append($popup);
	      } else {
	        $element.after($popup);
	      }

	      $scope.$on('$destroy', function () {
	        if ($scope.isOpen === true) {
	          if (!$rootScope.$$phase) {
	            $scope.$apply(function () {
	              $scope.isOpen = false;
	            });
	          }
	        }

	        $popup.remove();
	        $element.off('keydown', inputKeydownBind);
	        $document.off('click', documentClickBind);
	        if (scrollParentEl) {
	          scrollParentEl.off('scroll', positionPopup);
	        }
	        angular.element($window).off('resize', positionPopup);

	        //Clear all watch listeners on destroy
	        while (watchListeners.length) {
	          watchListeners.shift()();
	        }
	      });
	    };

	    $scope.getText = function (key) {
	      return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	    };

	    $scope.isDisabled = function (date) {
	      if (date === 'today') {
	        date = new Date();
	      }

	      return $scope.watchData.minDate && $scope.compare(date, cache.minDate) < 0 ||
	      $scope.watchData.maxDate && $scope.compare(date, cache.maxDate) > 0;
	    };

	    $scope.compare = function (date1, date2) {
	      return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    };

	    // Inner change
	    $scope.dateSelection = function (dt) {
	      if (angular.isDefined(dt)) {
	        $scope.date = dt;
	      }
	      var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	      $element.val(date);
	      ngModel.$setViewValue(date);

	      if (closeOnDateSelection) {
	        $scope.isOpen = false;
	        $element[0].focus();
	      }
	    };

	    $scope.keydown = function (evt) {
	      if (evt.which === 27) {
	        evt.stopPropagation();
	        $scope.isOpen = false;
	        $element[0].focus();
	      }
	    };

	    $scope.select = function (date, evt) {
	      evt.stopPropagation();

	      if (date === 'today') {
	        var today = new Date();
	        if (angular.isDate($scope.date)) {
	          date = new Date($scope.date);
	          date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	        } else {
	          date = new Date(today.setHours(0, 0, 0, 0));
	        }
	      }
	      $scope.dateSelection(date);
	    };

	    $scope.close = function (evt) {
	      evt.stopPropagation();

	      $scope.isOpen = false;
	      $element[0].focus();
	    };

	    $scope.disabled = angular.isDefined($attrs.disabled) || false;
	    if ($attrs.ngDisabled) {
	      watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
	        $scope.disabled = disabled;
	      }));
	    }

	    $scope.$watch('isOpen', function (value) {
	      if (value) {
	        if (!$scope.disabled) {
	          $timeout(function () {
	            positionPopup();

	            if (onOpenFocus) {
	              $scope.$broadcast('uib:datepicker.focus');
	            }
	            $document.on('click', documentClickBind);

	            var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	            if (appendToBody || $position.parsePlacement(placement)[2]) {
	              scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	              if (scrollParentEl) {
	                scrollParentEl.on('scroll', positionPopup);
	              }
	            } else {
	              scrollParentEl = null;
	            }

	            angular.element($window).on('resize', positionPopup);
	          }, 0, false);
	        } else {
	          $scope.isOpen = false;
	        }
	      } else {
	        $document.off('click', documentClickBind);
	        if (scrollParentEl) {
	          scrollParentEl.off('scroll', positionPopup);
	        }
	        angular.element($window).off('resize', positionPopup);
	      }
	    });

	    function cameltoDash(string) {
	      return string.replace(/([A-Z])/g, function ($1) {return '-' + $1.toLowerCase();});
	    }

	    function parseDateString(viewValue) {
	      var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	      if (isNaN(date)) {
	        for (var i = 0; i < altInputFormats.length; i++) {
	          date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	          if (!isNaN(date)) {
	            return date;
	          }
	        }
	      }
	      return date;
	    }

	    function parseDate(viewValue) {
	      if (angular.isNumber(viewValue)) {
	        // presumably timestamp to date object
	        viewValue = new Date(viewValue);
	      }

	      if (!viewValue) {
	        return null;
	      }

	      if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	        return viewValue;
	      }

	      if (angular.isString(viewValue)) {
	        var date = parseDateString(viewValue);
	        if (!isNaN(date)) {
	          return dateParser.toTimezone(date, ngModelOptions.timezone);
	        }
	      }

	      return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;
	    }

	    function validator(modelValue, viewValue) {
	      var value = modelValue || viewValue;

	      if (!$attrs.ngRequired && !value) {
	        return true;
	      }

	      if (angular.isNumber(value)) {
	        value = new Date(value);
	      }

	      if (!value) {
	        return true;
	      }

	      if (angular.isDate(value) && !isNaN(value)) {
	        return true;
	      }

	      if (angular.isString(value)) {
	        return !isNaN(parseDateString(viewValue));
	      }

	      return false;
	    }

	    function documentClickBind(event) {
	      if (!$scope.isOpen && $scope.disabled) {
	        return;
	      }

	      var popup = $popup[0];
	      var dpContainsTarget = $element[0].contains(event.target);
	      // The popup node may not be an element node
	      // In some browsers (IE) only element nodes have the 'contains' function
	      var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	      if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	        $scope.$apply(function () {
	          $scope.isOpen = false;
	        });
	      }
	    }

	    function inputKeydownBind(evt) {
	      if (evt.which === 27 && $scope.isOpen) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        $scope.$apply(function () {
	          $scope.isOpen = false;
	        });
	        $element[0].focus();
	      } else if (evt.which === 40 && !$scope.isOpen) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        $scope.$apply(function () {
	          $scope.isOpen = true;
	        });
	      }
	    }

	    function positionPopup() {
	      if ($scope.isOpen) {
	        var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	        var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	        var position = $position.positionElements($element, dpElement, placement, appendToBody);
	        dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
	        if (dpElement.hasClass('uib-position-measure')) {
	          dpElement.removeClass('uib-position-measure');
	        }
	      }
	    }

	    $scope.$on('uib:datepicker.mode', function () {
	      $timeout(positionPopup, 0, false);
	    });
	  }]).

	  directive('uibDatepickerPopup', function () {
	    return {
	      require: ['ngModel', 'uibDatepickerPopup'],
	      controller: 'UibDatepickerPopupController',
	      scope: {
	        datepickerOptions: '=?',
	        isOpen: '=?',
	        currentText: '@',
	        clearText: '@',
	        closeText: '@',
	        dateDisabled: '&',
	        customClass: '&' },

	      link: function link(scope, element, attrs, ctrls) {
	        var ngModel = ctrls[0],
	        ctrl = ctrls[1];

	        ctrl.init(ngModel);
	      } };

	  }).

	  directive('uibDatepickerPopupWrap', function () {
	    return {
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/datepicker/popup.html';
	      } };

	  });

	  angular.module('ui.bootstrap.debounce', [])
	  /**
	                                               * A helper, internal service that debounces a function
	                                               */.
	  factory('$$debounce', ['$timeout', function ($timeout) {
	    return function (callback, debounceTime) {
	      var timeoutPromise;

	      return function () {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }

	        timeoutPromise = $timeout(function () {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);

	  angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position']).

	  constant('uibDropdownConfig', {
	    appendToOpenClass: 'uib-dropdown-open',
	    openClass: 'open' }).


	  service('uibDropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
	    var openScope = null;

	    this.open = function (dropdownScope) {
	      if (!openScope) {
	        $document.on('click', closeDropdown);
	        $document.on('keydown', keybindFilter);
	      }

	      if (openScope && openScope !== dropdownScope) {
	        openScope.isOpen = false;
	      }

	      openScope = dropdownScope;
	    };

	    this.close = function (dropdownScope) {
	      if (openScope === dropdownScope) {
	        openScope = null;
	        $document.off('click', closeDropdown);
	        $document.off('keydown', keybindFilter);
	      }
	    };

	    var closeDropdown = function closeDropdown(evt) {
	      // This method may still be called during the same mouse event that
	      // unbound this event handler. So check openScope before proceeding.
	      if (!openScope) {return;}

	      if (evt && openScope.getAutoClose() === 'disabled') {return;}

	      if (evt && evt.which === 3) {return;}

	      var toggleElement = openScope.getToggleElement();
	      if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	        return;
	      }

	      var dropdownElement = openScope.getDropdownElement();
	      if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	        return;
	      }

	      openScope.isOpen = false;

	      if (!$rootScope.$$phase) {
	        openScope.$apply();
	      }
	    };

	    var keybindFilter = function keybindFilter(evt) {
	      if (evt.which === 27) {
	        openScope.focusToggleElement();
	        closeDropdown();
	      } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        openScope.focusDropdownEntry(evt.which);
	      }
	    };
	  }]).

	  controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	    var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    appendToOpenClass = dropdownConfig.appendToOpenClass,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    appendToBody = false,
	    appendTo = null,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');

	    $element.addClass('dropdown');

	    this.init = function () {
	      if ($attrs.isOpen) {
	        getIsOpen = $parse($attrs.isOpen);
	        setIsOpen = getIsOpen.assign;

	        $scope.$watch(getIsOpen, function (value) {
	          scope.isOpen = !!value;
	        });
	      }

	      if (angular.isDefined($attrs.dropdownAppendTo)) {
	        var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	        if (appendToEl) {
	          appendTo = angular.element(appendToEl);
	        }
	      }

	      appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	      keynavEnabled = angular.isDefined($attrs.keyboardNav);

	      if (appendToBody && !appendTo) {
	        appendTo = body;
	      }

	      if (appendTo && self.dropdownMenu) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', function handleDestroyEvent() {
	          self.dropdownMenu.remove();
	        });
	      }
	    };

	    this.toggle = function (open) {
	      return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    };

	    // Allow other directives to watch status
	    this.isOpen = function () {
	      return scope.isOpen;
	    };

	    scope.getToggleElement = function () {
	      return self.toggleElement;
	    };

	    scope.getAutoClose = function () {
	      return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	    };

	    scope.getElement = function () {
	      return $element;
	    };

	    scope.isKeynavEnabled = function () {
	      return keynavEnabled;
	    };

	    scope.focusDropdownEntry = function (keyCode) {
	      var elems = self.dropdownMenu ? //If append to body is used.
	      angular.element(self.dropdownMenu).find('a') :
	      $element.find('ul').eq(0).find('a');

	      switch (keyCode) {
	        case 40:{
	            if (!angular.isNumber(self.selectedOption)) {
	              self.selectedOption = 0;
	            } else {
	              self.selectedOption = self.selectedOption === elems.length - 1 ?
	              self.selectedOption :
	              self.selectedOption + 1;
	            }
	            break;
	          }
	        case 38:{
	            if (!angular.isNumber(self.selectedOption)) {
	              self.selectedOption = elems.length - 1;
	            } else {
	              self.selectedOption = self.selectedOption === 0 ?
	              0 : self.selectedOption - 1;
	            }
	            break;
	          }}

	      elems[self.selectedOption].focus();
	    };

	    scope.getDropdownElement = function () {
	      return self.dropdownMenu;
	    };

	    scope.focusToggleElement = function () {
	      if (self.toggleElement) {
	        self.toggleElement[0].focus();
	      }
	    };

	    scope.$watch('isOpen', function (isOpen, wasOpen) {
	      if (appendTo && self.dropdownMenu) {
	        var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	        css,
	        rightalign;

	        css = {
	          top: pos.top + 'px',
	          display: isOpen ? 'block' : 'none' };


	        rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	        if (!rightalign) {
	          css.left = pos.left + 'px';
	          css.right = 'auto';
	        } else {
	          css.left = 'auto';
	          css.right = window.innerWidth - (
	          pos.left + $element.prop('offsetWidth')) + 'px';
	        }

	        // Need to adjust our positioning to be relative to the appendTo container
	        // if it's not the body element
	        if (!appendToBody) {
	          var appendOffset = $position.offset(appendTo);

	          css.top = pos.top - appendOffset.top + 'px';

	          if (!rightalign) {
	            css.left = pos.left - appendOffset.left + 'px';
	          } else {
	            css.right = window.innerWidth - (
	            pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	          }
	        }

	        self.dropdownMenu.css(css);
	      }

	      var openContainer = appendTo ? appendTo : $element;
	      var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);

	      if (hasOpenClass === !isOpen) {
	        $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function () {
	          if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	            toggleInvoker($scope, { open: !!isOpen });
	          }
	        });
	      }

	      if (isOpen) {
	        if (self.dropdownMenuTemplateUrl) {
	          $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
	            templateScope = scope.$new();
	            $compile(tplContent.trim())(templateScope, function (dropdownElement) {
	              var newEl = dropdownElement;
	              self.dropdownMenu.replaceWith(newEl);
	              self.dropdownMenu = newEl;
	            });
	          });
	        }

	        scope.focusToggleElement();
	        uibDropdownService.open(scope);
	      } else {
	        if (self.dropdownMenuTemplateUrl) {
	          if (templateScope) {
	            templateScope.$destroy();
	          }
	          var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	          self.dropdownMenu.replaceWith(newEl);
	          self.dropdownMenu = newEl;
	        }

	        uibDropdownService.close(scope);
	        self.selectedOption = null;
	      }

	      if (angular.isFunction(setIsOpen)) {
	        setIsOpen($scope, isOpen);
	      }
	    });

	    $scope.$on('$locationChangeSuccess', function () {
	      if (scope.getAutoClose() !== 'disabled') {
	        scope.isOpen = false;
	      }
	    });
	  }]).

	  directive('uibDropdown', function () {
	    return {
	      controller: 'UibDropdownController',
	      link: function link(scope, element, attrs, dropdownCtrl) {
	        dropdownCtrl.init();
	      } };

	  }).

	  directive('uibDropdownMenu', function () {
	    return {
	      restrict: 'A',
	      require: '?^uibDropdown',
	      link: function link(scope, element, attrs, dropdownCtrl) {
	        if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	          return;
	        }

	        element.addClass('dropdown-menu');

	        var tplUrl = attrs.templateUrl;
	        if (tplUrl) {
	          dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	        }

	        if (!dropdownCtrl.dropdownMenu) {
	          dropdownCtrl.dropdownMenu = element;
	        }
	      } };

	  }).

	  directive('uibDropdownToggle', function () {
	    return {
	      require: '?^uibDropdown',
	      link: function link(scope, element, attrs, dropdownCtrl) {
	        if (!dropdownCtrl) {
	          return;
	        }

	        element.addClass('dropdown-toggle');

	        dropdownCtrl.toggleElement = element;

	        var toggleDropdown = function toggleDropdown(event) {
	          event.preventDefault();

	          if (!element.hasClass('disabled') && !attrs.disabled) {
	            scope.$apply(function () {
	              dropdownCtrl.toggle();
	            });
	          }
	        };

	        element.bind('click', toggleDropdown);

	        // WAI-ARIA
	        element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	        scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	          element.attr('aria-expanded', !!isOpen);
	        });

	        scope.$on('$destroy', function () {
	          element.unbind('click', toggleDropdown);
	        });
	      } };

	  });

	  angular.module('ui.bootstrap.stackedMap', [])
	  /**
	                                                 * A helper, internal data structure that acts as a map but also allows getting / removing
	                                                 * elements in the LIFO order
	                                                 */.
	  factory('$$stackedMap', function () {
	    return {
	      createNew: function createNew() {
	        var stack = [];

	        return {
	          add: function add(key, value) {
	            stack.push({
	              key: key,
	              value: value });

	          },
	          get: function get(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function keys() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function top() {
	            return stack[stack.length - 1];
	          },
	          remove: function remove(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function removeTop() {
	            return stack.splice(stack.length - 1, 1)[0];
	          },
	          length: function length() {
	            return stack.length;
	          } };

	      } };

	  });
	  angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap'])
	  /**
	                                                                     * A helper, internal data structure that stores all references attached to key
	                                                                     */.
	  factory('$$multiMap', function () {
	    return {
	      createNew: function createNew() {
	        var map = {};

	        return {
	          entries: function entries() {
	            return Object.keys(map).map(function (key) {
	              return {
	                key: key,
	                value: map[key] };

	            });
	          },
	          get: function get(key) {
	            return map[key];
	          },
	          hasKey: function hasKey(key) {
	            return !!map[key];
	          },
	          keys: function keys() {
	            return Object.keys(map);
	          },
	          put: function put(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }

	            map[key].push(value);
	          },
	          remove: function remove(key, value) {
	            var values = map[key];

	            if (!values) {
	              return;
	            }

	            var idx = values.indexOf(value);

	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }

	            if (!values.length) {
	              delete map[key];
	            }
	          } };

	      } };

	  })

	  /**
	      * Pluggable resolve mechanism for the modal resolve resolution
	      * Supports UI Router's $resolve service
	      */.
	  provider('$uibResolve', function () {
	    var resolve = this;
	    this.resolver = null;

	    this.setResolver = function (resolver) {
	      this.resolver = resolver;
	    };

	    this.$get = ['$injector', '$q', function ($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function resolve(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }

	          var promises = [];

	          angular.forEach(invocables, function (value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });

	          return $q.all(promises).then(function (resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function (value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });

	            return resolveObj;
	          });
	        } };

	    }];
	  })

	  /**
	      * A helper directive for the $modal service. It creates a backdrop element.
	      */.
	  directive('uibModalBackdrop', ['$animateCss', '$injector', '$uibModalStack',
	  function ($animateCss, $injector, $modalStack) {
	    return {
	      replace: true,
	      templateUrl: 'uib/template/modal/backdrop.html',
	      compile: function compile(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      } };


	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animateCss(element, {
	          addClass: attrs.modalInClass }).
	        start();

	        scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animateCss(element, {
	              removeClass: attrs.modalInClass }).
	            start().then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }]).

	  directive('uibModalWindow', ['$uibModalStack', '$q', '$animate', '$animateCss', '$document',
	  function ($modalStack, $q, $animate, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@' },

	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function link(scope, element, attrs) {
	        element.addClass(attrs.windowClass || '');
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;

	        scope.close = function (evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	          modal.value.backdrop !== 'static' &&
	          evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };

	        // moved from template to fix issue #2280
	        element.on('click', scope.close);

	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;

	        // Deferred object that will be resolved when this modal is render.
	        var modalRenderDeferObj = $q.defer();
	        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	        attrs.$observe('modalRender', function (value) {
	          if (value === 'true') {
	            modalRenderDeferObj.resolve();
	          }
	        });

	        modalRenderDeferObj.promise.then(function () {
	          var animationPromise = null;

	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass }).
	            start();

	            scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	              var done = setIsAsync();
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: attrs.modalInClass }).
	                start().then(done);
	              } else {
	                $animate.removeClass(element, attrs.modalInClass).then(done);
	              }
	            });
	          }


	          $q.when(animationPromise).then(function () {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }

	            /**
	               * If something within the freshly-opened modal already has focus (perhaps via a
	               * directive that causes focus). then no need to try and focus anything.
	               */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	                                                                                 * Auto-focusing of a freshly-opened modal element causes any child elements
	                                                                                 * with the autofocus attribute to lose focus. This is an issue on touch
	                                                                                 * based devices which will show and then hide the onscreen keyboard.
	                                                                                 * Attempts to refocus the autofocus element via JavaScript will not reopen
	                                                                                 * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	                                                                                 * the modal element if the modal does not contain an autofocus element.
	                                                                                 */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      } };

	  }]).

	  directive('uibModalAnimationClass', function () {
	    return {
	      compile: function compile(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      } };

	  }).

	  directive('uibModalTransclude', function () {
	    return {
	      link: function link(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function (clone) {
	          element.empty();
	          element.append(clone);
	        });
	      } };

	  }).

	  factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	  '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap',
	  function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap) {
	    var OPENED_MODAL_CLASS = 'modal-open';

	    var backdropDomEl, backdropScope;
	    var openedWindows = $$stackedMap.createNew();
	    var openedClasses = $$multiMap.createNew();
	    var $modalStack = {
	      NOW_CLOSING_EVENT: 'modal.stack.now-closing' };


	    //Modal focus behavior
	    var focusableElementList;
	    var focusIndex = 0;
	    var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
	    'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
	    'iframe, object, embed, *[tabindex], *[contenteditable=true]';

	    function backdropIndex() {
	      var topBackdropIndex = -1;
	      var opened = openedWindows.keys();
	      for (var i = 0; i < opened.length; i++) {
	        if (openedWindows.get(opened[i]).value.backdrop) {
	          topBackdropIndex = i;
	        }
	      }
	      return topBackdropIndex;
	    }

	    $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	      if (backdropScope) {
	        backdropScope.index = newBackdropIndex;
	      }
	    });

	    function removeModalWindow(modalInstance, elementToReceiveFocus) {
	      var modalWindow = openedWindows.get(modalInstance).value;
	      var appendToElement = modalWindow.appendTo;

	      //clean up the stack
	      openedWindows.remove(modalInstance);

	      removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
	        var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	        openedClasses.remove(modalBodyClass, modalInstance);
	        appendToElement.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
	        toggleTopWindowClass(true);
	      }, modalWindow.closedDeferred);
	      checkRemoveBackdrop();

	      //move focus to specified element if available, or else to body
	      if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	        elementToReceiveFocus.focus();
	      } else if (appendToElement.focus) {
	        appendToElement.focus();
	      }
	    }

	    // Add or remove "windowTopClass" from the top window in the stack
	    function toggleTopWindowClass(toggleSwitch) {
	      var modalWindow;

	      if (openedWindows.length() > 0) {
	        modalWindow = openedWindows.top().value;
	        modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	      }
	    }

	    function checkRemoveBackdrop() {
	      //remove backdrop if no longer needed
	      if (backdropDomEl && backdropIndex() === -1) {
	        var backdropScopeRef = backdropScope;
	        removeAfterAnimate(backdropDomEl, backdropScope, function () {
	          backdropScopeRef = null;
	        });
	        backdropDomEl = undefined;
	        backdropScope = undefined;
	      }
	    }

	    function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	      var asyncDeferred;
	      var asyncPromise = null;
	      var setIsAsync = function setIsAsync() {
	        if (!asyncDeferred) {
	          asyncDeferred = $q.defer();
	          asyncPromise = asyncDeferred.promise;
	        }

	        return function asyncDone() {
	          asyncDeferred.resolve();
	        };
	      };
	      scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

	      // Note that it's intentional that asyncPromise might be null.
	      // That's when setIsAsync has not been called during the
	      // NOW_CLOSING_EVENT broadcast.
	      return $q.when(asyncPromise).then(afterAnimating);

	      function afterAnimating() {
	        if (afterAnimating.done) {
	          return;
	        }
	        afterAnimating.done = true;

	        $animate.leave(domEl).then(function () {
	          domEl.remove();
	          if (closedDeferred) {
	            closedDeferred.resolve();
	          }
	        });

	        scope.$destroy();
	        if (done) {
	          done();
	        }
	      }
	    }

	    $document.on('keydown', keydownListener);

	    $rootScope.$on('$destroy', function () {
	      $document.off('keydown', keydownListener);
	    });

	    function keydownListener(evt) {
	      if (evt.isDefaultPrevented()) {
	        return evt;
	      }

	      var modal = openedWindows.top();
	      if (modal) {
	        switch (evt.which) {
	          case 27:{
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function () {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	          case 9:{
	              $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement();
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement();
	                }
	              }

	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	              break;
	            }}

	      }
	    }

	    $modalStack.open = function (modalInstance, modal) {
	      var modalOpener = $document[0].activeElement,
	      modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

	      toggleTopWindowClass(false);

	      openedWindows.add(modalInstance, {
	        deferred: modal.deferred,
	        renderDeferred: modal.renderDeferred,
	        closedDeferred: modal.closedDeferred,
	        modalScope: modal.scope,
	        backdrop: modal.backdrop,
	        keyboard: modal.keyboard,
	        openedClass: modal.openedClass,
	        windowTopClass: modal.windowTopClass,
	        animation: modal.animation,
	        appendTo: modal.appendTo });


	      openedClasses.put(modalBodyClass, modalInstance);

	      var appendToElement = modal.appendTo,
	      currBackdropIndex = backdropIndex();

	      if (!appendToElement.length) {
	        throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	      }

	      if (currBackdropIndex >= 0 && !backdropDomEl) {
	        backdropScope = $rootScope.$new(true);
	        backdropScope.modalOptions = modal;
	        backdropScope.index = currBackdropIndex;
	        backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	        backdropDomEl.attr('backdrop-class', modal.backdropClass);
	        if (modal.animation) {
	          backdropDomEl.attr('modal-animation', 'true');
	        }
	        $compile(backdropDomEl)(backdropScope);
	        $animate.enter(backdropDomEl, appendToElement);
	      }

	      var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	      angularDomEl.attr({
	        'template-url': modal.windowTemplateUrl,
	        'window-class': modal.windowClass,
	        'window-top-class': modal.windowTopClass,
	        'size': modal.size,
	        'index': openedWindows.length() - 1,
	        'animate': 'animate' }).
	      html(modal.content);
	      if (modal.animation) {
	        angularDomEl.attr('modal-animation', 'true');
	      }

	      $animate.enter($compile(angularDomEl)(modal.scope), appendToElement).
	      then(function () {
	        if (!modal.scope.$$uibDestructionScheduled) {
	          $animate.addClass(appendToElement, modalBodyClass);
	        }
	      });

	      openedWindows.top().value.modalDomEl = angularDomEl;
	      openedWindows.top().value.modalOpener = modalOpener;

	      $modalStack.clearFocusListCache();
	    };

	    function broadcastClosing(modalWindow, resultOrReason, closing) {
	      return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	    }

	    $modalStack.close = function (modalInstance, result) {
	      var modalWindow = openedWindows.get(modalInstance);
	      if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	        modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	        modalWindow.value.deferred.resolve(result);
	        removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	        return true;
	      }
	      return !modalWindow;
	    };

	    $modalStack.dismiss = function (modalInstance, reason) {
	      var modalWindow = openedWindows.get(modalInstance);
	      if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	        modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	        modalWindow.value.deferred.reject(reason);
	        removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	        return true;
	      }
	      return !modalWindow;
	    };

	    $modalStack.dismissAll = function (reason) {
	      var topModal = this.getTop();
	      while (topModal && this.dismiss(topModal.key, reason)) {
	        topModal = this.getTop();
	      }
	    };

	    $modalStack.getTop = function () {
	      return openedWindows.top();
	    };

	    $modalStack.modalRendered = function (modalInstance) {
	      var modalWindow = openedWindows.get(modalInstance);
	      if (modalWindow) {
	        modalWindow.value.renderDeferred.resolve();
	      }
	    };

	    $modalStack.focusFirstFocusableElement = function () {
	      if (focusableElementList.length > 0) {
	        focusableElementList[0].focus();
	        return true;
	      }
	      return false;
	    };
	    $modalStack.focusLastFocusableElement = function () {
	      if (focusableElementList.length > 0) {
	        focusableElementList[focusableElementList.length - 1].focus();
	        return true;
	      }
	      return false;
	    };

	    $modalStack.isModalFocused = function (evt, modalWindow) {
	      if (evt && modalWindow) {
	        var modalDomEl = modalWindow.value.modalDomEl;
	        if (modalDomEl && modalDomEl.length) {
	          return (evt.target || evt.srcElement) === modalDomEl[0];
	        }
	      }
	      return false;
	    };

	    $modalStack.isFocusInFirstItem = function (evt) {
	      if (focusableElementList.length > 0) {
	        return (evt.target || evt.srcElement) === focusableElementList[0];
	      }
	      return false;
	    };

	    $modalStack.isFocusInLastItem = function (evt) {
	      if (focusableElementList.length > 0) {
	        return (evt.target || evt.srcElement) === focusableElementList[focusableElementList.length - 1];
	      }
	      return false;
	    };

	    $modalStack.clearFocusListCache = function () {
	      focusableElementList = [];
	      focusIndex = 0;
	    };

	    $modalStack.loadFocusElementList = function (modalWindow) {
	      if (focusableElementList === undefined || !focusableElementList.length) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
	          }
	        }
	      }
	    };

	    return $modalStack;
	  }]).

	  provider('$uibModal', function () {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true },

	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	      function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	        var $modal = {};

	        function getTemplatePromise(options) {
	          return options.template ? $q.when(options.template) :
	          $templateRequest(angular.isFunction(options.templateUrl) ?
	          options.templateUrl() : options.templateUrl);
	        }

	        var promiseChain = null;
	        $modal.getPromiseChain = function () {
	          return promiseChain;
	        };

	        $modal.open = function (modalOptions) {
	          var modalResultDeferred = $q.defer();
	          var modalOpenedDeferred = $q.defer();
	          var modalClosedDeferred = $q.defer();
	          var modalRenderDeferred = $q.defer();

	          //prepare an instance of a modal to be injected into controllers and returned to a caller
	          var modalInstance = {
	            result: modalResultDeferred.promise,
	            opened: modalOpenedDeferred.promise,
	            closed: modalClosedDeferred.promise,
	            rendered: modalRenderDeferred.promise,
	            close: function close(result) {
	              return $modalStack.close(modalInstance, result);
	            },
	            dismiss: function dismiss(reason) {
	              return $modalStack.dismiss(modalInstance, reason);
	            } };


	          //merge and clean up options
	          modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	          modalOptions.resolve = modalOptions.resolve || {};
	          modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

	          //verify options
	          if (!modalOptions.template && !modalOptions.templateUrl) {
	            throw new Error('One of template or templateUrl options is required.');
	          }

	          var templateAndResolvePromise =
	          $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);

	          function resolveWithTemplate() {
	            return templateAndResolvePromise;
	          }

	          // Wait for the resolution of the existing promise chain.
	          // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	          // Then add to $modalStack and resolve opened.
	          // Finally clean up the chain variable if no subsequent modal has overwritten it.
	          var samePromise;
	          samePromise = promiseChain = $q.all([promiseChain]).
	          then(resolveWithTemplate, resolveWithTemplate).
	          then(function resolveSuccess(tplAndVars) {
	            var providedScope = modalOptions.scope || $rootScope;

	            var modalScope = providedScope.$new();
	            modalScope.$close = modalInstance.close;
	            modalScope.$dismiss = modalInstance.dismiss;

	            modalScope.$on('$destroy', function () {
	              if (!modalScope.$$uibDestructionScheduled) {
	                modalScope.$dismiss('$uibUnscheduledDestruction');
	              }
	            });

	            var ctrlInstance,ctrlInstantiate,ctrlLocals = {};

	            //controllers
	            if (modalOptions.controller) {
	              ctrlLocals.$scope = modalScope;
	              ctrlLocals.$uibModalInstance = modalInstance;
	              angular.forEach(tplAndVars[1], function (value, key) {
	                ctrlLocals[key] = value;
	              });

	              // the third param will make the controller instantiate later,private api
	              // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	              ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true);
	              if (modalOptions.controllerAs) {
	                ctrlInstance = ctrlInstantiate.instance;

	                if (modalOptions.bindToController) {
	                  ctrlInstance.$close = modalScope.$close;
	                  ctrlInstance.$dismiss = modalScope.$dismiss;
	                  angular.extend(ctrlInstance, providedScope);
	                }

	                ctrlInstance = ctrlInstantiate();

	                modalScope[modalOptions.controllerAs] = ctrlInstance;
	              } else {
	                ctrlInstance = ctrlInstantiate();
	              }

	              if (angular.isFunction(ctrlInstance.$onInit)) {
	                ctrlInstance.$onInit();
	              }
	            }

	            $modalStack.open(modalInstance, {
	              scope: modalScope,
	              deferred: modalResultDeferred,
	              renderDeferred: modalRenderDeferred,
	              closedDeferred: modalClosedDeferred,
	              content: tplAndVars[0],
	              animation: modalOptions.animation,
	              backdrop: modalOptions.backdrop,
	              keyboard: modalOptions.keyboard,
	              backdropClass: modalOptions.backdropClass,
	              windowTopClass: modalOptions.windowTopClass,
	              windowClass: modalOptions.windowClass,
	              windowTemplateUrl: modalOptions.windowTemplateUrl,
	              size: modalOptions.size,
	              openedClass: modalOptions.openedClass,
	              appendTo: modalOptions.appendTo });

	            modalOpenedDeferred.resolve(true);

	          }, function resolveError(reason) {
	            modalOpenedDeferred.reject(reason);
	            modalResultDeferred.reject(reason);
	          })['finally'](function () {
	            if (promiseChain === samePromise) {
	              promiseChain = null;
	            }
	          });

	          return modalInstance;
	        };

	        return $modal;
	      }] };



	    return $modalProvider;
	  });

	  angular.module('ui.bootstrap.paging', [])
	  /**
	                                             * Helper internal service for generating common controller code between the
	                                             * pager and pagination components
	                                             */.
	  factory('uibPaging', ['$parse', function ($parse) {
	    return {
	      create: function create(ctrl, $scope, $attrs) {
	        ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	        ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	        ctrl._watchers = [];

	        ctrl.init = function (ngModelCtrl, config) {
	          ctrl.ngModelCtrl = ngModelCtrl;
	          ctrl.config = config;

	          ngModelCtrl.$render = function () {
	            ctrl.render();
	          };

	          if ($attrs.itemsPerPage) {
	            ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
	              ctrl.itemsPerPage = parseInt(value, 10);
	              $scope.totalPages = ctrl.calculateTotalPages();
	              ctrl.updatePage();
	            }));
	          } else {
	            ctrl.itemsPerPage = config.itemsPerPage;
	          }

	          $scope.$watch('totalItems', function (newTotal, oldTotal) {
	            if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	              $scope.totalPages = ctrl.calculateTotalPages();
	              ctrl.updatePage();
	            }
	          });
	        };

	        ctrl.calculateTotalPages = function () {
	          var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	          return Math.max(totalPages || 0, 1);
	        };

	        ctrl.render = function () {
	          $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	        };

	        $scope.selectPage = function (page, evt) {
	          if (evt) {
	            evt.preventDefault();
	          }

	          var clickAllowed = !$scope.ngDisabled || !evt;
	          if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	            if (evt && evt.target) {
	              evt.target.blur();
	            }
	            ctrl.ngModelCtrl.$setViewValue(page);
	            ctrl.ngModelCtrl.$render();
	          }
	        };

	        $scope.getText = function (key) {
	          return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	        };

	        $scope.noPrevious = function () {
	          return $scope.page === 1;
	        };

	        $scope.noNext = function () {
	          return $scope.page === $scope.totalPages;
	        };

	        ctrl.updatePage = function () {
	          ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

	          if ($scope.page > $scope.totalPages) {
	            $scope.selectPage($scope.totalPages);
	          } else {
	            ctrl.ngModelCtrl.$render();
	          }
	        };

	        $scope.$on('$destroy', function () {
	          while (ctrl._watchers.length) {
	            ctrl._watchers.shift()();
	          }
	        });
	      } };

	  }]);

	  angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging']).

	  controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
	    $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

	    uibPaging.create(this, $scope, $attrs);
	  }]).

	  constant('uibPagerConfig', {
	    itemsPerPage: 10,
	    previousText: '« Previous',
	    nextText: 'Next »',
	    align: true }).


	  directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
	    return {
	      scope: {
	        totalItems: '=',
	        previousText: '@',
	        nextText: '@',
	        ngDisabled: '=' },

	      require: ['uibPager', '?ngModel'],
	      controller: 'UibPagerController',
	      controllerAs: 'pager',
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/pager/pager.html';
	      },
	      replace: true,
	      link: function link(scope, element, attrs, ctrls) {
	        var paginationCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	        if (!ngModelCtrl) {
	          return; // do nothing if no ng-model
	        }

	        paginationCtrl.init(ngModelCtrl, uibPagerConfig);
	      } };

	  }]);

	  angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging']).
	  controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	    var ctrl = this;
	    // Setup configuration parameters
	    var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) {return $scope.$parent.$eval($attrs.pageLabel, { $page: idx });} : angular.identity;
	    $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	    $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;

	    uibPaging.create(this, $scope, $attrs);

	    if ($attrs.maxSize) {
	      ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
	        maxSize = parseInt(value, 10);
	        ctrl.render();
	      }));
	    }

	    // Create page object used in template
	    function makePage(number, text, isActive) {
	      return {
	        number: number,
	        text: text,
	        active: isActive };

	    }

	    function getPages(currentPage, totalPages) {
	      var pages = [];

	      // Default page limits
	      var startPage = 1,endPage = totalPages;
	      var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

	      // recompute if maxSize
	      if (isMaxSized) {
	        if (rotate) {
	          // Current page is displayed in the middle of the visible ones
	          startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	          endPage = startPage + maxSize - 1;

	          // Adjust if limit is exceeded
	          if (endPage > totalPages) {
	            endPage = totalPages;
	            startPage = endPage - maxSize + 1;
	          }
	        } else {
	          // Visible pages are paginated with maxSize
	          startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

	          // Adjust last page if limit is exceeded
	          endPage = Math.min(startPage + maxSize - 1, totalPages);
	        }
	      }

	      // Add page number links
	      for (var number = startPage; number <= endPage; number++) {
	        var page = makePage(number, pageLabel(number), number === currentPage);
	        pages.push(page);
	      }

	      // Add links to move between page sets
	      if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	        if (startPage > 1) {
	          if (!boundaryLinkNumbers || startPage > 3) {//need ellipsis for all options unless range is too close to beginning
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	          if (boundaryLinkNumbers) {
	            if (startPage === 3) {//need to replace ellipsis when the buttons would be sequential
	              var secondPageLink = makePage(2, '2', false);
	              pages.unshift(secondPageLink);
	            }
	            //add the first page
	            var firstPageLink = makePage(1, '1', false);
	            pages.unshift(firstPageLink);
	          }
	        }

	        if (endPage < totalPages) {
	          if (!boundaryLinkNumbers || endPage < totalPages - 2) {//need ellipsis for all options unless range is too close to end
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	          if (boundaryLinkNumbers) {
	            if (endPage === totalPages - 2) {//need to replace ellipsis when the buttons would be sequential
	              var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	              pages.push(secondToLastPageLink);
	            }
	            //add the last page
	            var lastPageLink = makePage(totalPages, totalPages, false);
	            pages.push(lastPageLink);
	          }
	        }
	      }
	      return pages;
	    }

	    var originalRender = this.render;
	    this.render = function () {
	      originalRender();
	      if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	        $scope.pages = getPages($scope.page, $scope.totalPages);
	      }
	    };
	  }]).

	  constant('uibPaginationConfig', {
	    itemsPerPage: 10,
	    boundaryLinks: false,
	    boundaryLinkNumbers: false,
	    directionLinks: true,
	    firstText: 'First',
	    previousText: 'Previous',
	    nextText: 'Next',
	    lastText: 'Last',
	    rotate: true,
	    forceEllipses: false }).


	  directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
	    return {
	      scope: {
	        totalItems: '=',
	        firstText: '@',
	        previousText: '@',
	        nextText: '@',
	        lastText: '@',
	        ngDisabled: '=' },

	      require: ['uibPagination', '?ngModel'],
	      controller: 'UibPaginationController',
	      controllerAs: 'pagination',
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	      },
	      replace: true,
	      link: function link(scope, element, attrs, ctrls) {
	        var paginationCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	        if (!ngModelCtrl) {
	          return; // do nothing if no ng-model
	        }

	        paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	      } };

	  }]);

	  /**
	        * The following features are still outstanding: animation as a
	        * function, placement as a function, inside, support for more triggers than
	        * just mouse enter/leave, html tooltips, and selector delegation.
	        */
	  angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

	  /**
	                                                                                                * The $tooltip service creates tooltip- and popover-like directives as well as
	                                                                                                * houses global options for them.
	                                                                                                */.
	  provider('$uibTooltip', function () {
	    // The default options tooltip and popover.
	    var defaultOptions = {
	      placement: 'top',
	      placementClassPrefix: '',
	      animation: true,
	      popupDelay: 0,
	      popupCloseDelay: 0,
	      useContentExp: false };


	    // Default hide triggers for each show trigger
	    var triggerMap = {
	      'mouseenter': 'mouseleave',
	      'click': 'click',
	      'outsideClick': 'outsideClick',
	      'focus': 'blur',
	      'none': '' };


	    // The options specified to the provider globally.
	    var globalOptions = {};

	    /**
	                             * `options({})` allows global configuration of all tooltips in the
	                             * application.
	                             *
	                             *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	                             *     // place tooltips left instead of top by default
	                             *     $tooltipProvider.options( { placement: 'left' } );
	                             *   });
	                             */
	    this.options = function (value) {
	      angular.extend(globalOptions, value);
	    };

	    /**
	        * This allows you to extend the set of trigger mappings available. E.g.:
	        *
	        *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	        */
	    this.setTriggers = function setTriggers(triggers) {
	      angular.extend(triggerMap, triggers);
	    };

	    /**
	        * This is a helper function for translating camel-case to snake_case.
	        */
	    function snake_case(name) {
	      var regexp = /[A-Z]/g;
	      var separator = '-';
	      return name.replace(regexp, function (letter, pos) {
	        return (pos ? separator : '') + letter.toLowerCase();
	      });
	    }

	    /**
	       * Returns the actual instance of the $tooltip service.
	       * TODO support multiple triggers
	       */
	    this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	      var openedTooltips = $$stackedMap.createNew();
	      $document.on('keypress', keypressListener);

	      $rootScope.$on('$destroy', function () {
	        $document.off('keypress', keypressListener);
	      });

	      function keypressListener(e) {
	        if (e.which === 27) {
	          var last = openedTooltips.top();
	          if (last) {
	            last.value.close();
	            openedTooltips.removeTop();
	            last = null;
	          }
	        }
	      }

	      return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	        options = angular.extend({}, defaultOptions, globalOptions, options);

	        /**
	                                                                               * Returns an object of show and hide triggers.
	                                                                               *
	                                                                               * If a trigger is supplied,
	                                                                               * it is used to show the tooltip; otherwise, it will use the `trigger`
	                                                                               * option passed to the `$tooltipProvider.options` method; else it will
	                                                                               * default to the trigger supplied to this directive factory.
	                                                                               *
	                                                                               * The hide trigger is based on the show trigger. If the `trigger` option
	                                                                               * was passed to the `$tooltipProvider.options` method, it will use the
	                                                                               * mapped trigger from `triggerMap` or the passed trigger if the map is
	                                                                               * undefined; otherwise, it uses the `triggerMap` value of the show
	                                                                               * trigger; else it will just use the show trigger.
	                                                                               */
	        function getTriggers(trigger) {
	          var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	          var hide = show.map(function (trigger) {
	            return triggerMap[trigger] || trigger;
	          });
	          return {
	            show: show,
	            hide: hide };

	        }

	        var directiveName = snake_case(ttType);

	        var startSym = $interpolate.startSymbol();
	        var endSym = $interpolate.endSymbol();
	        var template =
	        '<div ' + directiveName + '-popup ' +
	        'title="' + startSym + 'title' + endSym + '" ' + (
	        options.useContentExp ?
	        'content-exp="contentExp()" ' :
	        'content="' + startSym + 'content' + endSym + '" ') +
	        'placement="' + startSym + 'placement' + endSym + '" ' +
	        'popup-class="' + startSym + 'popupClass' + endSym + '" ' +
	        'animation="animation" ' +
	        'is-open="isOpen"' +
	        'origin-scope="origScope" ' +
	        'class="uib-position-measure"' +
	        '>' +
	        '</div>';

	        return {
	          compile: function compile(tElem, tAttrs) {
	            var tooltipLinker = $compile(template);

	            return function link(scope, element, attrs, tooltipCtrl) {
	              var tooltip;
	              var tooltipLinkedScope;
	              var transitionTimeout;
	              var showTimeout;
	              var hideTimeout;
	              var positionTimeout;
	              var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	              var triggers = getTriggers(undefined);
	              var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	              var ttScope = scope.$new(true);
	              var repositionScheduled = false;
	              var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	              var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	              var observers = [];
	              var lastPlacement;

	              var positionTooltip = function positionTooltip() {
	                // check if tooltip exists and is not empty
	                if (!tooltip || !tooltip.html()) {return;}

	                if (!positionTimeout) {
	                  positionTimeout = $timeout(function () {
	                    var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                    tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });

	                    if (!tooltip.hasClass(ttPosition.placement.split('-')[0])) {
	                      tooltip.removeClass(lastPlacement.split('-')[0]);
	                      tooltip.addClass(ttPosition.placement.split('-')[0]);
	                    }

	                    if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                      tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                      tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                    }

	                    // first time through tt element will have the
	                    // uib-position-measure class or if the placement
	                    // has changed we need to position the arrow.
	                    if (tooltip.hasClass('uib-position-measure')) {
	                      $position.positionArrow(tooltip, ttPosition.placement);
	                      tooltip.removeClass('uib-position-measure');
	                    } else if (lastPlacement !== ttPosition.placement) {
	                      $position.positionArrow(tooltip, ttPosition.placement);
	                    }
	                    lastPlacement = ttPosition.placement;

	                    positionTimeout = null;
	                  }, 0, false);
	                }
	              };

	              // Set up the correct scope to allow transclusion later
	              ttScope.origScope = scope;

	              // By default, the tooltip is not open.
	              // TODO add ability to start tooltip opened
	              ttScope.isOpen = false;
	              openedTooltips.add(ttScope, {
	                close: hide });


	              function toggleTooltipBind() {
	                if (!ttScope.isOpen) {
	                  showTooltipBind();
	                } else {
	                  hideTooltipBind();
	                }
	              }

	              // Show the tooltip with delay if specified, otherwise show it immediately
	              function showTooltipBind() {
	                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                  return;
	                }

	                cancelHide();
	                prepareTooltip();

	                if (ttScope.popupDelay) {
	                  // Do nothing if the tooltip was already scheduled to pop-up.
	                  // This happens if show is triggered multiple times before any hide is triggered.
	                  if (!showTimeout) {
	                    showTimeout = $timeout(show, ttScope.popupDelay, false);
	                  }
	                } else {
	                  show();
	                }
	              }

	              function hideTooltipBind() {
	                cancelShow();

	                if (ttScope.popupCloseDelay) {
	                  if (!hideTimeout) {
	                    hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                  }
	                } else {
	                  hide();
	                }
	              }

	              // Show the tooltip popup element.
	              function show() {
	                cancelShow();
	                cancelHide();

	                // Don't show empty tooltips.
	                if (!ttScope.content) {
	                  return angular.noop;
	                }

	                createTooltip();

	                // And show the tooltip.
	                ttScope.$evalAsync(function () {
	                  ttScope.isOpen = true;
	                  assignIsOpen(true);
	                  positionTooltip();
	                });
	              }

	              function cancelShow() {
	                if (showTimeout) {
	                  $timeout.cancel(showTimeout);
	                  showTimeout = null;
	                }

	                if (positionTimeout) {
	                  $timeout.cancel(positionTimeout);
	                  positionTimeout = null;
	                }
	              }

	              // Hide the tooltip popup element.
	              function hide() {
	                if (!ttScope) {
	                  return;
	                }

	                // First things first: we don't show it anymore.
	                ttScope.$evalAsync(function () {
	                  if (ttScope) {
	                    ttScope.isOpen = false;
	                    assignIsOpen(false);
	                    // And now we remove it from the DOM. However, if we have animation, we
	                    // need to wait for it to expire beforehand.
	                    // FIXME: this is a placeholder for a port of the transitions library.
	                    // The fade transition in TWBS is 150ms.
	                    if (ttScope.animation) {
	                      if (!transitionTimeout) {
	                        transitionTimeout = $timeout(removeTooltip, 150, false);
	                      }
	                    } else {
	                      removeTooltip();
	                    }
	                  }
	                });
	              }

	              function cancelHide() {
	                if (hideTimeout) {
	                  $timeout.cancel(hideTimeout);
	                  hideTimeout = null;
	                }

	                if (transitionTimeout) {
	                  $timeout.cancel(transitionTimeout);
	                  transitionTimeout = null;
	                }
	              }

	              function createTooltip() {
	                // There can only be one tooltip element per directive shown at once.
	                if (tooltip) {
	                  return;
	                }

	                tooltipLinkedScope = ttScope.$new();
	                tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                  if (appendToBody) {
	                    $document.find('body').append(tooltip);
	                  } else {
	                    element.after(tooltip);
	                  }
	                });

	                prepObservers();
	              }

	              function removeTooltip() {
	                cancelShow();
	                cancelHide();
	                unregisterObservers();

	                if (tooltip) {
	                  tooltip.remove();
	                  tooltip = null;
	                }
	                if (tooltipLinkedScope) {
	                  tooltipLinkedScope.$destroy();
	                  tooltipLinkedScope = null;
	                }
	              }

	              /**
	                 * Set the initial scope values. Once
	                 * the tooltip is created, the observers
	                 * will be added to keep things in sync.
	                 */
	              function prepareTooltip() {
	                ttScope.title = attrs[prefix + 'Title'];
	                if (contentParse) {
	                  ttScope.content = contentParse(scope);
	                } else {
	                  ttScope.content = attrs[ttType];
	                }

	                ttScope.popupClass = attrs[prefix + 'Class'];
	                ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	                var placement = $position.parsePlacement(ttScope.placement);
	                lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

	                var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	                var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	                ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	              }

	              function assignIsOpen(isOpen) {
	                if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                  isOpenParse.assign(scope, isOpen);
	                }
	              }

	              ttScope.contentExp = function () {
	                return ttScope.content;
	              };

	              /**
	                  * Observe the relevant attributes.
	                  */
	              attrs.$observe('disabled', function (val) {
	                if (val) {
	                  cancelShow();
	                }

	                if (val && ttScope.isOpen) {
	                  hide();
	                }
	              });

	              if (isOpenParse) {
	                scope.$watch(isOpenParse, function (val) {
	                  if (ttScope && !val === ttScope.isOpen) {
	                    toggleTooltipBind();
	                  }
	                });
	              }

	              function prepObservers() {
	                observers.length = 0;

	                if (contentParse) {
	                  observers.push(
	                  scope.$watch(contentParse, function (val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  }));


	                  observers.push(
	                  tooltipLinkedScope.$watch(function () {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function () {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  }));

	                } else {
	                  observers.push(
	                  attrs.$observe(ttType, function (val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  }));

	                }

	                observers.push(
	                attrs.$observe(prefix + 'Title', function (val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                }));


	                observers.push(
	                attrs.$observe(prefix + 'Placement', function (val) {
	                  ttScope.placement = val ? val : options.placement;
	                  var placement = $position.parsePlacement(ttScope.placement);
	                  lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                }));

	              }

	              function unregisterObservers() {
	                if (observers.length) {
	                  angular.forEach(observers, function (observer) {
	                    observer();
	                  });
	                  observers.length = 0;
	                }
	              }

	              // hide tooltips/popovers for outsideClick trigger
	              function bodyHideTooltipBind(e) {
	                if (!ttScope || !ttScope.isOpen || !tooltip) {
	                  return;
	                }
	                // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	                if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                  hideTooltipBind();
	                }
	              }

	              var unregisterTriggers = function unregisterTriggers() {
	                triggers.show.forEach(function (trigger) {
	                  if (trigger === 'outsideClick') {
	                    element.off('click', toggleTooltipBind);
	                  } else {
	                    element.off(trigger, showTooltipBind);
	                    element.off(trigger, toggleTooltipBind);
	                  }
	                });
	                triggers.hide.forEach(function (trigger) {
	                  if (trigger === 'outsideClick') {
	                    $document.off('click', bodyHideTooltipBind);
	                  } else {
	                    element.off(trigger, hideTooltipBind);
	                  }
	                });
	              };

	              function prepTriggers() {
	                var val = attrs[prefix + 'Trigger'];
	                unregisterTriggers();

	                triggers = getTriggers(val);

	                if (triggers.show !== 'none') {
	                  triggers.show.forEach(function (trigger, idx) {
	                    if (trigger === 'outsideClick') {
	                      element.on('click', toggleTooltipBind);
	                      $document.on('click', bodyHideTooltipBind);
	                    } else if (trigger === triggers.hide[idx]) {
	                      element.on(trigger, toggleTooltipBind);
	                    } else if (trigger) {
	                      element.on(trigger, showTooltipBind);
	                      element.on(triggers.hide[idx], hideTooltipBind);
	                    }

	                    element.on('keypress', function (e) {
	                      if (e.which === 27) {
	                        hideTooltipBind();
	                      }
	                    });
	                  });
	                }
	              }

	              prepTriggers();

	              var animation = scope.$eval(attrs[prefix + 'Animation']);
	              ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

	              var appendToBodyVal;
	              var appendKey = prefix + 'AppendToBody';
	              if (appendKey in attrs && attrs[appendKey] === undefined) {
	                appendToBodyVal = true;
	              } else {
	                appendToBodyVal = scope.$eval(attrs[appendKey]);
	              }

	              appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

	              // Make sure tooltip is destroyed and removed.
	              scope.$on('$destroy', function onDestroyTooltip() {
	                unregisterTriggers();
	                removeTooltip();
	                openedTooltips.remove(ttScope);
	                ttScope = null;
	              });
	            };
	          } };

	      };
	    }];
	  })

	  // This is mostly ngInclude code but with a custom scope
	  .directive('uibTooltipTemplateTransclude', [
	  '$animate', '$sce', '$compile', '$templateRequest',
	  function ($animate, $sce, $compile, $templateRequest) {
	    return {
	      link: function link(scope, elem, attrs) {
	        var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

	        var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;

	        var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }

	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }

	          if (currentElement) {
	            $animate.leave(currentElement).then(function () {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };

	        scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
	          var thisChangeId = ++changeCounter;

	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function (response) {
	              if (thisChangeId !== changeCounter) {return;}
	              var newScope = origScope.$new();
	              var template = response;

	              var clone = $compile(template)(newScope, function (clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, elem);
	              });

	              currentScope = newScope;
	              currentElement = clone;

	              currentScope.$emit('$includeContentLoaded', src);
	            }, function () {
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	          }
	        });

	        scope.$on('$destroy', cleanupLastIncludeContent);
	      } };

	  }])

	  /**
	       * Note that it's intentional that these classes are *not* applied through $animate.
	       * They must not be animated as they're expected to be present on the tooltip on
	       * initialization.
	       */.
	  directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
	    return {
	      restrict: 'A',
	      link: function link(scope, element, attrs) {
	        // need to set the primary position so the
	        // arrow has space during position measure.
	        // tooltip.positionTooltip()
	        if (scope.placement) {
	          // // There are no top-left etc... classes
	          // // in TWBS, so we need the primary position.
	          var position = $uibPosition.parsePlacement(scope.placement);
	          element.addClass(position[0]);
	        }

	        if (scope.popupClass) {
	          element.addClass(scope.popupClass);
	        }

	        if (scope.animation()) {
	          element.addClass(attrs.tooltipAnimationClass);
	        }
	      } };

	  }]).

	  directive('uibTooltipPopup', function () {
	    return {
	      replace: true,
	      scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	      templateUrl: 'uib/template/tooltip/tooltip-popup.html' };

	  }).

	  directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
	    return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	  }]).

	  directive('uibTooltipTemplatePopup', function () {
	    return {
	      replace: true,
	      scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	        originScope: '&' },
	      templateUrl: 'uib/template/tooltip/tooltip-template-popup.html' };

	  }).

	  directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
	    return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	      useContentExp: true });

	  }]).

	  directive('uibTooltipHtmlPopup', function () {
	    return {
	      replace: true,
	      scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	      templateUrl: 'uib/template/tooltip/tooltip-html-popup.html' };

	  }).

	  directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
	    return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	      useContentExp: true });

	  }]);

	  /**
	        * The following features are still outstanding: popup delay, animation as a
	        * function, placement as a function, inside, support for more triggers than
	        * just mouse enter/leave, and selector delegatation.
	        */
	  angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).

	  directive('uibPopoverTemplatePopup', function () {
	    return {
	      replace: true,
	      scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	        originScope: '&' },
	      templateUrl: 'uib/template/popover/popover-template.html' };

	  }).

	  directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
	    return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	      useContentExp: true });

	  }]).

	  directive('uibPopoverHtmlPopup', function () {
	    return {
	      replace: true,
	      scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	      templateUrl: 'uib/template/popover/popover-html.html' };

	  }).

	  directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
	    return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	      useContentExp: true });

	  }]).

	  directive('uibPopoverPopup', function () {
	    return {
	      replace: true,
	      scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	      templateUrl: 'uib/template/popover/popover.html' };

	  }).

	  directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
	    return $uibTooltip('uibPopover', 'popover', 'click');
	  }]);

	  angular.module('ui.bootstrap.progressbar', []).

	  constant('uibProgressConfig', {
	    animate: true,
	    max: 100 }).


	  controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
	    var self = this,
	    animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

	    this.bars = [];
	    $scope.max = getMaxOrDefault();

	    this.addBar = function (bar, element, attrs) {
	      if (!animate) {
	        element.css({ 'transition': 'none' });
	      }

	      this.bars.push(bar);

	      bar.max = getMaxOrDefault();
	      bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

	      bar.$watch('value', function (value) {
	        bar.recalculatePercentage();
	      });

	      bar.recalculatePercentage = function () {
	        var totalPercentage = self.bars.reduce(function (total, bar) {
	          bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	          return total + bar.percent;
	        }, 0);

	        if (totalPercentage > 100) {
	          bar.percent -= totalPercentage - 100;
	        }
	      };

	      bar.$on('$destroy', function () {
	        element = null;
	        self.removeBar(bar);
	      });
	    };

	    this.removeBar = function (bar) {
	      this.bars.splice(this.bars.indexOf(bar), 1);
	      this.bars.forEach(function (bar) {
	        bar.recalculatePercentage();
	      });
	    };

	    //$attrs.$observe('maxParam', function(maxParam) {
	    $scope.$watch('maxParam', function (maxParam) {
	      self.bars.forEach(function (bar) {
	        bar.max = getMaxOrDefault();
	        bar.recalculatePercentage();
	      });
	    });

	    function getMaxOrDefault() {
	      return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	    }
	  }]).

	  directive('uibProgress', function () {
	    return {
	      replace: true,
	      transclude: true,
	      controller: 'UibProgressController',
	      require: 'uibProgress',
	      scope: {
	        maxParam: '=?max' },

	      templateUrl: 'uib/template/progressbar/progress.html' };

	  }).

	  directive('uibBar', function () {
	    return {
	      replace: true,
	      transclude: true,
	      require: '^uibProgress',
	      scope: {
	        value: '=',
	        type: '@' },

	      templateUrl: 'uib/template/progressbar/bar.html',
	      link: function link(scope, element, attrs, progressCtrl) {
	        progressCtrl.addBar(scope, element, attrs);
	      } };

	  }).

	  directive('uibProgressbar', function () {
	    return {
	      replace: true,
	      transclude: true,
	      controller: 'UibProgressController',
	      scope: {
	        value: '=',
	        maxParam: '=?max',
	        type: '@' },

	      templateUrl: 'uib/template/progressbar/progressbar.html',
	      link: function link(scope, element, attrs, progressCtrl) {
	        progressCtrl.addBar(scope, angular.element(element.children()[0]), { title: attrs.title });
	      } };

	  });

	  angular.module('ui.bootstrap.rating', []).

	  constant('uibRatingConfig', {
	    max: 5,
	    stateOn: null,
	    stateOff: null,
	    titles: ['one', 'two', 'three', 'four', 'five'] }).


	  controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
	    var ngModelCtrl = { $setViewValue: angular.noop },
	    self = this;

	    this.init = function (ngModelCtrl_) {
	      ngModelCtrl = ngModelCtrl_;
	      ngModelCtrl.$render = this.render;

	      ngModelCtrl.$formatters.push(function (value) {
	        if (angular.isNumber(value) && value << 0 !== value) {
	          value = Math.round(value);
	        }

	        return value;
	      });

	      this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	      this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	      var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
	      this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;

	      var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	      $scope.range = this.buildTemplateObjects(ratingStates);
	    };

	    this.buildTemplateObjects = function (states) {
	      for (var i = 0, n = states.length; i < n; i++) {
	        states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	      }
	      return states;
	    };

	    this.getTitle = function (index) {
	      if (index >= this.titles.length) {
	        return index + 1;
	      }

	      return this.titles[index];
	    };

	    $scope.rate = function (value) {
	      if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	        ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
	        ngModelCtrl.$render();
	      }
	    };

	    $scope.enter = function (value) {
	      if (!$scope.readonly) {
	        $scope.value = value;
	      }
	      $scope.onHover({ value: value });
	    };

	    $scope.reset = function () {
	      $scope.value = ngModelCtrl.$viewValue;
	      $scope.onLeave();
	    };

	    $scope.onKeydown = function (evt) {
	      if (/(37|38|39|40)/.test(evt.which)) {
	        evt.preventDefault();
	        evt.stopPropagation();
	        $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	      }
	    };

	    this.render = function () {
	      $scope.value = ngModelCtrl.$viewValue;
	      $scope.title = self.getTitle($scope.value - 1);
	    };
	  }]).

	  directive('uibRating', function () {
	    return {
	      require: ['uibRating', 'ngModel'],
	      scope: {
	        readonly: '=?readOnly',
	        onHover: '&',
	        onLeave: '&' },

	      controller: 'UibRatingController',
	      templateUrl: 'uib/template/rating/rating.html',
	      replace: true,
	      link: function link(scope, element, attrs, ctrls) {
	        var ratingCtrl = ctrls[0],ngModelCtrl = ctrls[1];
	        ratingCtrl.init(ngModelCtrl);
	      } };

	  });

	  angular.module('ui.bootstrap.tabs', []).

	  controller('UibTabsetController', ['$scope', function ($scope) {
	    var ctrl = this,
	    oldIndex;
	    ctrl.tabs = [];

	    ctrl.select = function (index) {
	      if (!destroyed) {
	        var previousIndex = findTabIndex(oldIndex);
	        var previousSelected = ctrl.tabs[previousIndex];
	        if (previousSelected) {
	          previousSelected.tab.onDeselect();
	          previousSelected.tab.active = false;
	        }

	        var selected = ctrl.tabs[index];
	        if (selected) {
	          selected.tab.onSelect();
	          selected.tab.active = true;
	          ctrl.active = selected.index;
	          oldIndex = selected.index;
	        } else if (!selected && angular.isNumber(oldIndex)) {
	          ctrl.active = null;
	          oldIndex = null;
	        }
	      }
	    };

	    ctrl.addTab = function addTab(tab) {
	      ctrl.tabs.push({
	        tab: tab,
	        index: tab.index });

	      ctrl.tabs.sort(function (t1, t2) {
	        if (t1.index > t2.index) {
	          return 1;
	        }

	        if (t1.index < t2.index) {
	          return -1;
	        }

	        return 0;
	      });

	      if (tab.index === ctrl.active || !angular.isNumber(ctrl.active) && ctrl.tabs.length === 1) {
	        var newActiveIndex = findTabIndex(tab.index);
	        ctrl.select(newActiveIndex);
	      }
	    };

	    ctrl.removeTab = function removeTab(tab) {
	      var index = findTabIndex(tab.index);

	      if (tab.index === ctrl.active) {
	        var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
	        index - 1 : index + 1 % ctrl.tabs.length;
	        ctrl.select(newActiveTabIndex);
	      }

	      ctrl.tabs.splice(index, 1);
	    };

	    $scope.$watch('tabset.active', function (val) {
	      if (angular.isNumber(val) && val !== oldIndex) {
	        ctrl.select(findTabIndex(val));
	      }
	    });

	    var destroyed;
	    $scope.$on('$destroy', function () {
	      destroyed = true;
	    });

	    function findTabIndex(index) {
	      for (var i = 0; i < ctrl.tabs.length; i++) {
	        if (ctrl.tabs[i].index === index) {
	          return i;
	        }
	      }
	    }
	  }]).

	  directive('uibTabset', function () {
	    return {
	      transclude: true,
	      replace: true,
	      scope: {},
	      bindToController: {
	        active: '=?',
	        type: '@' },

	      controller: 'UibTabsetController',
	      controllerAs: 'tabset',
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	      },
	      link: function link(scope, element, attrs) {
	        scope.vertical = angular.isDefined(attrs.vertical) ?
	        scope.$parent.$eval(attrs.vertical) : false;
	        scope.justified = angular.isDefined(attrs.justified) ?
	        scope.$parent.$eval(attrs.justified) : false;
	        if (angular.isUndefined(attrs.active)) {
	          scope.active = 0;
	        }
	      } };

	  }).

	  directive('uibTab', ['$parse', function ($parse) {
	    return {
	      require: '^uibTabset',
	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || 'uib/template/tabs/tab.html';
	      },
	      transclude: true,
	      scope: {
	        heading: '@',
	        index: '=?',
	        classes: '@?',
	        onSelect: '&select', //This callback is called in contentHeadingTransclude
	        //once it inserts the tab's content into the dom
	        onDeselect: '&deselect' },

	      controller: function controller() {
	        //Empty controller so other directives can require being 'under' a tab
	      },
	      controllerAs: 'tab',
	      link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
	        scope.disabled = false;
	        if (attrs.disable) {
	          scope.$parent.$watch($parse(attrs.disable), function (value) {
	            scope.disabled = !!value;
	          });
	        }

	        if (angular.isUndefined(attrs.index)) {
	          if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	            scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {return t.index;})) + 1;
	          } else {
	            scope.index = 0;
	          }
	        }

	        if (angular.isUndefined(attrs.classes)) {
	          scope.classes = '';
	        }

	        scope.select = function () {
	          if (!scope.disabled) {
	            var index;
	            for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	              if (tabsetCtrl.tabs[i].tab === scope) {
	                index = i;
	                break;
	              }
	            }

	            tabsetCtrl.select(index);
	          }
	        };

	        tabsetCtrl.addTab(scope);
	        scope.$on('$destroy', function () {
	          tabsetCtrl.removeTab(scope);
	        });

	        //We need to transclude later, once the content container is ready.
	        //when this link happens, we're inside a tab heading.
	        scope.$transcludeFn = transclude;
	      } };

	  }]).

	  directive('uibTabHeadingTransclude', function () {
	    return {
	      restrict: 'A',
	      require: '^uibTab',
	      link: function link(scope, elm) {
	        scope.$watch('headingElement', function updateHeadingElement(heading) {
	          if (heading) {
	            elm.html('');
	            elm.append(heading);
	          }
	        });
	      } };

	  }).

	  directive('uibTabContentTransclude', function () {
	    return {
	      restrict: 'A',
	      require: '^uibTabset',
	      link: function link(scope, elm, attrs) {
	        var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

	        //Now our tab is ready to be transcluded: both the tab heading area
	        //and the tab content area are loaded.  Transclude 'em both.
	        tab.$transcludeFn(tab.$parent, function (contents) {
	          angular.forEach(contents, function (node) {
	            if (isTabHeading(node)) {
	              //Let tabHeadingTransclude know.
	              tab.headingElement = node;
	            } else {
	              elm.append(node);
	            }
	          });
	        });
	      } };


	    function isTabHeading(node) {
	      return node.tagName && (
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading');

	    }
	  });

	  angular.module('ui.bootstrap.timepicker', []).

	  constant('uibTimepickerConfig', {
	    hourStep: 1,
	    minuteStep: 1,
	    secondStep: 1,
	    showMeridian: true,
	    showSeconds: false,
	    meridians: null,
	    readonlyInput: false,
	    mousewheel: true,
	    arrowkeys: true,
	    showSpinners: true,
	    templateUrl: 'uib/template/timepicker/timepicker.html' }).


	  controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	    var selected = new Date(),
	    watchers = [],
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;

	    $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	    $element.removeAttr('tabindex');

	    this.init = function (ngModelCtrl_, inputs) {
	      ngModelCtrl = ngModelCtrl_;
	      ngModelCtrl.$render = this.render;

	      ngModelCtrl.$formatters.unshift(function (modelValue) {
	        return modelValue ? new Date(modelValue) : null;
	      });

	      var hoursInputEl = inputs.eq(0),
	      minutesInputEl = inputs.eq(1),
	      secondsInputEl = inputs.eq(2);

	      var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

	      if (mousewheel) {
	        this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	      }

	      var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	      if (arrowkeys) {
	        this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	      }

	      $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	      this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    };

	    var hourStep = timepickerConfig.hourStep;
	    if ($attrs.hourStep) {
	      watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
	        hourStep = +value;
	      }));
	    }

	    var minuteStep = timepickerConfig.minuteStep;
	    if ($attrs.minuteStep) {
	      watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
	        minuteStep = +value;
	      }));
	    }

	    var min;
	    watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
	      var dt = new Date(value);
	      min = isNaN(dt) ? undefined : dt;
	    }));

	    var max;
	    watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
	      var dt = new Date(value);
	      max = isNaN(dt) ? undefined : dt;
	    }));

	    var disabled = false;
	    if ($attrs.ngDisabled) {
	      watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
	        disabled = value;
	      }));
	    }

	    $scope.noIncrementHours = function () {
	      var incrementedSelected = addMinutes(selected, hourStep * 60);
	      return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	    };

	    $scope.noDecrementHours = function () {
	      var decrementedSelected = addMinutes(selected, -hourStep * 60);
	      return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	    };

	    $scope.noIncrementMinutes = function () {
	      var incrementedSelected = addMinutes(selected, minuteStep);
	      return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	    };

	    $scope.noDecrementMinutes = function () {
	      var decrementedSelected = addMinutes(selected, -minuteStep);
	      return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	    };

	    $scope.noIncrementSeconds = function () {
	      var incrementedSelected = addSeconds(selected, secondStep);
	      return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	    };

	    $scope.noDecrementSeconds = function () {
	      var decrementedSelected = addSeconds(selected, -secondStep);
	      return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	    };

	    $scope.noToggleMeridian = function () {
	      if (selected.getHours() < 12) {
	        return disabled || addMinutes(selected, 12 * 60) > max;
	      }

	      return disabled || addMinutes(selected, -12 * 60) < min;
	    };

	    var secondStep = timepickerConfig.secondStep;
	    if ($attrs.secondStep) {
	      watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
	        secondStep = +value;
	      }));
	    }

	    $scope.showSeconds = timepickerConfig.showSeconds;
	    if ($attrs.showSeconds) {
	      watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
	        $scope.showSeconds = !!value;
	      }));
	    }

	    // 12H / 24H mode
	    $scope.showMeridian = timepickerConfig.showMeridian;
	    if ($attrs.showMeridian) {
	      watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
	        $scope.showMeridian = !!value;

	        if (ngModelCtrl.$error.time) {
	          // Evaluate from template
	          var hours = getHoursFromTemplate(),minutes = getMinutesFromTemplate();
	          if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	            selected.setHours(hours);
	            refresh();
	          }
	        } else {
	          updateTemplate();
	        }
	      }));
	    }

	    // Get $scope.hours in 24H mode if valid
	    function getHoursFromTemplate() {
	      var hours = +$scope.hours;
	      var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
	      hours >= 0 && hours < 24;
	      if (!valid) {
	        return undefined;
	      }

	      if ($scope.showMeridian) {
	        if (hours === 12) {
	          hours = 0;
	        }
	        if ($scope.meridian === meridians[1]) {
	          hours = hours + 12;
	        }
	      }
	      return hours;
	    }

	    function getMinutesFromTemplate() {
	      var minutes = +$scope.minutes;
	      return minutes >= 0 && minutes < 60 ? minutes : undefined;
	    }

	    function getSecondsFromTemplate() {
	      var seconds = +$scope.seconds;
	      return seconds >= 0 && seconds < 60 ? seconds : undefined;
	    }

	    function pad(value) {
	      if (value === null) {
	        return '';
	      }

	      return angular.isDefined(value) && value.toString().length < 2 ?
	      '0' + value : value.toString();
	    }

	    // Respond on mousewheel spin
	    this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	      var isScrollingUp = function isScrollingUp(e) {
	        if (e.originalEvent) {
	          e = e.originalEvent;
	        }
	        //pick correct delta variable depending on event
	        var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	        return e.detail || delta > 0;
	      };

	      hoursInputEl.bind('mousewheel wheel', function (e) {
	        if (!disabled) {
	          $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	        }
	        e.preventDefault();
	      });

	      minutesInputEl.bind('mousewheel wheel', function (e) {
	        if (!disabled) {
	          $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	        }
	        e.preventDefault();
	      });

	      secondsInputEl.bind('mousewheel wheel', function (e) {
	        if (!disabled) {
	          $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	        }
	        e.preventDefault();
	      });
	    };

	    // Respond on up/down arrowkeys
	    this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	      hoursInputEl.bind('keydown', function (e) {
	        if (!disabled) {
	          if (e.which === 38) {// up
	            e.preventDefault();
	            $scope.incrementHours();
	            $scope.$apply();
	          } else if (e.which === 40) {// down
	            e.preventDefault();
	            $scope.decrementHours();
	            $scope.$apply();
	          }
	        }
	      });

	      minutesInputEl.bind('keydown', function (e) {
	        if (!disabled) {
	          if (e.which === 38) {// up
	            e.preventDefault();
	            $scope.incrementMinutes();
	            $scope.$apply();
	          } else if (e.which === 40) {// down
	            e.preventDefault();
	            $scope.decrementMinutes();
	            $scope.$apply();
	          }
	        }
	      });

	      secondsInputEl.bind('keydown', function (e) {
	        if (!disabled) {
	          if (e.which === 38) {// up
	            e.preventDefault();
	            $scope.incrementSeconds();
	            $scope.$apply();
	          } else if (e.which === 40) {// down
	            e.preventDefault();
	            $scope.decrementSeconds();
	            $scope.$apply();
	          }
	        }
	      });
	    };

	    this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	      if ($scope.readonlyInput) {
	        $scope.updateHours = angular.noop;
	        $scope.updateMinutes = angular.noop;
	        $scope.updateSeconds = angular.noop;
	        return;
	      }

	      var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
	        ngModelCtrl.$setViewValue(null);
	        ngModelCtrl.$setValidity('time', false);
	        if (angular.isDefined(invalidHours)) {
	          $scope.invalidHours = invalidHours;
	        }

	        if (angular.isDefined(invalidMinutes)) {
	          $scope.invalidMinutes = invalidMinutes;
	        }

	        if (angular.isDefined(invalidSeconds)) {
	          $scope.invalidSeconds = invalidSeconds;
	        }
	      };

	      $scope.updateHours = function () {
	        var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();

	        ngModelCtrl.$setDirty();

	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          selected.setMinutes(minutes);
	          if (selected < min || selected > max) {
	            invalidate(true);
	          } else {
	            refresh('h');
	          }
	        } else {
	          invalidate(true);
	        }
	      };

	      hoursInputEl.bind('blur', function (e) {
	        ngModelCtrl.$setTouched();
	        if ($scope.hours === null || $scope.hours === '') {
	          invalidate(true);
	        } else if (!$scope.invalidHours && $scope.hours < 10) {
	          $scope.$apply(function () {
	            $scope.hours = pad($scope.hours);
	          });
	        }
	      });

	      $scope.updateMinutes = function () {
	        var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();

	        ngModelCtrl.$setDirty();

	        if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	          selected.setHours(hours);
	          selected.setMinutes(minutes);
	          if (selected < min || selected > max) {
	            invalidate(undefined, true);
	          } else {
	            refresh('m');
	          }
	        } else {
	          invalidate(undefined, true);
	        }
	      };

	      minutesInputEl.bind('blur', function (e) {
	        ngModelCtrl.$setTouched();
	        if ($scope.minutes === null) {
	          invalidate(undefined, true);
	        } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	          $scope.$apply(function () {
	            $scope.minutes = pad($scope.minutes);
	          });
	        }
	      });

	      $scope.updateSeconds = function () {
	        var seconds = getSecondsFromTemplate();

	        ngModelCtrl.$setDirty();

	        if (angular.isDefined(seconds)) {
	          selected.setSeconds(seconds);
	          refresh('s');
	        } else {
	          invalidate(undefined, undefined, true);
	        }
	      };

	      secondsInputEl.bind('blur', function (e) {
	        if (!$scope.invalidSeconds && $scope.seconds < 10) {
	          $scope.$apply(function () {
	            $scope.seconds = pad($scope.seconds);
	          });
	        }
	      });

	    };

	    this.render = function () {
	      var date = ngModelCtrl.$viewValue;

	      if (isNaN(date)) {
	        ngModelCtrl.$setValidity('time', false);
	        $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      } else {
	        if (date) {
	          selected = date;
	        }

	        if (selected < min || selected > max) {
	          ngModelCtrl.$setValidity('time', false);
	          $scope.invalidHours = true;
	          $scope.invalidMinutes = true;
	        } else {
	          makeValid();
	        }
	        updateTemplate();
	      }
	    };

	    // Call internally when we know that model is valid.
	    function refresh(keyboardChange) {
	      makeValid();
	      ngModelCtrl.$setViewValue(new Date(selected));
	      updateTemplate(keyboardChange);
	    }

	    function makeValid() {
	      ngModelCtrl.$setValidity('time', true);
	      $scope.invalidHours = false;
	      $scope.invalidMinutes = false;
	      $scope.invalidSeconds = false;
	    }

	    function updateTemplate(keyboardChange) {
	      if (!ngModelCtrl.$modelValue) {
	        $scope.hours = null;
	        $scope.minutes = null;
	        $scope.seconds = null;
	        $scope.meridian = meridians[0];
	      } else {
	        var hours = selected.getHours(),
	        minutes = selected.getMinutes(),
	        seconds = selected.getSeconds();

	        if ($scope.showMeridian) {
	          hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	        }

	        $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
	        if (keyboardChange !== 'm') {
	          $scope.minutes = pad(minutes);
	        }
	        $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

	        if (keyboardChange !== 's') {
	          $scope.seconds = pad(seconds);
	        }
	        $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	      }
	    }

	    function addSecondsToSelected(seconds) {
	      selected = addSeconds(selected, seconds);
	      refresh();
	    }

	    function addMinutes(selected, minutes) {
	      return addSeconds(selected, minutes * 60);
	    }

	    function addSeconds(date, seconds) {
	      var dt = new Date(date.getTime() + seconds * 1000);
	      var newDate = new Date(date);
	      newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	      return newDate;
	    }

	    $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

	    $scope.incrementHours = function () {
	      if (!$scope.noIncrementHours()) {
	        addSecondsToSelected(hourStep * 60 * 60);
	      }
	    };

	    $scope.decrementHours = function () {
	      if (!$scope.noDecrementHours()) {
	        addSecondsToSelected(-hourStep * 60 * 60);
	      }
	    };

	    $scope.incrementMinutes = function () {
	      if (!$scope.noIncrementMinutes()) {
	        addSecondsToSelected(minuteStep * 60);
	      }
	    };

	    $scope.decrementMinutes = function () {
	      if (!$scope.noDecrementMinutes()) {
	        addSecondsToSelected(-minuteStep * 60);
	      }
	    };

	    $scope.incrementSeconds = function () {
	      if (!$scope.noIncrementSeconds()) {
	        addSecondsToSelected(secondStep);
	      }
	    };

	    $scope.decrementSeconds = function () {
	      if (!$scope.noDecrementSeconds()) {
	        addSecondsToSelected(-secondStep);
	      }
	    };

	    $scope.toggleMeridian = function () {
	      var minutes = getMinutesFromTemplate(),
	      hours = getHoursFromTemplate();

	      if (!$scope.noToggleMeridian()) {
	        if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	          addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	        } else {
	          $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	        }
	      }
	    };

	    $scope.blur = function () {
	      ngModelCtrl.$setTouched();
	    };

	    $scope.$on('$destroy', function () {
	      while (watchers.length) {
	        watchers.shift()();
	      }
	    });
	  }]).

	  directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
	    return {
	      require: ['uibTimepicker', '?^ngModel'],
	      controller: 'UibTimepickerController',
	      controllerAs: 'timepicker',
	      replace: true,
	      scope: {},
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	      },
	      link: function link(scope, element, attrs, ctrls) {
	        var timepickerCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	        if (ngModelCtrl) {
	          timepickerCtrl.init(ngModelCtrl, element.find('input'));
	        }
	      } };

	  }]);

	  angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

	  /**
	                                                                                                * A helper service that can parse typeahead's syntax (string provided by users)
	                                                                                                * Extracted to a separate service for ease of unit testing
	                                                                                                */.
	  factory('uibTypeaheadParser', ['$parse', function ($parse) {
	    //                      00000111000000000000022200000000000000003333333333333330000000000044000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function parse(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	          ' but got "' + input + '".');
	        }

	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1]) };

	      } };

	  }]).

	  controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
	  function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)

	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }

	    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
	      minLength = !newVal && newVal !== 0 ? 1 : newVal;
	    });

	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
	      isEditable = newVal !== false;
	    });

	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

	    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

	    var appendTo = attrs.typeaheadAppendTo ?
	    originalScope.$eval(attrs.typeaheadAppendTo) : null;

	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

	    //binding to a variable that indicates if dropdown is open
	    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

	    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

	    //INTERNAL VARIABLES

	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function $setModelValue(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	      ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	        return invokeModelSetter(scope, { $$$p: newValue });
	      }

	      return parsedModel.assign(scope, newValue);
	    };

	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

	    var hasFocus;

	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;

	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function () {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);

	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId });


	    var inputsContainer, hintInputElem;
	    //add read-only input to show hint
	    if (showHint) {
	      inputsContainer = angular.element('<div></div>');
	      inputsContainer.css('position', 'relative');
	      element.after(inputsContainer);
	      hintInputElem = element.clone();
	      hintInputElem.attr('placeholder', '');
	      hintInputElem.attr('tabindex', '-1');
	      hintInputElem.val('');
	      hintInputElem.css({
	        'position': 'absolute',
	        'top': '0px',
	        'left': '0px',
	        'border-color': 'transparent',
	        'box-shadow': 'none',
	        'opacity': 1,
	        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
	        'color': '#999' });

	      element.css({
	        'position': 'relative',
	        'vertical-align': 'top',
	        'background-color': 'transparent' });

	      inputsContainer.append(hintInputElem);
	      hintInputElem.after(element);
	    }

	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx, evt)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position',
	      'assign-is-open': 'assignIsOpen(isOpen)',
	      debounce: 'debounceUpdate' });

	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }

	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }

	    var resetHint = function resetHint() {
	      if (showHint) {
	        hintInputElem.val('');
	      }
	    };

	    var resetMatches = function resetMatches() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	      resetHint();
	    };

	    var getMatchId = function getMatchId(index) {
	      return popupId + '-option-' + index;
	    };

	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function (index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });

	    var inputIsExactMatch = function inputIsExactMatch(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }

	      return false;
	    };

	    var getMatchesAsync = function getMatchesAsync(inputValue, evt) {
	      var locals = { $viewValue: inputValue };
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;

	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i] });

	            }

	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();

	            element.attr('aria-expanded', true);

	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function () {
	                  scope.select(0, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(0, evt);
	              }
	            }

	            if (showHint) {
	              var firstLabel = scope.matches[0].label;
	              if (angular.isString(inputValue) &&
	              inputValue.length > 0 &&
	              firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
	                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
	              } else {
	                hintInputElem.val('');
	              }
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function () {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };

	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).on('resize', fireRecalculating);
	      $document.find('body').on('scroll', fireRecalculating);
	    }

	    // Declare the debounced function outside recalculating for
	    // proper debouncing
	    var debouncedRecalculate = $$debounce(function () {
	      // if popup is visible
	      if (scope.matches.length) {
	        recalculatePosition();
	      }

	      scope.moveInProgress = false;
	    }, eventDebounceTime);

	    // Default progress type
	    scope.moveInProgress = false;

	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }

	      debouncedRecalculate();
	    }

	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }

	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;

	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;

	    var scheduleSearchWithTimeout = function scheduleSearchWithTimeout(inputValue) {
	      timeoutPromise = $timeout(function () {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };

	    var cancelPreviousTimeout = function cancelPreviousTimeout() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };

	    resetMatches();

	    scope.assignIsOpen = function (isOpen) {
	      isOpenSetter(originalScope, isOpen);
	    };

	    scope.select = function (activeIdx, evt) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;

	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);

	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals),
	        $event: evt });


	      resetMatches();

	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function () {element[0].focus();}, 0, false);
	      }
	    };

	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.on('keydown', function (evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }

	      /**
	         * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	         * or
	         * shift + tab is pressed to bring focus to the previous element
	         * then clear the results
	         */
	      if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13) || evt.which === 9 && !!evt.shiftKey) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }

	      evt.preventDefault();
	      var target;
	      switch (evt.which) {
	        case 9:
	        case 13:
	          scope.$apply(function () {
	            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	              $$debounce(function () {
	                scope.select(scope.activeIdx, evt);
	              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	            } else {
	              scope.select(scope.activeIdx, evt);
	            }
	          });
	          break;
	        case 27:
	          evt.stopPropagation();

	          resetMatches();
	          scope.$digest();
	          break;
	        case 38:
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	          target = popUpEl.find('li')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        case 40:
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	          target = popUpEl.find('li')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;}

	    });

	    element.bind('focus', function (evt) {
	      hasFocus = true;
	      if (minLength === 0 && !modelCtrl.$viewValue) {
	        $timeout(function () {
	          getMatchesAsync(modelCtrl.$viewValue, evt);
	        }, 0);
	      }
	    });

	    element.bind('blur', function (evt) {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function () {
	          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
	            $$debounce(function () {
	              scope.select(scope.activeIdx, evt);
	            }, scope.debounceUpdate.blur);
	          } else {
	            scope.select(scope.activeIdx, evt);
	          }
	        });
	      }
	      if (!isEditable && modelCtrl.$error.editable) {
	        modelCtrl.$viewValue = '';
	        element.val('');
	      }
	      hasFocus = false;
	      selected = false;
	    });

	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function dismissClickHandler(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          scope.$digest();
	        }
	      }
	    };

	    $document.on('click', dismissClickHandler);

	    originalScope.$on('$destroy', function () {
	      $document.off('click', dismissClickHandler);
	      if (appendToBody || appendTo) {
	        $popup.remove();
	      }

	      if (appendToBody) {
	        angular.element($window).off('resize', fireRecalculating);
	        $document.find('body').off('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();

	      if (showHint) {
	        inputsContainer.remove();
	      }
	    });

	    var $popup = $compile(popUpEl)(scope);

	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendTo) {
	      angular.element(appendTo).eq(0).append($popup);
	    } else {
	      element.after($popup);
	    }

	    this.init = function (_modelCtrl, _ngModelOptions) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = _ngModelOptions;

	      scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function (inputValue) {
	        hasFocus = true;

	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }

	        if (isEditable) {
	          return inputValue;
	        }

	        if (!inputValue) {
	          // Reset in case user had typed something previously.
	          modelCtrl.$setValidity('editable', true);
	          return null;
	        }

	        modelCtrl.$setValidity('editable', false);
	        return undefined;
	      });

	      modelCtrl.$formatters.push(function (modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};

	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }

	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        }

	        //it might happen that we don't have enough info to properly render input value
	        //we need to check for this situation and simply return model value if we can't apply custom formatting
	        locals[parserResult.itemName] = modelValue;
	        candidateViewValue = parserResult.viewMapper(originalScope, locals);
	        locals[parserResult.itemName] = undefined;
	        emptyViewValue = parserResult.viewMapper(originalScope, locals);

	        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	      });
	    };
	  }]).

	  directive('uibTypeahead', function () {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
	      link: function link(originalScope, element, attrs, ctrls) {
	        ctrls[2].init(ctrls[0], ctrls[1]);
	      } };

	  }).

	  directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&',
	        assignIsOpen: '&',
	        debounce: '&' },

	      replace: true,
	      templateUrl: function templateUrl(element, attrs) {
	        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
	      },
	      link: function link(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;

	        scope.isOpen = function () {
	          var isDropdownOpen = scope.matches.length > 0;
	          scope.assignIsOpen({ isOpen: isDropdownOpen });
	          return isDropdownOpen;
	        };

	        scope.isActive = function (matchIdx) {
	          return scope.active === matchIdx;
	        };

	        scope.selectActive = function (matchIdx) {
	          scope.active = matchIdx;
	        };

	        scope.selectMatch = function (activeIdx, evt) {
	          var debounce = scope.debounce();
	          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
	            $$debounce(function () {
	              scope.select({ activeIdx: activeIdx, evt: evt });
	            }, angular.isNumber(debounce) ? debounce : debounce['default']);
	          } else {
	            scope.select({ activeIdx: activeIdx, evt: evt });
	          }
	        };
	      } };

	  }]).

	  directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '=' },

	      link: function link(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function (tplContent) {
	          var tplEl = angular.element(tplContent.trim());
	          element.replaceWith(tplEl);
	          $compile(tplEl)(scope);
	        });
	      } };

	  }]).

	  filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');

	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }

	    function containsHtml(matchItem) {
	      return (/<.*>/g.test(matchItem));
	    }

	    return function (matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);

	  angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/accordion/accordion-group.html",
	    "<div class=\"panel\" ng-class=\"panelClass || 'panel-default'\">\n" +
	    "  <div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "    <h4 class=\"panel-title\">\n" +
	    "      <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "    </h4>\n" +
	    "  </div>\n" +
	    "  <div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "    <div class=\"panel-body\" ng-transclude></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/accordion/accordion.html",
	    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	  }]);

	  angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/alert/alert.html",
	    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
	    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "        <span aria-hidden=\"true\">&times;</span>\n" +
	    "        <span class=\"sr-only\">Close</span>\n" +
	    "    </button>\n" +
	    "    <div ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/carousel/carousel.html",
	    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
	    "  <div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\">\n" +
	    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "    <span class=\"sr-only\">previous</span>\n" +
	    "  </a>\n" +
	    "  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\">\n" +
	    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "    <span class=\"sr-only\">next</span>\n" +
	    "  </a>\n" +
	    "  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "    </li>\n" +
	    "  </ol>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/carousel/slide.html",
	    "<div ng-class=\"{\n" +
	    "    'active': active\n" +
	    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/datepicker/datepicker.html",
	    "<div class=\"uib-datepicker\" ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	    "  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n" +
	    "  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n" +
	    "  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/datepicker/day.html",
	    "<table class=\"uib-daypicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	  }]);

	  angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/datepicker/month.html",
	    "<table class=\"uib-monthpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	  }]);

	  angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/datepicker/popup.html",
	    "<div>\n" +
	    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "    <li ng-transclude></li>\n" +
	    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "      <span class=\"btn-group pull-left\">\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "      </span>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "    </li>\n" +
	    "  </ul>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/datepicker/year.html",
	    "<table class=\"uib-yearpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	  }]);

	  angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/modal/backdrop.html",
	    "<div class=\"modal-backdrop\"\n" +
	    "     uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/modal/window.html",
	    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
	    "    uib-modal-animation-class=\"fade\"\n" +
	    "    modal-in-class=\"in\"\n" +
	    "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" +
	    "    <div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/pager/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	  }]);

	  angular.module("uib/template/pagination/pager.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/pagination/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	  }]);

	  angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/pagination/pagination.html",
	    "<ul class=\"pagination\">\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	  }]);

	  angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\"\n" +
	    "    uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/popover/popover-html.html",
	    "<div class=\"popover\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/popover/popover-template.html",
	    "<div class=\"popover\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\"\n" +
	    "        uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/popover/popover.html",
	    "<div class=\"popover\"\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	  }]);

	  angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	  }]);

	  angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/tabs/tab.html",
	    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
	    "  <a href ng-click=\"select()\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	  }]);

	  angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\"\n" +
	    "         ng-repeat=\"tab in tabset.tabs\"\n" +
	    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	  }]);

	  angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/timepicker/timepicker.html",
	    "<table class=\"uib-timepicker\">\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	  }]);

	  angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/typeahead/typeahead-match.html",
	    "<a href\n" +
	    "   tabindex=\"-1\"\n" +
	    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
	    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
	    "");
	  }]);

	  angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
	    $templateCache.put("uib/template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	  }]);
	  angular.module('ui.bootstrap.carousel').run(function () {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');angular.$$uibCarouselCss = true;});
	  angular.module('ui.bootstrap.position').run(function () {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll;}</style>');angular.$$uibPositionCss = true;});
	  angular.module('ui.bootstrap.datepicker').run(function () {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}.uib-left,.uib-right{width:100%}</style>');angular.$$uibDatepickerCss = true;});
	  angular.module('ui.bootstrap.tooltip').run(function () {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>');angular.$$uibTooltipCss = true;});
	  angular.module('ui.bootstrap.timepicker').run(function () {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>');angular.$$uibTimepickerCss = true;});
	  angular.module('ui.bootstrap.typeahead').run(function () {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');angular.$$uibTypeaheadCss = true;});

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var angular = __webpack_require__(20).ng,
	    utils = __webpack_require__(20).utils;

	    var migrate = {
	        directivesList: [],
	        names: {
	            '$uibPosition': '$position',
	            'UibDateParser': 'dateParser',
	            'uibTabHeadingTransclude': 'tabHeadingTransclude',
	            'uibDatepickerPopupConfig': 'datepickerPopupConfig',
	            'uibDropdownConfig': 'dropdownConfig' },

	        overrideAngularMethods: ['directive', 'provider', 'factory', 'service', 'filter', 'constant'],
	        overrideDirectivesList: ['uibDatepicker', 'uibDaypicker', 'uibMonthpicker', 'uibYearpicker', 'uibDatepickerPopup', 'uibDatepickerPopupWrap', 'uibDropdown', 'uibDropdownToggle', 'uibTabset', 'uibTab', 'uibTabContentTransclude'],
	        wrapAttributes: ['collapse', 'btnRadio', 'tabContentTransclude'],
	        wrapAttributesByCompile: ['tooltip', 'tooltipTemplate', 'tooltipHtml', 'popoverTemplate', 'popoverHtml', 'popover'],
	        addPrefix: function addPrefix(name) {
	            return 'uib' + name.charAt(0).toUpperCase() + name.slice(1);
	        },
	        removePrefix: function removePrefix(name) {
	            if (!name) {
	                return name;
	            }

	            if (Array.isArray(name)) {
	                return name.map(migrate.removePrefix);
	            }

	            return name.replace(/^(\??\^?)uib([A-Z])/, function (match, fnPrefix, char) {
	                return fnPrefix + char.toLowerCase();
	            });
	        } };


	    var angularModule = angular.module;
	    angular.module = function (name) {
	        if (!~name.indexOf('ui.bootstrap')) {
	            return angularModule.apply(this, arguments);
	        }

	        var createdModule = angularModule.apply(this, arguments),
	        memo = {};

	        utils.forEach(migrate.overrideAngularMethods, function (fnName) {
	            memo[fnName] = createdModule[fnName];

	            createdModule[fnName] = function (name, factoryFunction) {
	                memo[fnName].call(this, name, factoryFunction);
	                if (fnName === 'directive' && !~migrate.overrideDirectivesList.indexOf(name)) {
	                    migrate.directivesList.push(migrate.names[name] = migrate.removePrefix(name));
	                }

	                if (migrate.names[name]) {
	                    memo[fnName].call(this, migrate.names[name], factoryFunction);
	                }

	                return createdModule;
	            };
	        });

	        return createdModule;
	    };

	    // @ngInject
	    module.exports = function config($provide) {
	        utils.forEach(migrate.directivesList, function (directiveName) {
	            $provide.decorator(directiveName + 'Directive', ['$delegate', function ($delegate) {
	                var prefixedDirectiveName = migrate.addPrefix(directiveName);
	                utils.deprecate(directiveName + ' directive is deprecated. Use ' + prefixedDirectiveName + ' instead.');

	                utils.forEach($delegate, function ($d) {
	                    $d.require = migrate.removePrefix($d.require);

	                    if (~migrate.wrapAttributes.indexOf(directiveName)) {
	                        var $dLink = $d.link;
	                        $d.compile = function () {
	                            return function (scope, element, attrs) {
	                                attrs[prefixedDirectiveName] = attrs[directiveName];
	                                return $dLink.apply(this, arguments);
	                            };
	                        };
	                    }

	                    if (~migrate.wrapAttributesByCompile.indexOf(directiveName)) {
	                        var $dCompile = $d.compile;
	                        $d.compile = function () {
	                            var $dLink = $dCompile.apply($d, arguments);

	                            return function (scope, element, attrs) {
	                                attrs[prefixedDirectiveName] = attrs[directiveName];
	                                return $dLink.apply(this, arguments);
	                            };
	                        };
	                    }

	                });

	                return $delegate;
	            }]);
	        });
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.input-overflow';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(24));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var angular = __webpack_require__(20).ng;

	    /** @ngInject */
	    exports.lpInputOverflow = function ($timeout) {

	        function $getWrapper(fontSize) {
	            return angular.element(
	            '<div class="lp-input-overflow">' +
	            '<div class="lp-input-overflow-indicator">' +
	            '<span class="lp-input-overflow-elipsis">...</span>' +
	            '</div>' +
	            '<span class="lp-input-overflow-input-text" style="font-size: ' + fontSize + '"></span>' +
	            '</div>');

	        }

	        return {
	            require: 'ngModel',
	            link: function link(scope, element, attrs, ngModelCtrls) {

	                var fontSize = element.css('font-size'),
	                $wrapper = element.after($getWrapper(fontSize)).next().append(element),
	                $span = $wrapper.find('.lp-input-overflow-input-text'),
	                $indicator = $wrapper.find('.lp-input-overflow-indicator');


	                function showIndicator() {

	                    var textWidth = $span.text(ngModelCtrls.$modelValue).width(),
	                    inputWidth = element.width();

	                    $indicator.toggleClass('inactive', textWidth < inputWidth);
	                }

	                function hideIndicator() {
	                    if (!$indicator.hasClass('inactive')) {
	                        $indicator.addClass('inactive');
	                        element.focus();
	                    }
	                }

	                // Listen events to show/hide indicator
	                element.on('blur', showIndicator);
	                element.on('click focus', hideIndicator);
	                $indicator.on('click', hideIndicator);

	                // Add a little delay for overflow check just in case
	                $timeout(showIndicator, 100);
	            } };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.amount';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    module.exports = base.
	    createModule(module.name, [
	    core.name]).

	    directive(__webpack_require__(27));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_26__;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    // @ngInject
	    exports.lpAmount = function (lpCoreI18n) {

	        var CLASS_AMOUNT_NEGATIVE = 'lp-amount-negative';
	        var CLASS_AMOUNT_POSITIVE = 'lp-amount-positive';

	        function templateFn() {
	            return '<span class="{{signClass}}">{{formattedAmount}}</span>';
	        }

	        function linkFn(scope, element, attrs) {
	            function formatAmount() {
	                var amount = parseFloat(scope.amount);
	                scope.signClass = amount < 0 ? CLASS_AMOUNT_NEGATIVE : CLASS_AMOUNT_POSITIVE;
	                scope.formattedAmount = lpCoreI18n.formatCurrency(amount, scope.currency);
	            }

	            scope.$watch('amount', formatAmount);
	            scope.$watch('currency', formatAmount);

	            scope.$on('$localeChangeSuccess', formatAmount);
	        }

	        return {
	            restrict: 'EA',
	            //replace: false, DO NOT USE REPLACE  ([DEPRECATED!], will be removed in next major release)
	            template: templateFn,
	            link: linkFn,
	            // bindToController: true 1.3
	            scope: {
	                'amount': '=lpAmount',
	                'currency': '=lpAmountCurrency' } };


	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.list';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    module.exports = base.
	    createModule(module.name, [
	    core.name]).

	    directive(__webpack_require__(29));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    // @ngInject
	    exports.lpList = function () {

	        var ng = window.angular;
	        var CLASS_LIST = 'list-group';

	        function templateFn() {
	            return [
	            '<div class="list">',
	            '</div>'].
	            join('');
	        }

	        function compileFn($element, $attr) {
	            // Create DOM.
	            var listEl = ng.element(templateFn()).
	            append($element.contents()) // transclude element contents
	            .addClass(CLASS_LIST);
	            $element.append(listEl);
	        }

	        return {
	            restrict: 'EA',
	            priority: Number.MAX_VALUE,
	            //replace: false, DO NOT USE REPLACE  ([DEPRECATED!], will be removed in next major release)
	            compile: compileFn,
	            // bindToController: true 1.3
	            scope: {} };

	    };

	    // @ngInject
	    exports.lpItem = function () {

	        var ng = window.angular;
	        var CLASS_LIST_ITEM = 'list-group-item clearfix';
	        var CLASS_LIST_CONTAINER = 'list-group-container';

	        function ctrlFn(ctrl, el, attr) {
	            ctrl.href = function () {
	                return attr.href || attr.ngHref;
	            };
	            ctrl.target = function () {
	                return attr.target || '_self';
	            };
	        }

	        function templateFn(isAnchor) {
	            return [
	            '<div',
	            isAnchor ? ' ng-href="{{href()}}" target="{{target()}}"' : '',
	            '>',
	            '</div>'].
	            join('');
	        }

	        function compileFn($element, $attrs) {
	            var isAnchor, itemEl;

	            // Create DOM.
	            isAnchor = ng.isDefined($attrs.href) || ng.isDefined($attrs.ngHref);

	            // If anchor item, (has href) use the anchor template.
	            itemEl = ng.element(templateFn(isAnchor));
	            itemEl.append($element.contents()); // transclude item contents.
	            itemEl.addClass(CLASS_LIST_ITEM);
	            $element.append(itemEl);

	            // Add class to the item element
	            $element.addClass(CLASS_LIST_CONTAINER);

	            return ctrlFn;
	        }

	        return {
	            restrict: 'EA',
	            compile: compileFn,
	            scope: true };

	    };

	    // @ngInject
	    exports.lpItemCell = function () {

	        var ng = window.angular;

	        function templateFn() {
	            return [
	            '<div>',
	            '</div>'].
	            join('');
	        }

	        // TODO: provide auto widths like flexbox.
	        function markupColumnWidths($element, $attrs) {
	            var supportedWidths = ['xs', 'sm', 'md', 'lg'];
	            var defaultWidth = ng.isDefined($attrs.width) ? $attrs.width : Math.floor(12 / $element.children().length);
	            ng.forEach(supportedWidths, function (widthType) {
	                var widthAttr = widthType + 'Width';
	                var width = ng.isDefined($attrs[widthAttr]) ? $attrs[widthAttr] : defaultWidth;
	                $element.addClass('col-' + widthType + '-' + width);
	            });
	        }

	        function compileFn($element, $attrs) {
	            var cellEl;

	            // Create DOM.
	            cellEl = ng.element(templateFn());
	            cellEl.append($element.contents()); // tranclude cell contents.

	            // Markup column widths.
	            markupColumnWidths($element, $attrs);

	            $element.append(cellEl);
	        }

	        return {
	            restrict: 'EA',
	            compile: compileFn,
	            scope: true };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		'use strict';

		module.name = 'ui.field';

		var base = __webpack_require__(20);
		var core = __webpack_require__(26);
		var utils = base.utils;
		// var responsive = require('../../responsive/scripts/main');

		module.exports = base.createModule(module.name, [
		core.name
		// responsive.name
		]).
		directive(__webpack_require__(31)).
		controller(__webpack_require__(33)).
		value('defaultErrorMessages', {
			'required': 'This field is required.' }).

		filter('newlines', function () {
			return function (text) {
				if (utils.isString(text)) {
					return text.replace(/\n/g, '<br/>');
				}
				return text;
			};
		});
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		'use strict';

		var base = __webpack_require__(20);
		var angular = base.ng;

		var lpResponsive = __webpack_require__(32);

		var tpl = {};
		var find = function find(el, query) {
			return angular.element(el && el.querySelector(query));
		};

		// @ngInject
		exports.lpField = function () {

			return {
				restrict: 'EA',
				replace: true,
				transclude: true,
				template: tpl.lpField,
				scope: {
					label: '@',
					tip: '@',
					help: '@',
					actionLabel: '@',
					action: '@' },

				controller: 'FieldController',
				link: function link(scope, element, attrs, modelCtrl, transcludeFn) {

					scope.extraControls = attrs.extraControls && attrs.extraControls === 'true';

					//manually process the transclusion
					transcludeFn(scope.$parent, function (clonedTranscludedContent) {

						//clear out empty content on nested widgets?
						var elementList = [];
						if (clonedTranscludedContent.length > 1) {
							for (var i = 0; i < clonedTranscludedContent.length; i++) {
								if (clonedTranscludedContent[i].nodeType === 1) {
									elementList.push(clonedTranscludedContent[i]);
								}
							}
						} else {
							elementList.push(clonedTranscludedContent[0]);
						}

						var field = angular.element(elementList[0]);

						// element.find('.field-area').prepend(field); // does not work withoout jQuery
						find(element[0], '.field-area').prepend(field);

						//if there are extra controls
						if (scope.extraControls) {
							var control = angular.element(elementList[1]);
							// element.find('.extra-control').prepend(control);
							find(element[0], '.extra-control').prepend(control);
						}
					});
				} };

		};

		// @ngInject
		exports.lpEnterPressed = function () {
			return {
				restrict: 'A',
				scope: true,
				link: function link(scope, elem, attrs) {
					elem.on('keydown', function (e) {
						//checks to see if ENTER was pressed
						if (e.which === 13) {
							e.preventDefault();
							scope.$apply(function () {
								scope.save(scope.model.value);
							});
						}
					});
				} };

		};





		// @ngInject
		exports.lpControl = function ($timeout, $sce, newlinesFilter) {

			// base.deprecated('please use lp-field=')
			//var TEMPLATE_PATH = '/scripts/components/field/templates/';

			// #TODO split it into multiple composable input field components
			function templateFn() {
				return tpl.lpControl;
			}

			return {
				restrict: 'EA',
				replace: true,
				transclude: true,
				template: templateFn,
				scope: {
					label: '@',
					tip: '@',
					validate: '&',
					loading: '=' },

				require: ['^lpField', '?ngModel'],
				link: function link(scope, element, attrs, ctrls) {
					var ngModelCtrl = ctrls[1],
					fieldCtrl = ctrls[0];

					scope.keepEdittingOpen = false;

					scope.readonly = angular.isDefined(attrs.readonly) ? scope.$parent.$eval(attrs.readonly) : false;

					//add keydown listener to open editting
					element.on('keydown', function (e) {
						if (e.which === 13 && !scope.editting) {
							scope.setEditMode(true);
						}
					});

					if (!ngModelCtrl) {
						scope.readonly = true;
						return;
					}

					var required = angular.isDefined(attrs.required) ? scope.$parent.$eval(attrs.required) : true;


					scope.type = attrs.type || 'text';
					if (scope.type === 'select' || scope.type === 'checkbox' || scope.type === 'select-multiple' || scope.type === 'radio') {
						scope.options = scope.$parent.$eval(attrs.options);
					}
					scope.model = {};

					var focusEl;
					var getFocusEl = function getFocusEl() {
						if (!focusEl) {
							focusEl = find(element[0], scope.type === 'select' || scope.type === 'select-multiple' ? 'select' :
							scope.type === 'textarea' ? 'textarea' : 'input');
						}
						if (focusEl.length > 1) {
							return focusEl[1];
						} else {
							return focusEl;
						}
					};

					scope.editting = false;
					scope.setEditMode = function (isEditting) {
						scope.editting = isEditting;

						if (scope.editting) {
							scope.model.value = angular.copy(ngModelCtrl.$modelValue);

							//small screen? don't auto focus
							if (!scope.keepEdittingOpen) {
								$timeout(function () {
									getFocusEl().focus();
								}, 0);
							}
						} else {
							fieldCtrl.clearErrors();
						}
					};


					$timeout(function () {
						lpResponsive.enable(element).rule({
							'max-width': 240,
							then: function then() {
								scope.keepEdittingOpen = true;
								scope.setEditMode(true);
							} }).
						rule({
							'min-width': 241,
							then: function then() {
								scope.keepEdittingOpen = false;
								scope.setEditMode(false);
							} });

					});

					scope.save = function (value) {
						fieldCtrl.clearErrors();

						// value = utils.escapeHtml(value);
						value = angular.element('<div>').text(value).html();

						var isValid = true,inputLength = value.length;

						// Check required
						if (required && inputLength < 1) {
							fieldCtrl.addError('required');
							return false;
						}

						// Custom validation
						if (isValid && attrs.validate) {
							isValid = scope.validate({ value: value });
							if (typeof isValid === 'string') {
								fieldCtrl.addError(isValid);
								isValid = false;
							}
						}

						if (isValid) {
							//is the viewport less than 200px? Don't close edit more
							if (!scope.keepEdittingOpen) {
								scope.setEditMode(false);
							}
							ngModelCtrl.$setViewValue(value);
							scope.model.text = $sce.trustAsHtml(scope.getText(value));
						}
					};

					scope.isChecked = function (value) {
						return ngModelCtrl.$modelValue.indexOf(value) > -1;
					};

					scope.toggleCheck = function (value) {
						var idx = scope.model.value.indexOf(value);
						if (idx > -1) {
							scope.model.value.splice(idx, 1);
						} else {
							scope.model.value.push(value);
						}
					};

					scope.getText = function (value) {
						var options = scope.options,i,n;

						if (scope.type === 'textarea') {
							value = newlinesFilter(value);
						} else if (scope.type === 'select' || scope.type === 'radio') {
							for (i = 0, n = options.length; i < n; i++) {
								if (options[i].value.toString() === value.toString()) {
									return options[i].text;
								}
							}
						} else if (scope.type === 'checkbox' || scope.type === 'select-multiple') {
							var text = [];
							for (i = 0, n = options.length; i < n; i++) {
								if (value.indexOf(options[i].value) > -1) {
									text.push(options[i].text);
								}
							}
							return text.join(', ');
						}

						return value ? value.toString().replace('<br/>', '\n') : ''; //fix to remove <br /> tag from textarea when editing is open
					};

					ngModelCtrl.$render = function () {
						scope.model.text = $sce.trustAsHtml(scope.getText(ngModelCtrl.$modelValue));
						scope.model.value = scope.getText(ngModelCtrl.$modelValue);
					};
				} };

		};




		tpl.lpField = [
		'<div class="lp-field form-group">',
		'	<label class="col-sm-3 control-label">',
		'		<span lp-i18n="{{label}}" ng-bind="label"></span> <i class="lp-icon lp-icon-info-sign" tooltip="{{tip}}" tooltip-append-to-body="true" ng-show="tip"></i>',
		'	</label>',
		'	<div class="col-sm-6 field-area">',
		'		<div ng-repeat="error in errorMessages" class="text-danger"><small ng-bind="error"></small></div>',
		'		<div class="lp-field-help" ng-show="help">',
		'			<small class="text-muted" lp-i18n="{{help}}" ng-bind="help"></small>',
		'		</div>',
		'	</div>',
		'	<div class="col-sm-3 no-padding extra-control">',
		'		<a ng-if="action" ng-href="{{action}}"><small>{{actionLabel || action}}</small></a>',
		'	</div>',
		'</div>'].
		join('\n');


		tpl.fieldFn = function (type) {
			return [
			'<div ng-switch-when="', type, '" class="input-group">',
			'	<input type="', type, '" ng-model="model.value" class="form-control" lp-enter-pressed="" />',
			tpl.inputGroupBtn,
			'</div>'].
			join('');

		};

		tpl.btnFn = function (className) {
			return [
			'<div class="' + className + '">',
			'	<button type="button" class="btn btn-default" ng-click="save(model.value)">',
			'		<i class="lp-icon lp-icon-ok-sign"></i>',
			'	</button>',
			'	<button type="button" class="btn btn-default" ng-click="setEditMode(false)" ng-hide="keepEdittingOpen">',
			'		<i class="lp-icon lp-icon-remove"></i>',
			'	</button>',
			'</div>'].
			join('');

		};

		tpl.inputGroupBtn = tpl.btnFn('input-group-btn');

		tpl.inputGroupBtnRight = tpl.btnFn('btn-group pull-right');

		tpl.lpControl = [
		'<div class="lp-editable">',
		'	<div ng-hide="editting" class="has-feedback">',
		'		<input type="input" tabindex="-1" ng-model="model.text" class="form-control" readonly="readonly" />',
		'		<span class="lp-icon lp-icon-pencil pull-right lp-editable-edit" tabindex="0" ',
		'			ng-click="setEditMode(true)" ng-hide="readonly || loading" style="cursor:pointer;"></span>',
		'	</div>',

		'	<div ng-show="editting" ng-switch on="type">',

		// TEXT INPUT
		tpl.fieldFn('text'),

		// NUMBER INPUT
		tpl.fieldFn('number'),

		// TEL INPUT
		tpl.fieldFn('tel'),

		// EMAIL INPUT
		tpl.fieldFn('email'),

		// URL INPUT
		tpl.fieldFn('url'),

		// TEXTAREA
		'	<div ng-switch-when="textarea">',
		'		<textarea ng-model="model.value" class="form-control" rows="3" lp-enter-pressed=""></textarea>',
		tpl.inputGroupBtnRight,
		'	</div>',

		// SELECT
		'	<div ng-switch-when="select" class="input-group">',
		'		<select ng-model="model.value" class="form-control" ng-options="option.value as option.text for option in options"></select>',
		tpl.inputGroupBtn,
		'	</div>',

		// SELECT MULTIPLE
		'	<div ng-switch-when="select-multiple" class="input-group">',
		'		<select ng-model="model.value" multiple="multiple" class="form-control" ng-options="option.value as option.text for option in options"></select>',
		'		<span type="button" class="input-group-addon" ng-click="save(model.value)"><i class="lp-icon lp-icon-ok-sign"></i></span>',
		'		<span class="input-group-addon" ng-hide="keepEdittingOpen" ng-click="setEditMode(false)"><span class="lp-icon lp-icon-remove"></span></span>',
		'	</div>',

		// CHECKBOX
		'	<div ng-switch-when="checkbox">',
		'		<div class="btn-group pull-right">',
		'			<button type="button" class="btn btn-default" ng-click="save(model.value)"><i class="lp-icon lp-icon-ok-sign"></i></button>',
		'		</div>',
		'		<div class="checkbox" ng-repeat="option in options">',
		'			<label><input type="checkbox" value="{{option.value}}" ng-checked="isChecked(option.value)" ',
		'					ng-click="toggleCheck(option.value)"> {{option.text}}</label>',
		'		</div>',
		'	</div>',

		// RADIO
		'	<div ng-switch-when="radio">',
		tpl.inputGroupBtnRight,
		'		<div ng-repeat="option in options">',
		'			<div lp-custom-radio="" value="{{option.value}}" ng-model="model.value">',
		'				{{option.text}}',
		'			</div>',
		'		</div>',
		'	</div>',

		'	</div>',
		'</div>'].
		join('\n');




	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /* eslint-disable*/
	/**
	                                   * <p>Launchpad responsive library, allows you to apply responsive behaviors to widgets and other DOM element by
	                                   * applying CSS media query style rules to an HTML element.
	                                   *
	                                   * <p>This module is packaged as an AMD module, and should be include using the <i>define</i> syntax.
	                                   *
	                                   * @module responsive
	                                   * @exports Responsive
	                                   * @author philip@backbase.com, nikos@backbase.com
	                                   * @copyright Backbase B.V, 2013
	                                   *
	                                   * @example
	                                   * //Changing the inner html of a widget based on its size:
	                                   *
	                                   * //amd define imports the responsive module
	                                   * define('launchpad/lib/responsive', function(responsive) {
	                                   *
	                                   *   //Enable a dom element (the widget body) as responsive
	                                   *   var responsive = Responsive.enable(widget.body);
	                                   *
	                                   *   //chain a set of rules
	                                   *   responsive
	                                   *     .rule({
	                                   *       'max-width': 100,
	                                   *       then: function(e) {
	                                   *         widget.body.innerHTML('&lt;p&gt;Small widget&lt;/p>');
	                                   *       }
	                                   *     }).rule({
	                                   *       'min-width': 101,
	                                   *       'max-width' 500,
	                                   *       then: function(e) {
	                                   *         widget.body.innerHTML('&lt;p&gt;Medium widget&lt;/p&gt;');
	                                   *       }
	                                   *    }).rule({
	                                   *       'min-width': 501  ,
	                                   *       then: function(e) {
	                                   *         widget.body.innerHTML('&lt;p&gt;Large widget&lt;/p&gt;');
	                                   *       }
	                                   *   });
	                                   *
	                                   * });
	                                   */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';

		var jQuery = window.jQuery;

		/**
	                              * How often should the element be polled to check for a size change
	                              * @const
	                              * @type {number}
	                              */
		var DEFAULT_SIZE_CHECK_INTERVAL = 150;

		/**
	                                         * Return if an element is visible.
	                                         *
	                                         * @param {DomElemetn} element
	                                         * @return bool
	                                         */
		var _isVisible = function _isVisible(element) {
			if (jQuery) {
				return jQuery(element).is(':visible');
			} else
			if (element[0]) {
				// Native element is visible.
				return element[0].offsetParent === null;
			}
		};

		/**
	     * Return element width.
	     *
	     * @param {DomElemetn} element
	     * @return int
	     */
		var _elementWidth = function _elementWidth(element) {
			if (jQuery) {
				return jQuery(element).width();
			} else
			if (element[0]) {
				// Native element width.
				return element[0].offsetWidth;
			}
		};

		/**
	     * Constructs a new Responsive instance which monitors the given html element and fires callbacks associated with
	     * rules if a rule's media query matches the html element's width
	     *
	     * @constructor
	     * @alias module:responsive
	     * @private
	     * @param {Object} element  An html element to monitor for size changes
	     */
		var Responsive = function Responsive(element) {

			this.element = element;
			this.checkSizeInterval = DEFAULT_SIZE_CHECK_INTERVAL;
			this.rules = [];
			this.lastWidth = 0;

			//when new rules are added this is true
			this.forceCheck = false;
		};

		/**
	     * Stop polling the this responsive instance's dom node for size changes
	     *
	     * @return {Object} Responsive
	     */
		Responsive.prototype.stop = function () {

			window.clearTimeout(this.checkSizeTimeout);
			return this;
		};

		/**
	     * Start/resume polling. (Polling starts automatically). Only use this if you have manually stopped polling
	     *
	     * @return {Object} Responsive
	     */
		Responsive.prototype.start = function () {

			this._checkForSizeChange();
			return this;
		};

		/**
	     * Adds a new rule to this responsive object
	     * A rule object may contain min width and/or max width properties and a callback function <i>then</i>. The <i>then</i>
	     * function will be invoked when it the becomes active with an event parameter which contains one
	     * property, the current width.
	     *
	     * @param {Object} rule A responsive rule object
	     *
	     * @returns {Responsive} The responsive object to allow chaining
	     */
		Responsive.prototype.rule = function (rule) {

			//convert to camel case for internal use
			if ('min-width' in rule) {
				rule.minWidth = rule['min-width'];
			}
			if ('max-width' in rule) {
				rule.maxWidth = rule['max-width'];
			}

			//parse values
			rule.minWidth = parseInt(rule.minWidth, 10);
			rule.maxWidth = parseInt(rule.maxWidth, 10);

			//don't add an empty rule
			//probably need some kind of console warning here
			if (typeof rule.minWidth === 'number' || typeof rule.maxWidth === 'number') {
				//default active
				rule.active = false;

				//add to rules array
				this.rules.push(rule);

				//forces the check interval to check for changes if a new rule has been added
				this.forceCheck = true;
			}

			// Do one time check when a new rule is added
			this._hasSizeChanged();

			return this;
		};

		/**
	     * The given callback function will be called whenever any rule is triggered
	     * @param {Function} callback A callback function, when invoked it will be passed an event argument containing details
	     *                          of the size change
	     *
	     */
		Responsive.prototype.any = function (callback) {

			this.anyFn = callback;
			return this;
		};

		/**
	     * The given callback function will be called whenever the element's width changes
	     * @param {Function} callback A callback function, when invoked it will be passed an event argument containing details
	     *                          of the size change
	     *
	     */
		Responsive.prototype.resize = function (callback) {

			this.resize = callback;
			return this;
		};

		/**
	     * Polling for detecting size changes
	     * @private
	     * @return {Object} Responsive
	     */
		Responsive.prototype._checkForSizeChange = function () {

			var self = this;

			//poll width for changes
			this.checkSizeTimeout = window.setTimeout(function () {
				self._hasSizeChanged();
				self._checkForSizeChange();
			}, this.checkSizeInterval);

			return this;
		};


		/**
	     * Check if size has changed
	     * @private
	     * @return {Object} Responsive
	     */
		Responsive.prototype._hasSizeChanged = function () {
			var newWidth = this._isWidthChanged();
			if (newWidth > 0) {
				this._checkRules(newWidth);
				if (typeof this.resize === 'function') {
					this.resize.call(this.element, {
						width: newWidth });

				}
			}

			return this;
		};

		/**
	     * If the size has changed returns the new width, otherwise returns 0
	     *
	     * @private
	     * @return {Number}
	     */
		Responsive.prototype._isWidthChanged = function () {

			var width = _elementWidth(this.element);

			var sizeChanged = width !== this.lastWidth && _isVisible(this.element);
			if (sizeChanged || this.forceCheck) {
				this.lastWidth = width;
				return width;
			} else {
				return 0;
			}
		};

		/**
	     * Iterates through the registered rules looking for inactive rules with media queries which match the current
	     * width
	     * @private
	     */
		Responsive.prototype._checkRules = function (width) {

			var self = this;
			var i,rule,len = this.rules.length;
			for (i = 0; i < len; i++) {
				rule = this.rules[i];
				var match =
				(!rule.minWidth || rule.minWidth && width >= rule.minWidth) && (
				!rule.maxWidth || rule.maxWidth && width <= rule.maxWidth);

				if (match && !rule.active) {
					var e = {
						width: width };


					if (typeof rule.then === 'function') {
						rule.then.call(this.element, e);
					}
					if (typeof self.anyFn === 'function') {
						self.anyFn.call(this.element, e);
					}
				}
				rule.active = match;
			}
		};

		/**
	     * Factory function which enables responsive behavior on a DOM element and returns a Responsive instance on which
	     * rules can be applied.
	     * @param element The DOM element to monitor for size changes
	     * @returns {Responsive} A responsive instance object
	     */
		Responsive.enable = function (element) {
			var responsive = new Responsive(element);
			responsive.start();
			return responsive;
		};

		// export
		module.exports = Responsive;

		// export to window for springboard (TODO: Refactor springboard).
		window.lp = window.lp || {};
		window.lp.responsive = Responsive;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';
		var base = __webpack_require__(20);
		// var utils = base.utils;
		var angular = base.ng;

		// @ngInject
		exports.FieldController = function ($scope, $templateCache, $sce, $attrs, $parse, defaultErrorMessages) {

			var self = this,getErrors,setErrors;

			$scope.errors = [];

			var errorMessages = angular.isDefined($attrs.errorMessages) ? angular.copy($scope.$parent.$eval($attrs.errorMessages)) : {};
			errorMessages = angular.extend({}, defaultErrorMessages, errorMessages);

			if ($attrs.errors) {
				getErrors = $parse($attrs.errors);
				setErrors = getErrors.assign;

				$scope.$parent.$watch(getErrors, function (errors) {
					$scope.errors = errors;
					$scope.setErrorMessages();
				}, true);

				$scope.$watch('errors', function (errors) {
					if (setErrors) {
						setErrors($scope.$parent, errors);
					}
				});
			}

			$scope.setErrorMessages = function () {
				var messages = [];
				if ($scope.errors) {
					for (var i = 0, n = $scope.errors.length; i < n; i++) {
						var error = $scope.errors[i];
						messages.push(self.getErrorMessage(error));
					}
				}
				$scope.errorMessages = messages;
			};

			this.getErrorMessage = function (error) {
				return errorMessages && errorMessages[error] ? errorMessages[error] : error;
			};

			this.addError = function (error) {
				$scope.errors.push(error);
			};

			this.clearErrors = function () {
				if ($scope.errors) {
					$scope.errors.length = 0;
				}
			};
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.responsive';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    var responsive = __webpack_require__(32);

	    module.exports = base.
	    createModule(module.name, [
	    core.name]).

	    constant('lpUIResponsiveConfig', {
	        classPattern: 'lp-{{size}}-size',
	        rules: [
	        { max: 200, size: 'tile' },
	        { min: 201, max: 350, size: 'small' },
	        { min: 351, size: 'large' }] }).


	    controller(__webpack_require__(35)).
	    directive(__webpack_require__(36)).
	    factory('lpUIResponsive', function () {
	        return responsive;
	    });
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var base = __webpack_require__(20);
	    var utils = base.utils;

	    // @ngInject
	    exports.ResponsiveController = function ($scope, $attrs, $parse, $timeout, lpUIResponsiveConfig, lpUIResponsive) {
	        var self = this,
	        setSize = !utils.isUndefined($attrs.lpSize) ? $parse($attrs.lpSize).assign : null,
	        resizeFn = utils.identity;

	        this.init = function (element) {
	            this.element = element;
	            this.responsive = lpUIResponsive.enable(element);

	            var rules = !utils.isUndefined($attrs.sizeRules) ? $scope.$eval($attrs.sizeRules) : lpUIResponsiveConfig.rules;
	            this.addRules(rules);

	            if ($attrs.lpOnResize) {
	                resizeFn = $parse($attrs.lpOnResize);
	                this.setResizeWatcher();
	            }
	        };

	        this.addRules = function (rules) {
	            utils.forEach(rules, function (rule) {
	                self.addRule(rule.min, rule.max, rule.size);
	            });
	        };

	        var expressionHandler;
	        if ($attrs.onSizeChange) {
	            expressionHandler = $parse($attrs.onSizeChange);
	        }

	        this.addRule = function (min, max, size) {
	            var rule = {};
	            if (min) {
	                rule['min-width'] = min;
	            }
	            if (max) {
	                rule['max-width'] = max;
	            }

	            utils.extend(rule, {
	                then: function then() {
	                    var oldSize = self.size;

	                    $timeout(function () {
	                        self.toggleClass(size, oldSize);
	                        self.size = size;
	                        if (expressionHandler) {
	                            expressionHandler($scope, { size: size });
	                        }
	                    });
	                } });


	            this.responsive.rule(rule);
	        };

	        this.toggleClass = function (newSize, oldSize) {
	            self.element.addClass(lpUIResponsiveConfig.classPattern.replace('{{size}}', newSize));
	            if (oldSize) {
	                self.element.removeClass(lpUIResponsiveConfig.classPattern.replace('{{size}}', oldSize));
	            }

	            if (setSize) {
	                setSize($scope, newSize);
	            }
	        };

	        var width = null;

	        this.setResizeWatcher = function () {
	            this.responsive.resize = function (object) {
	                if (object.width !== width) {
	                    width = object.width;
	                    $scope.$apply(function () {
	                        resizeFn($scope, { width: width });
	                    });
	                }
	            };
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    // @ngInject
	    exports.lpResponsive = function () {

	        return {
	            replace: false,
	            controller: 'ResponsiveController',
	            link: function link(scope, element, attrs, ctrl) {
	                ctrl.init(element);
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.wizard';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    module.exports = base.createModule(module.name, [
	    core.name]).

	    directive(__webpack_require__(38)).
	    controller(__webpack_require__(39));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    var utils = base.utils;

	    // @ngInject
	    exports.lpWizard = function () {
	        return {
	            restrict: 'A',
	            transclude: true,
	            replace: true,
	            scope: {
	                wizard: '=lpWizard',
	                title: '@title' },

	            controller: 'WizardController',
	            link: function link(scope, element, attrs) {

	                scope.wizard = scope.wizard || {};

	                scope.currentStepIndex = 0;
	                // create functions in the parent scope of directive

	                scope.wizard.nextStep = function () {
	                    if (scope.wizardSteps[scope.currentStepIndex + 1]) {
	                        scope.wizardSteps[++scope.currentStepIndex].active = true;
	                    }
	                };

	                scope.wizard.getActiveStep = function () {
	                    return scope.currentStepIndex + 1;
	                };

	                scope.wizard.previousStep = function () {
	                    if (scope.wizardSteps[scope.currentStepIndex - 1]) {
	                        scope.wizardSteps[--scope.currentStepIndex].active = true;
	                    }
	                };

	                scope.wizard.goToStep = function (index) {
	                    --index;

	                    if (scope.wizardSteps[index]) {
	                        scope.currentStepIndex = index;
	                        scope.wizardSteps[scope.currentStepIndex].active = true;
	                    }
	                };

	                // not needed if we passing wizard="wizard"
	                scope.$parent.$parent[attrs.nextStep] = scope.wizard.nextStep;
	                scope.$parent.$parent[attrs.getActiveStep] = scope.wizard.getActiveStep;
	                scope.$parent.$parent[attrs.previousStep] = scope.wizard.previousStep;
	                scope.$parent.$parent[attrs.goToStep] = scope.wizard.goToStep;

	            },
	            template: '<div class="wizard-wrapper">' +
	            '	<div class="panel panel-default wizard-header text-center" tabindex="0" aria-labelledby="{{wizardSteps[currentStepIndex].uniqueId}}">' +
	            '		<div class="panel-heading">' +
	            '			<h3 class="wizard-header-title" ng-show="title">{{title}}</h3>' +
	            '			<div class="clearfix wizard-steps text-center" role="navigation" ng-transclude></div>' +
	            '		</div>' +
	            '	</div>' +
	            '	<div>' +
	            '		<div class="wizard-views">' +
	            '			<div ng-repeat="step in wizardSteps" class="wizard-view" ng-show="step.active" lp-wizard-content-transclude="step"></div>' +
	            '		</div>' +
	            '	</div>' +
	            '</div>' };

	    };
	    // @ngInject
	    exports.lpWizardStep = function ($parse) {
	        return {
	            require: '^lpWizard',
	            restrict: 'A',
	            replace: true,
	            template: '<div class="wizard-step-container">' +
	            '	<i ng-if="stepIndex !== 1" class="glyphicon glyphicon-arrow-right pull-left wizard-step-arrow"></i>' +
	            '	<div class="wizard-step pull-left" ng-class="{\'wizard-active-step\': active}" lp-wizard-heading-transclude="">' +
	            '		<span class="wizard-step-number cursor-pointer" ng-click="goToStep(stepIndex)" ng-class="{\'wizard-step-number-active\': active, \'wizard-step-done\': completed, \'text-muted\': !completed && !active}">{{stepIndex}}</span>' +
	            '		<span id="{{uniqueId}}" class="wizard-step-heading visible-xs-block visible-sm-inline visible-md-inline visible-lg-inline" ng-class="{\'wizard-active-step\': active, \'hidden-sm hidden-xs\': !active,\'text-muted\': !completed && !active}">{{heading}}</span>' +
	            '	</div>' +
	            '</div>',
	            transclude: true,
	            scope: {
	                active: '=?',
	                heading: '@' },

	            controller: function controller() {
	            },
	            compile: function compile(element, attribs, transclude) {
	                return function postLink(scope, elm, attrs, wizardCtrl) {
	                    scope.uniqueId = 'wizardStep-' + wizardCtrl.instance++ + '-' + Math.floor(Math.random() * 10000);
	                    scope.stepIndex = wizardCtrl.instance;
	                    scope.$watch('active', function (active) {
	                        if (active) {
	                            wizardCtrl.select(scope);
	                        }
	                    });
	                    scope.goToStep = wizardCtrl.goToStep;
	                    wizardCtrl.addStep(scope);
	                    scope.$transcludeFn = transclude;
	                };
	            } };

	    };

	    // @ngInject
	    exports.lpWizardHeadingTransclude = function () {
	        return {
	            restrict: 'A',
	            require: '^lpWizardStep',
	            link: function link(scope, elm, attrs, wizardCtrl) {
	                scope.$watch('headingElement', function updateHeadingElement(heading) {
	                    if (heading) {
	                        elm.html('');
	                        elm.append(heading);
	                    }
	                });
	            } };

	    };

	    // @ngInject
	    exports.lpWizardContentTransclude = function () {
	        return {
	            restrict: 'A',
	            require: '^lpWizard',
	            link: function link(scope, elm, attrs) {
	                var step = scope.$eval(attrs.lpWizardContentTransclude);
	                step.$transcludeFn(step.$parent, function (contents) {
	                    utils.forEach(contents, function (node) {
	                        elm.append(node);
	                    });
	                });
	            } };

	    };


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';
	    var base = __webpack_require__(20);
	    var utils = base.utils;

	    // @ngInject
	    exports.WizardController = function ($scope) {
	        var ctrl = this,
	        wizardSteps = ctrl.wizardSteps = $scope.wizardSteps = [];
	        ctrl.instance = 0;

	        ctrl.select = function (selectedStep) {

	            utils.forEach(wizardSteps, function (step) {

	                step.active = false;
	                if (selectedStep.stepIndex > step.stepIndex) {
	                    step.completed = true;
	                } else {
	                    step.completed = false;
	                }
	            });
	            selectedStep.active = true;
	        };

	        ctrl.addStep = function addStep(step) {
	            wizardSteps.push(step);
	            if (wizardSteps.length === 1) {
	                step.active = true;
	            } else if (step.active) {
	                ctrl.select(step);
	            }
	        };

	        ctrl.goToStep = function (index) {
	            index--;
	            if (index < $scope.currentStepIndex) {
	                ctrl.select(wizardSteps[index]);
	                $scope.currentStepIndex = index;
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.progress-indicator';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    module.exports = base.createModule(module.name, [
	    core.name]).

	    directive(__webpack_require__(41));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.progressIndicator = function ($compile) {

	        var template =
	        '<div ng-show="showProgress" class="panel panel-default progress-indicator">' +
	        '<div class="panel-body">' +
	        '<p class="panel-message text-center {{customClasses}}"><i class="lp-icon lp-icon-spinner2 lp-spin loading-icon"></i></p>' +
	        '</div>' +
	        '</div>';

	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {

	                var watchExpression = typeof attrs['isLoading'] === 'undefined' ?
	                attrs['progressIndicator'] :
	                attrs['isLoading'];

	                var $scope = scope.$new(true, scope);

	                scope.$watch(attrs['customClasses'], function (newValue) {
	                    $scope.customClasses = newValue;
	                });

	                scope.$watch(watchExpression, function (newValue) {
	                    $scope.showProgress = newValue;
	                });

	                var initialize = function initialize() {
	                    element.wrap('<div class="progress-indicator-container"></div>');
	                    element.append($compile(template)($scope));
	                };

	                initialize();
	            } };


	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		'use strict';

		module.name = 'ui.input';

		var base = __webpack_require__(20);
		var core = __webpack_require__(26);

		var deps = [
		core.name];


		return base.createModule(module.name, deps).
		directive(__webpack_require__(43));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';

		function buildInputDirective(type, name) {

			// @ngInject
			return function () {

				function lpInputLink(ctrl, el, attrs) {
					ctrl.placeholder = attrs.placeholder;
					ctrl.label = attrs.label;

					ctrl.change = function change(event) {
						ctrl.onChange({ $event: event });
					};

					if ('autofocus' in attrs) {
						el.find('input').attr('autofocus', true);
					}

					if (type === 'text') {
						el.find('input').attr('autocorrect', 'autocorrect' in attrs ? 'on' : 'off');
						el.find('input').attr('spellcheck', 'spellcheck' in attrs);
					}
				}

				var tmpl =
				'<div class="form-group">' +
				'<label class="control-label" ng-show="label">{{label | translate}}</label>' +
				'<input ' +
				'type="' + type + '" ' +
				'name="' + name + '" ' +
				'lp-focus-id="{{focusId}}" ' +
				'placeholder="{{placeholder | translate}}" ' +
				'ng-disabled="disabled" ' +
				'ng-model="val" ' +
				'ng-change="change($event)" ' +
				'class="form-control"' +
				'autocapitalize="none"' +
				'/>' +
				'</div>';

				return {
					scope: {
						config: '=lpInput',
						val: '=ngModel',
						focusId: '@',
						disabled: '=ngDisabled',
						onChange: '&' },

					restrict: 'AE',
					link: lpInputLink,
					template: tmpl };

			};
		}

		exports.lpTextInput = buildInputDirective('text', 'username');
		exports.lpPasswordInput = buildInputDirective('password', 'password');
		exports.lpNumericInput = buildInputDirective('number', 'number');
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		'use strict';

		module.name = 'ui.checkbox';

		var base = __webpack_require__(20);
		var core = __webpack_require__(26);

		var deps = [
		core.name];


		return base.createModule(module.name, deps).
		directive(__webpack_require__(45));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		'use strict';

		// @ngInject
		exports.lpCheckbox = function () {

			function lpCheckboxCtrl(scope, el, attrs) {
				scope.label = attrs.label || '';
			}

			var tmpl = [
			'<label>',
			'<input type="checkbox" ng-model="checked" ng-disabled="disabled" /> {{label | translate}}',
			'</label>'].
			join('');

			function compileFn() {
				return lpCheckboxCtrl;
			}

			return {
				scope: {
					config: '=lpCheckbox',
					checked: '=ngModel',
					disabled: '=ngDisabled' },

				restrict: 'AE',
				require: '?^ngModel',
				compile: compileFn,
				template: tmpl };

		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		'use strict';

		module.name = 'ui.timer';

		var base = __webpack_require__(20);

		return base.createModule(module.name, []).
		directive(__webpack_require__(47));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.lpTimer = function () {

	        function lpTimerCtrl(scope, el, attrs) {

	            var timeoutId,now,end,
	            interval = 100,
	            millis = parseInt(attrs.millis, 10),
	            delayCountdown = parseInt(attrs.delayCountdown, 10) || 0,
	            countdownStart = false;

	            function getFormattedTime(t) {
	                return Math.ceil(t / 1000) + 's';
	            }

	            function tick() {

	                timeoutId = setTimeout(function () {
	                    var delta = end - new Date();
	                    var timePassed = millis + delayCountdown - delta;
	                    var startIn = delayCountdown - timePassed;

	                    scope.onTick({
	                        percentage: scope.percentage,
	                        time: delta,
	                        startIn: startIn });


	                    if (startIn > 0) {
	                        scope.percentage = 100;
	                        scope.formattedTime = getFormattedTime(millis);
	                        tick();
	                    } else
	                    if (delta > 0) {
	                        if (!countdownStart) {
	                            countdownStart = true;
	                            scope.onCountdownstart();
	                        }
	                        scope.percentage = delta / millis * 100;
	                        scope.formattedTime = getFormattedTime(delta);
	                        tick();
	                    } else
	                    {
	                        scope.percentage = 0;
	                        scope.formattedTime = '';
	                        scope.onFinish();
	                    }

	                    scope.$apply();
	                }, interval);
	            }

	            scope.run = function () {
	                if (scope.percentage === 100 || typeof scope.percentage === 'undefined') {
	                    now = +new Date();
	                    end = now + delayCountdown + millis;
	                    countdownStart = false;
	                    tick();
	                }
	            };

	            scope.pause = function () {
	                if (timeoutId) {
	                    clearTimeout(timeoutId);
	                }
	            };

	            scope.resume = tick;

	            scope.reset = function () {
	                scope.pause();
	                scope.animate = false;
	                scope.percentage = 100;
	                scope.formattedTime = getFormattedTime(millis);
	                scope.animate = true;
	            };

	            scope.reset();

	            if (attrs.autostart) {
	                scope.run();
	            }

	            scope.$on('timer-run', scope.run);
	            scope.$on('timer-pause', scope.pause);
	            scope.$on('timer-resume', scope.resume);
	            scope.$on('timer-reset', scope.reset);
	        }

	        var tmpl = [
	        '<div class="lp-timer">',
	        '<progressbar animate="animate" value="percentage" type="success"><b>{{formattedTime}}</b></progressbar>',
	        '</div>'].
	        join('');

	        function compileFn() {
	            return lpTimerCtrl;
	        }

	        return {
	            scope: {
	                config: '=lpTimer',
	                onTick: '&',
	                onCountdownstart: '&',
	                onFinish: '&' },

	            restrict: 'AE',
	            compile: compileFn,
	            template: tmpl };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.switcher';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    var deps = [
	    core.name];


	    return base.createModule(module.name, deps).
	    directive(__webpack_require__(49));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	                   * @ngdoc directive
	                   * @name lpEnableDisableToggle
	                   *
	                   * @description Implements simple two-positions switcher
	                   *
	                   * Changes state depending on parameter (boolean) passing into with directive parameter itself
	                   *
	                   * @param lp-enable-disable-toggle {=boolean} Required, switcher state variable
	                   * @param enabled-text-long {@string} Optional, 'on' text inside switcher for wide screens (default: Enabled)
	                   * @param enabled-text-short {@string} Optional, 'on' text inside switcher for mobile screens (default: On)
	                   * @param disabled-text-long {@string} Optional, 'off' text inside switcher for wide screens (default: Disabled)
	                   * @param disabled-text-short {@string} Optional, 'off' text inside switcher for mobile screens (default: Off)
	                   *
	                   * @param $templateCache
	                   * @param $timeout
	                   * @returns {{scope: {active: string}, restrict: string, template: *, link: Function}}
	                   */
	    // @ngInject
	    exports.lpEnableDisableToggle = function ($templateCache, $timeout) {
	        $templateCache.put('enable-disable-toggle.html',
	        '<div class="enable-disable-toggle-wrapper">' +
	        '<div class="enable-disable-slider {{ directiveAnimationClasses }}" ng-class="{\'is-disabled\': !active}">' +
	        '<div class="enable-disable-enabled">' +
	        '<div class="note note-text note-text-wide">{{ enabledTextLong | limitTo : 8 }}</div>' +
	        '<div class="note note-text note-text-short">{{ enabledTextShort | limitTo : 3 }}</div>' +
	        '</div>' +
	        '<i class="zipper left">&nbsp;</i>' +
	        '<i class="zipper right">&nbsp;</i>' +
	        '<div class="enable-disable-disabled">' +
	        '<div class="note note-text note-text-wide">{{ disabledTextLong | limitTo : 8 }}</div>' +
	        '<div class="note note-text note-text-short">{{ disabledTextShort | limitTo : 3 }}</div>' +
	        '</div>' +
	        '</div>' +
	        '</div>');


	        return {
	            scope: {
	                active: '=lpEnableDisableToggle' },

	            restrict: 'A',
	            template: $templateCache.get('enable-disable-toggle.html'),
	            link: function link($scope, el, attrs) {
	                // fill in configs we pass by attributes
	                $scope.enabledTextLong = attrs.enabledTextLong || 'Enabled';
	                $scope.disabledTextLong = attrs.disabledTextLong || 'Disabled';
	                $scope.enabledTextShort = attrs.enabledTextShort || 'On';
	                $scope.disabledTextShort = attrs.disabledTextShort || 'Off';

	                $scope.$watch('active', function (val, old) {
	                    if (val !== old) {
	                        $scope.directiveAnimationClasses = $scope.active ? 'animated slideInLeft' : 'animated slideInRight';
	                    } else {
	                        $scope.directiveAnimationClasses = '';
	                    }
	                    $timeout(function () {$scope.directiveAnimationClasses = '';}, 3500);
	                });
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.card';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);
	    var deps = [core.name];

	    module.exports = base.createModule(module.name, deps).
	    directive(__webpack_require__(51));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    exports.lpCard = function () {

	        function templateFn() {
	            return [
	            '<div>',
	            '<div class="panel panel-default">',
	            '<div class="panel-heading clearfix">',
	            '<h5 class="pull-left">{{title}}</h5>',
	            '<div class="buttons pull-right">' +
	            '<button ng-repeat="button in buttons" class="btn btn-default {{button.className}}" role="button" ' +
	            '        ng-click="button.onclick(data)" ' +
	            '        lp-i18n="{{button.label}}"></button>',
	            '</div>',
	            '</div>',
	            '<div class="panel-body" ng-transclude></div>',
	            '</div>'].
	            join('');
	        }

	        return {
	            restrict: 'AE',
	            transclude: true,
	            scope: {
	                data: '=',
	                title: '@',
	                buttons: '=' },

	            template: templateFn };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.focus';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(53)).
	    factory(__webpack_require__(54));

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    function focus(element) {
	        setTimeout(function () {
	            element.focus();

	            if (element.tagName === 'INPUT') {
	                element.select();
	            }
	        }, 50);
	    }

	    // @ngInject
	    exports.lpFocusOn = function ($interpolate) {
	        return {
	            link: function link(scope, element, attrs) {
	                var value = $interpolate(attrs.lpFocusOn)(scope);
	                scope.$on(value, function () {
	                    focus(element[0]);
	                });
	            } };

	    };

	    exports.lpFocusId = function () {
	        return {
	            link: function link(scope, element, attr) {
	                scope.$on('lpFocusId', function (e, name) {
	                    if (name === attr.lpFocusId) {
	                        focus(element[0]);
	                    }
	                });
	            } };

	    };

	    if (!('autofocus' in document.createElement('input'))) {
	        exports.autofocus = function () {
	            return {
	                link: function link(scope, element) {
	                    // IE8: Use timeout
	                    setTimeout(function () {
	                        element[0].focus();
	                    }, 100);
	                } };

	        };
	    }

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    exports.lpFocus = function ($rootScope, $timeout) {
	        return function (name) {
	            $timeout(function () {
	                $rootScope.$broadcast('lpFocusId', name);
	            }, 100);
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.nav-icon';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(56));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.navIcon = function () {

	        // Predefined icons
	        var icons = {
	            'arrow-left': 'chevron-left' };


	        return {
	            scope: true,
	            replace: true,
	            template: '<span class="glyphicon glyphicon-{{icon}}"></span>',
	            link: function link(scope, element, attrs) {

	                // Old deprecated definition uses setup like <div nav-icon="nav-icon" icon="'list'"></div>
	                // In this case fallback to icon attribute evaluation instead of default navIcon
	                if (attrs.icon) {
	                    scope.icon = scope.$eval(attrs.icon);
	                } else
	                if (attrs.navIcon !== 'nav-icon') {
	                    scope.icon = scope.$eval(attrs.navIcon);
	                }

	                // Check if scope.icon is predefined icon from the list of icons
	                if (scope.icon in icons) {
	                    scope.icon = icons[scope.icon];
	                }
	            } };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.aria';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(58)).
	    filter(__webpack_require__(59));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /** @ngInject */
	    exports.lpAriaNumber = function ($filter) {
	        function link(scope) {
	            scope.$watch('lpAriaNumber', function (val) {
	                scope.srNumber = $filter('lpAriaNumber')(val);
	            });
	        }

	        return {
	            restrict: 'A',
	            link: link,
	            scope: {
	                lpAriaNumber: '=' },

	            template:
	            '<span aria-hidden="true">{{lpAriaNumber}}</span>' +
	            '<span class="sr-only">{{srNumber}}</span>' };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    exports.lpAriaNumber = function () {
	        return function (input) {
	            return input ? String(input).split('').join(' ') : '';
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.scrolling-hook';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(61));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var angular = base.ng;
	    var utils = base.utils;

	    /** @ngInject */
	    exports.scrollingHook = function ($window) {

	        // Trying to avoid using jQuery. This is $(window).scrollTop() replacement
	        function getScrollTop() {
	            return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
	        }

	        return {
	            scope: {
	                className: '=scrollClass',
	                distance: '=scrollDistance',
	                hookCallback: '=' },

	            link: function link(scope, element, attrs) {

	                // Get current distance from top
	                var lastScrollTop = getScrollTop(),
	                className = scope.className;

	                var doClassChange = function doClassChange() {

	                    // New distance from top once scrolled
	                    var st = getScrollTop();

	                    if (st >= scope.distance) {

	                        if (lastScrollTop - st >= 5 || lastScrollTop <= 0) {
	                            // Scrolling up
	                            if (element.hasClass(className)) {
	                                element.removeClass(className);
	                            }
	                        } else
	                        if (st > lastScrollTop) {
	                            // Scrolling down
	                            if (!element.hasClass(className)) {
	                                element.addClass(className);
	                            }
	                        }
	                    } else
	                    {
	                        if (element.hasClass(className)) {
	                            // We are not low enough on the page, return to default setting
	                            element.removeClass(className);
	                        }
	                    }

	                    // Reset scrollTop to current pageYOffset
	                    lastScrollTop = st;

	                    if (scope.hookCallback) {
	                        scope.hookCallback(element);
	                    }
	                };

	                angular.element($window).on('scroll', utils.debounce(doClassChange, 10));

	            } };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.number-input';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(63));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    /** @ngInject */
	    exports.lpNumberInput = function () {
	        return {
	            scope: {
	                'lpMaxLength': '=' },

	            link: function link(scope, element, attrs) {

	                // set the min and max values
	                var maxValue = attrs.max || Number.MAX_VALUE,
	                minValue = attrs.min || -Number.MAX_VALUE;

	                // check for browser support of input type="number"
	                var numberInputSupported = element[0].getAttribute('type') === 'number' && element[0].type === 'number';

	                // set the max attribute depending on the length
	                var updateMaxValue = function updateMaxValue(value) {
	                    if (value) {
	                        maxValue = Math.pow(10, value) - 1;
	                        element.attr('max', maxValue);
	                    }
	                };

	                // set the max length, in case the browser doesn't support number input fields
	                var updateMaxLength = function updateMaxLength(value) {
	                    if (value) {
	                        element.attr('maxlength', value);
	                    }
	                };

	                // if lp-max-length is defined set the max value again
	                if (scope.lpMaxLength) {
	                    if (numberInputSupported) {
	                        updateMaxValue(scope.lpMaxLength);

	                        scope.$watch('lpMaxLength', function (newValue) {
	                            updateMaxValue(newValue);
	                        });
	                    } else {
	                        updateMaxLength(scope.lpMaxLength);

	                        scope.$watch('lpMaxLength', function (newValue) {
	                            updateMaxLength(newValue);
	                        });
	                    }
	                }

	                element.bind('keypress', function (event) {

	                    // Regular expression for numbers 0..9
	                    var digitRegex = new RegExp('(4[8-9]|5[0-7])'),
	                    isMinus = event.which === 45,
	                    digit = null,
	                    preValue,
	                    input = element[0];

	                    // if key pressed not a digit, backspace, delete, enter, tab or function key... block it
	                    if (!event.ctrlKey && !event.metaKey &&
	                    !/^(8|9|13|189|190|45)$/.test(event.keyCode) && !digitRegex.test(event.which) && !isMinus) {
	                        return false;
	                    }

	                    // if min value is 0 or higher, don't allow minus sign (ASCII code 45) to be entered
	                    if (minValue >= 0 && isMinus) {
	                        return false;
	                    }

	                    if (digitRegex.test(event.which) || isMinus) {

	                        digit = String.fromCharCode(event.which);

	                        var value = input.valueAsNumber;

	                        // Check only if it's the first chracter (this.value is "")
	                        if (isNaN(value) && !this.value) {

	                            // If minus is the very first character just don't validate
	                            if (!isMinus) {
	                                value = '';
	                            }
	                        }

	                        preValue = value || this.value;

	                        // Additional check for minus character to make sure it can only be the very first character
	                        if (isMinus && (preValue || String(value || this.value).match(/-/g).length)) {
	                            return false;
	                        }

	                        value = parseInt(preValue + digit, 10);

	                        // if new value out of the min..max range block the last key
	                        if (value < minValue || value > maxValue) {
	                            return false;
	                        }
	                    }
	                });
	            } };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.modal-dialog';

	    var base = __webpack_require__(20);

	    module.exports = base.createModule(module.name, []).
	    provider(__webpack_require__(65)).
	    directive(__webpack_require__(66));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';
	    var base = __webpack_require__(20);
	    var angular = base.ng;

	    exports.$modal = function () {
	        var $modalProvider = {
	            options: {
	                animation: true,
	                backdrop: true, //can also be false or 'static'
	                keyboard: true },

	            $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	            function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	                var $modal = {};

	                function getTemplatePromise(options) {
	                    return options.template ? $q.when(options.template) :
	                    $templateRequest(angular.isFunction(options.templateUrl) ?
	                    options.templateUrl() : options.templateUrl);
	                }

	                var promiseChain = null;
	                $modal.getPromiseChain = function () {
	                    return promiseChain;
	                };

	                $modal.open = function (modalOptions) {
	                    var modalResultDeferred = $q.defer();
	                    var modalOpenedDeferred = $q.defer();
	                    var modalClosedDeferred = $q.defer();
	                    var modalRenderDeferred = $q.defer();

	                    //prepare an instance of a modal to be injected into controllers and returned to a caller
	                    var modalInstance = {
	                        result: modalResultDeferred.promise,
	                        opened: modalOpenedDeferred.promise,
	                        closed: modalClosedDeferred.promise,
	                        rendered: modalRenderDeferred.promise,
	                        close: function close(result) {
	                            return $modalStack.close(modalInstance, result);
	                        },
	                        dismiss: function dismiss(reason) {
	                            return $modalStack.dismiss(modalInstance, reason);
	                        } };


	                    //merge and clean up options
	                    modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	                    modalOptions.resolve = modalOptions.resolve || {};
	                    modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

	                    //verify options
	                    if (!modalOptions.template && !modalOptions.templateUrl) {
	                        throw new Error('One of template or templateUrl options is required.');
	                    }

	                    var templateAndResolvePromise =
	                    $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);

	                    function resolveWithTemplate() {
	                        return templateAndResolvePromise;
	                    }

	                    // Wait for the resolution of the existing promise chain.
	                    // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	                    // Then add to $modalStack and resolve opened.
	                    // Finally clean up the chain variable if no subsequent modal has overwritten it.
	                    var samePromise;
	                    samePromise = promiseChain = $q.all([promiseChain]).
	                    then(resolveWithTemplate, resolveWithTemplate).
	                    then(function resolveSuccess(tplAndVars) {
	                        var providedScope = modalOptions.scope || $rootScope;

	                        var modalScope = providedScope.$new();
	                        modalScope.$close = modalInstance.close;
	                        modalScope.$dismiss = modalInstance.dismiss;

	                        modalScope.$on('$destroy', function () {
	                            if (!modalScope.$$uibDestructionScheduled) {
	                                modalScope.$dismiss('$uibUnscheduledDestruction');
	                            }
	                        });

	                        var ctrlInstance,ctrlLocals = {};

	                        //controllers
	                        if (modalOptions.controller) {
	                            ctrlLocals.$scope = modalScope;
	                            ctrlLocals.$modalInstance = modalInstance;
	                            angular.forEach(tplAndVars[1], function (value, key) {
	                                ctrlLocals[key] = value;
	                            });

	                            ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                            if (modalOptions.controllerAs) {
	                                if (modalOptions.bindToController) {
	                                    ctrlInstance.$close = modalScope.$close;
	                                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                                    angular.extend(ctrlInstance, providedScope);
	                                }

	                                modalScope[modalOptions.controllerAs] = ctrlInstance;
	                            }
	                        }

	                        $modalStack.open(modalInstance, {
	                            scope: modalScope,
	                            deferred: modalResultDeferred,
	                            renderDeferred: modalRenderDeferred,
	                            closedDeferred: modalClosedDeferred,
	                            content: tplAndVars[0],
	                            animation: modalOptions.animation,
	                            backdrop: modalOptions.backdrop,
	                            keyboard: modalOptions.keyboard,
	                            backdropClass: modalOptions.backdropClass,
	                            windowTopClass: modalOptions.windowTopClass,
	                            windowClass: modalOptions.windowClass,
	                            windowTemplateUrl: modalOptions.windowTemplateUrl,
	                            size: modalOptions.size,
	                            openedClass: modalOptions.openedClass,
	                            appendTo: modalOptions.appendTo });

	                        modalOpenedDeferred.resolve(true);

	                    }, function resolveError(reason) {
	                        modalOpenedDeferred.reject(reason);
	                        modalResultDeferred.reject(reason);
	                    })['finally'](function () {
	                        if (promiseChain === samePromise) {
	                            promiseChain = null;
	                        }
	                    });

	                    return modalInstance;
	                };

	                return $modal;
	            }] };



	        return $modalProvider;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    var $ = window.jQuery;
	    var be = window.be;
	    var bd = window.bd;

	    var getIceContent = function getIceContent(widget) {

	        var edit = function edit(wg) {
	            if (be && be.ice && be.ice.controller) {
	                wg.iceConfig = be.ice.config;
	                var templateUrl = String(wg.getPreference('templateUrl'));
	                if (templateUrl.match(/\/image\.html$/)) {
	                    templateUrl = templateUrl.replace(/\/image\.html$/, '/image-editorial.html');
	                }
	                return be.ice.controller.edit(wg, templateUrl).
	                then(function (dom) {
	                    return dom;
	                });
	            }
	        };

	        if (bd && bd.designMode === 'true') {
	            return edit(widget);
	        }
	    };

	    // @ngInject
	    exports.modalDialog = function (widget, $templateCache) {

	        $templateCache.put('$modalDialog.html',
	        '<div class="lp-modal modal" ng-show="show">' +
	        '    <div class="ng-modal-overlay" ng-click="hideModal()"></div>' +
	        '    <div class="modal-dialog" ng-style="dialogStyle" tabindex="-1">' +
	        '        <div class="modal-content" ng-transclude=""></div>' +
	        '    </div>' +
	        '</div>');

	        return {
	            restrict: 'AE',
	            scope: {
	                show: '=' },

	            replace: true, // Replace with the template below
	            transclude: true, // we want to insert custom content inside the directive
	            template: $templateCache.get('$modalDialog.html'),
	            link: function link(scope, element, attrs) {
	                scope.closable = attrs.closable ? scope.$parent.$eval(attrs.closable) : true;
	                scope.dialogStyle = {};
	                if (attrs.width) {
	                    scope.dialogStyle.width = attrs.width;
	                }
	                if (attrs.height) {
	                    scope.dialogStyle.height = attrs.height;
	                }

	                var bindCloseModal = function bindCloseModal() {
	                    $(element).find('.modal-close-button').on('click', function () {
	                        scope.hideModal();
	                        scope.$apply();
	                    });
	                };

	                if (attrs.isice && widget.getPreference('templateUrl')) {
	                    var c = getIceContent(widget);
	                    if (c) {
	                        c.then(function (dom) {
	                            $(element).find('.bp-g-include').html(dom);
	                            $(element).find('[contenteditable]').on('keypress keydown', function (e) {
	                                e.stopPropagation();
	                            });
	                            bindCloseModal();
	                        });
	                    } else {
	                        bindCloseModal();
	                    }
	                }

	                scope.hideModal = function () {
	                    scope.show = false;
	                };

	                scope.focusModal = function () {
	                    element.find('.modal-dialog').focus();
	                };

	                var escapeEvent = function escapeEvent(event) {
	                    if (event.keyCode === 27) {
	                        event.stopPropagation();
	                        event.preventDefault();

	                        scope.hideModal();
	                        scope.$apply();
	                    }
	                };
	                scope.$watch('show', function (newValue) {
	                    if (newValue) {
	                        element.bind('keydown.modalDialog', escapeEvent);
	                        scope.focusModal();
	                    } else {
	                        element.unbind('keydown.modalDialog', escapeEvent);
	                    }
	                });
	            } };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.smartsuggest';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    // Plugin needed for autosuggest
	    __webpack_require__(68);

	    var smartsuggestEngine = __webpack_require__(70);
	    var smartsuggestFormatter = __webpack_require__(76);

	    module.exports = base.
	    createModule(module.name, [
	    core.name,
	    smartsuggestEngine.name,
	    smartsuggestFormatter.name]);

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict"; /* eslint-disable */
	/**
	                                    *  Ajax Autocomplete for jQuery, version 1.2.7
	                                    *  (c) 2013 Tomas Kirda
	                                    *
	                                    *  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
	                                    *  For details, see the web site: http://www.devbridge.com/projects/autocomplete/jquery/
	                                    *
	                                    */

	/*jslint  browser: true, white: true, plusplus: true */
	/*global define, window, document, jQuery */

	// Expose plugin as an AMD module if AMD loader is present:
	(function (factory) {
		"use strict";
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Browser globals
			factory(window.jQuery);
		}
	})(function ($) {

		"use strict";


		var
		utils = function () {
			return {
				escapeRegExChars: function escapeRegExChars(value) {
					return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
				},
				createNode: function createNode(html) {
					var div = document.createElement("div");
					div.innerHTML = html;
					return div.firstChild;
				} };

		}(),

		keys = {
			ESC: 27,
			TAB: 9,
			RETURN: 13,
			LEFT: 37,
			UP: 38,
			RIGHT: 39,
			DOWN: 40 };


		function Autocomplete(el, options) {
			var noop = function noop() {},
			self = this,
			defaults = {
				autoSelectFirst: false,
				circularSelect: true,
				appendTo: "body",
				serviceUrl: null,
				lookup: null,
				onSelect: null,
				width: "auto",
				minChars: 1,
				maxHeight: 300,
				deferRequestBy: 0,
				params: {},
				formatResult: Autocomplete.formatResult,
				delimiter: null,
				zIndex: 9999,
				type: "GET",
				noCache: false,
				onSearchStart: noop,
				onSearchComplete: noop,
				onClear: noop,
				onChangeModel: noop,
				containerClass: "lp-autosuggest-suggestions",
				tabDisabled: true,
				dataType: "text",
				currentRequest: null,
				paramName: "query",
				transformResult: function transformResult(response) {
					return typeof response === "string" ? $.parseJSON(response) : response;
				} };


			// Shared variables:
			self.element = el;
			self.el = $(el);
			self.suggestions = [];
			self.badQueries = [];
			self.selectedIndex = -1;
			self.currentValue = self.element.value;
			self.intervalId = 0;
			self.cachedResponse = [];
			self.onChangeInterval = null;
			self.onChange = null;
			self.isLocal = false;
			self.suggestionsContainer = null;
			self.options = $.extend({}, defaults, options);
			self.classes = {
				selected: "lp-autosuggest-selected",
				suggestion: "lp-autosuggest-suggestion" };

			self.hint = null;
			self.hintValue = "";
			self.selection = null;

			// Initialize and set options:
			self.initialize();
			self.setOptions(options);
		}

		Autocomplete.utils = utils;

		$.Autocomplete = Autocomplete;

		Autocomplete.formatResult = function (suggestion, currentValue) {
			var pattern = "(" + utils.escapeRegExChars(currentValue) + ")";

			return suggestion.value.replace(new RegExp(pattern, "gi"), "<strong>$1<\/strong>");
		};

		Autocomplete.prototype = {

			killerFn: null,

			initialize: function initialize() {

				var self = this,
				suggestionSelector = "." + self.classes.suggestion,
				selected = self.classes.selected,
				options = self.options,
				container;

				// Remove autocomplete attribute to prevent native suggestions:
				self.element.setAttribute("autosuggest", "off");

				// Add aria attribute
				self.element.setAttribute("aria-autocomplete", "list");

				self.killerFn = function (e) {
					// Don't hide when field has focus
					if ($(e.target).closest("." + self.options.containerClass).length === 0 && !self.el.is(":focus")) {
						self.killSuggestions();
						self.disableKillerFn();
					}
				};

				self.suggestionsContainer = Autocomplete.utils.createNode('<div class="' + options.containerClass + '" style="position: absolute; display: none;"></div>');

				container = $(self.suggestionsContainer);

				container.appendTo(options.appendTo);

				// Only set width if it was provided:
				if (options.width !== "auto") {
					container.width(options.width);
				}

				// Listen for mouse over event on suggestions list:
				container.on("mouseover.autosuggest", suggestionSelector, function () {
					self.activate($(this).data("index"));
				});

				// Deselect active element when mouse leaves suggestions container:
				container.on("mouseout.autosuggest", function () {
					self.selectedIndex = -1;
					container.children("." + selected).removeClass(selected);
				});

				// Listen for click event on suggestions list:
				container.on("mousedown.autosuggest touchstart.autosuggest", suggestionSelector, function () {
					self.select($(this).data("index"));
					self.el.trigger('blur');
				});

				self.fixPosition();

				self.fixPositionCapture = function () {
					if (self.visible) {
						self.fixPosition();
					}
				};

				$(window).on("resize", self.fixPositionCapture);

				self.el.on("keydown.autosuggest", function (e) {self.onKeyPress(e);});
				self.el.on("keyup.autosuggest", function (e) {self.onKeyUp(e);});
				self.el.on("blur.autosuggest", function (e) {
					var delay;
					if (!e.isTrigger) {
						delay = setTimeout(function () {
							self.killerFn(e);
						}, 100);
					} else
					{
						clearTimeout(delay);
						self.killerFn(e);
					}
				});
				self.el.on("focus.autosuggest", function () {self.onFocus();});
				self.el.on("change.autosuggest", function (e) {self.onKeyUp(e);});
				self.el.on("toggle.autosuggest", function (e) {self.onToggle(e);});
			},

			onToggle: function onToggle() {
				if (this.visible) {
					this.el.blur();
				} else {
					this.el.focus();
				}
			},

			onBlur: function onBlur() {
				this.enableKillerFn();
			},

			setOptions: function setOptions(suppliedOptions) {
				var self = this,
				options = self.options;

				$.extend(options, suppliedOptions);

				self.isLocal = $.isArray(options.lookup);

				if (self.isLocal) {
					options.lookup = self.verifySuggestionsFormat(options.lookup);
				}

				// Adjust height, width and z-index:
				$(self.suggestionsContainer).css({
					"max-height": options.maxHeight + "px",
					"width": options.width + "px",
					"z-index": options.zIndex });

			},

			clearCache: function clearCache() {
				this.cachedResponse = [];
				this.badQueries = [];
			},

			clear: function clear() {
				this.clearCache();
				this.currentValue = "";
				this.suggestions = [];
			},

			disable: function disable() {
				this.disabled = true;
			},

			enable: function enable() {
				this.disabled = false;
			},

			changeModel: function changeModel() {
				var self = this;
				self.options.onChangeModel.call(self.element);
			},

			fixPosition: function fixPosition() {
				var self = this,
				offset;

				// Don't adjsut position if custom container has been specified:
				if (self.options.appendTo !== "body") {
					return;
				}

				offset = self.el.offset();

				$(self.suggestionsContainer).css({
					top: offset.top + self.el.outerHeight() + "px",
					left: offset.left + "px" });

			},

			enableKillerFn: function enableKillerFn() {
				var self = this;
				$(document).on("click.autosuggest", self.killerFn);
			},

			disableKillerFn: function disableKillerFn() {
				var self = this;
				$(document).off("click.autosuggest", self.killerFn);
			},

			killSuggestions: function killSuggestions() {
				var self = this;
				self.stopKillSuggestions();
				self.intervalId = window.setInterval(function () {
					self.hide();
					self.stopKillSuggestions();
				}, 100);
			},

			stopKillSuggestions: function stopKillSuggestions() {
				window.clearInterval(this.intervalId);
			},

			isCursorAtEnd: function isCursorAtEnd() {
				var self = this,
				valLength = self.el.val().length,
				selectionStart = self.element.selectionStart,
				range;

				if (typeof selectionStart === "number") {
					return selectionStart === valLength;
				}
				if (document.selection) {
					range = document.selection.createRange();
					range.moveStart("character", -valLength);
					return valLength === range.text.length;
				}
				return true;
			},

			onKeyPress: function onKeyPress(e) {
				var self = this;

				// If suggestions are hidden and user presses arrow down, display suggestions:
				if (!self.disabled && !self.visible && e.which === keys.DOWN && self.currentValue) {
					self.suggest();
					return;
				}

				if (self.disabled || !self.visible) {
					return;
				}

				switch (e.which) {
					case keys.ESC:
						self.el.val("");
						self.hide();
						self.options.onClear.call(self.element);
						break;
					case keys.RIGHT:
						if (self.hint && self.options.onHint && self.isCursorAtEnd()) {
							self.selectHint();
							break;
						}
						return;
					case keys.TAB:
						if (self.hint && self.options.onHint) {
							self.selectHint();
							return;
						}
					/* falls through */
					case keys.RETURN:
						if (self.selectedIndex === -1) {
							self.hide();
							return;
						}
						self.select(self.selectedIndex);
						if (e.which === keys.TAB && self.options.tabDisabled === false) {
							return;
						}
						break;
					case keys.UP:
						self.moveUp();
						break;
					case keys.DOWN:
						self.moveDown();
						break;
					default:
						return;}


				// Cancel event if function did not return:
				e.stopImmediatePropagation();
				e.preventDefault();
			},

			onKeyUp: function onKeyUp(e) {
				var self = this;

				if (self.disabled || e.which === keys.UP || e.which === keys.DOWN) {
					return;
				}

				clearInterval(self.onChangeInterval);

				if (self.currentValue !== self.el.val()) {
					self.findBestHint();
					if (self.options.deferRequestBy > 0) {
						// Defer lookup in case when value changes very quickly:
						self.onChangeInterval = setInterval(function () {
							self.onValueChange();
						}, self.options.deferRequestBy);
					} else {
						self.onValueChange();
					}
				}
			},

			onFocus: function onFocus() {
				this.currentValue = this.el.val();
				this.fixPosition();
				this.getSuggestions("", "focus");
			},

			onValueChange: function onValueChange() {

				var self = this,
				q;

				if (self.selection) {
					self.selection = null;
					(self.options.onInvalidateSelection || $.noop)();
				}

				clearInterval(self.onChangeInterval);
				self.currentValue = self.el.val();

				if (!self.currentValue) {
					//reset
					self.options.onClear.call(self.element);
				}

				q = self.getQuery(self.currentValue);
				self.selectedIndex = -1;

				if (q.length < self.options.minChars) {
					self.hide();
				} else {
					self.getSuggestions(q, "change");
				}
			},

			getQuery: function getQuery(value) {
				var delimiter = this.options.delimiter,
				parts;

				if (!delimiter) {
					return $.trim(value);
				}
				parts = value.split(delimiter);
				return $.trim(parts[parts.length - 1]);
			},

			getSuggestionsLocal: function getSuggestionsLocal(query) {
				var self = this;

				var suggestions = self.options.lookup.call(this.element, query);
				return {
					suggestions: suggestions };

			},

			getSuggestions: function getSuggestions(q, e) {
				var self = this,
				options = self.options;

				if (self.cachedResponse[q]) {
					self.suggestions = self.cachedResponse[q];
					self.suggest();

				} else if (!self.isBadQuery(q)) {
					options.params[options.paramName] = q;
					if (options.onSearchStart.call(self.element, options.params) === false) {
						return;
					}
					var suggestions = self.getSuggestionsLocal(q);
					self.processResponse(suggestions, q, e);
					options.onSearchComplete.call(self.element, q);
				}
			},

			isBadQuery: function isBadQuery(q) {
				var badQueries = this.badQueries,
				i = badQueries.length;

				while (i--) {
					if (q.indexOf(badQueries[i]) === 0) {
						return true;
					}
				}

				return false;
			},

			hide: function hide() {
				var self = this;
				self.visible = false;
				self.selectedIndex = -1;
				$(self.suggestionsContainer).hide();
				self.signalHint(null);
			},

			suggest: function suggest() {
				if (this.suggestions.length === 0) {
					this.hide();
					return;
				}

				var self = this,
				formatResult = self.options.formatResult,
				value = self.getQuery(self.currentValue),
				className = self.classes.suggestion,
				classSelected = self.classes.selected,
				container = $(self.suggestionsContainer),
				html = "",
				width;

				// Build suggestions inner HTML:
				$.each(self.suggestions, function (i, suggestion) {
					html += '<div class="' + className + '" data-index="' + i + '" role="option">' + formatResult(suggestion, value) + '</div>';
				});

				// If width is auto, adjust width before displaying suggestions,
				// because if instance was created before input had width, it will be zero.
				// Also it adjusts if input width has changed.
				// -2px to account for suggestions border.
				if (self.options.width === "auto") {
					width = self.el.outerWidth() - 2;
					container.width(width > 0 ? width : 300);
				}

				container.html(html).show();
				self.visible = true;

				// Select first value by default:
				if (self.options.autoSelectFirst) {
					self.selectedIndex = 0;
					container.children().first().addClass(classSelected);
				}

				self.findBestHint();
			},

			findBestHint: function findBestHint() {
				var self = this,
				value = self.el.val().toLowerCase(),
				bestMatch = null;

				if (!value) {
					return;
				}

				$.each(self.suggestions, function (i, suggestion) {
					var foundMatch = suggestion.value.toLowerCase && suggestion.value.toLowerCase().indexOf(value) === 0;
					if (foundMatch) {
						bestMatch = suggestion;
					}
					return !foundMatch;
				});

				self.signalHint(bestMatch);
			},

			signalHint: function signalHint(suggestion) {
				var hintValue = "",
				self = this;
				if (suggestion) {
					hintValue = self.currentValue + suggestion.value.substr(self.currentValue.length);
				}
				if (self.hintValue !== hintValue) {
					self.hintValue = hintValue;
					self.hint = suggestion;
					(this.options.onHint || $.noop)(hintValue);
				}
			},

			verifySuggestionsFormat: function verifySuggestionsFormat(suggestions) {
				// If suggestions is string array, convert them to supported format:
				if (suggestions.length && typeof suggestions[0] === "string") {
					return $.map(suggestions, function (value) {
						return { value: value, data: null };
					});
				}

				return suggestions;
			},

			processResponse: function processResponse(response, originalQuery, e) {
				var self = this,
				options = self.options,
				result = options.transformResult(response, originalQuery);

				result.suggestions = self.verifySuggestionsFormat(result.suggestions);

				// Cache results if cache is not disabled:
				if (!options.noCache) {
					self.cachedResponse[result[options.paramName]] = result;
					if (result.suggestions.length === 0) {
						self.badQueries.push(result[options.paramName]);
					}
				}

				// Display suggestions only if returned query matches current value:
				if (originalQuery === self.getQuery(self.currentValue) || e === "focus") {
					self.suggestions = result.suggestions;
					self.suggest();
				}
			},

			activate: function activate(index) {
				var self = this,
				activeItem,
				selected = self.classes.selected,
				container = $(self.suggestionsContainer),
				children = container.children();

				container.children("." + selected).removeClass(selected);

				self.selectedIndex = index;

				if (self.selectedIndex !== -1 && children.length > self.selectedIndex) {
					activeItem = children.get(self.selectedIndex);
					$(activeItem).addClass(selected);
					return activeItem;
				}

				return null;
			},

			selectHint: function selectHint() {
				var self = this,
				i = $.inArray(self.hint, self.suggestions);

				self.select(i);
			},

			select: function select(i) {
				var self = this;
				self.hide();
				self.onSelect(i);
			},

			moveUp: function moveUp() {
				var self = this;

				if (self.selectedIndex === -1) {
					return;
				}

				var modifier;
				if (self.selectedIndex === 0) {
					if (self.options.circularSelect) {
						modifier = self.suggestions.length - 1;
					} else {
						$(self.suggestionsContainer).children().first().removeClass(self.classes.selected);
						self.selectedIndex = -1;
						self.el.val(self.currentValue);
						self.el.trigger("input");
						self.findBestHint();
						return;
					}
				} else {
					modifier = -1;
				}

				self.adjustScroll(self.selectedIndex + modifier);
			},

			moveDown: function moveDown() {
				var self = this;

				var modifier;
				if (self.selectedIndex === self.suggestions.length - 1) {
					if (self.options.circularSelect) {
						modifier = (self.suggestions.length - 1) * -1;
					} else {
						return;
					}
				} else {
					modifier = 1;
				}

				self.adjustScroll(self.selectedIndex + modifier);
			},

			adjustScroll: function adjustScroll(index) {
				var self = this,
				activeItem = self.activate(index),
				offsetTop,
				upperBound,
				lowerBound,
				heightDelta = 75;

				if (!activeItem) {
					return;
				}

				offsetTop = activeItem.offsetTop;
				upperBound = $(self.suggestionsContainer).scrollTop();
				lowerBound = upperBound + self.options.maxHeight - heightDelta;

				if (offsetTop < upperBound) {
					$(self.suggestionsContainer).scrollTop(offsetTop);
				} else if (offsetTop > lowerBound) {
					$(self.suggestionsContainer).scrollTop(offsetTop - self.options.maxHeight + heightDelta);
				}

				self.el.val(self.getValue(self.suggestions[index].value));
				self.el.trigger("input");
				self.signalHint(null);
			},

			onSelect: function onSelect(index) {
				var self = this,
				onSelectCallback = self.options.onSelect,
				suggestion = self.suggestions[index],
				setCurrentValue = true;

				self.currentValue = self.getValue(suggestion.value);
				self.signalHint(null);
				self.suggestions = [];
				self.selection = suggestion;

				if ($.isFunction(onSelectCallback)) {
					if (onSelectCallback.call(self.element, suggestion) === false) {
						setCurrentValue = false;
					}
				}

				if (setCurrentValue) {
					self.el.val(self.currentValue);
					self.el.trigger("input");
				}
			},

			getValue: function getValue(value) {
				var self = this,
				delimiter = self.options.delimiter,
				currentValue,
				parts;

				if (!delimiter) {
					return value;
				}

				currentValue = self.currentValue;
				parts = currentValue.split(delimiter);

				if (parts.length === 1) {
					return value;
				}

				return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
			},

			dispose: function dispose() {
				var self = this;
				self.el.off(".autosuggest").removeData("autosuggest");
				self.disableKillerFn();
				$(window).off("resize", self.fixPositionCapture);
				$(self.suggestionsContainer).remove();
			} };


		// Create chainable jQuery plugin:
		$.fn.autosuggest = function (options, args) {
			var dataKey = "autosuggest";
			// If function invoked without argument return
			// instance of the first matched element:
			if (arguments.length === 0) {
				return this.first().data(dataKey);
			}

			return this.each(function () {
				var inputElement = $(this),
				instance = inputElement.data(dataKey);

				if (typeof options === "string") {
					if (instance && typeof instance[options] === "function") {
						instance[options](args);
					}
				} else {
					// If instance already exists, destroy it:
					if (instance && instance.dispose) {
						instance.dispose();
					}
					instance = new Autocomplete(this, options);
					inputElement.data(dataKey, instance);
				}
			});
		};
	});

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_69__;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);
	    var util = __webpack_require__(71);
	    var builtIn = __webpack_require__(74);
	    var config = __webpack_require__(75);

	    var regex = __webpack_require__(73);

	    module.name = 'ui.smartsuggest-engine'; // launchpad/lib/ui/smartsuggest-engine

	    module.exports = base.createModule(module.name, [
	    core.name,
	    util.name,
	    config.name,
	    builtIn.name]);


	    var RANGE_REGEX = regex['RANGE_REGEX'];
	    // var NUMBER_REGEX = regex['NUMBER_REGEX'];
	    // var STRIP_ACC_FORMATTING_REGEX = regex['STRIP_ACC_FORMATTING_REGEX'];

	    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	    // The SmartSearch class
	    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	    // @ngInject
	    var SmartSuggestFactory = function SmartSuggestFactory(lpCoreUtils, SmartSuggestConfig, SmartSuggestEngineUtil, SmartSuggestEngineBuiltInSuggesters) {

	        var SmartSuggest = function SmartSuggest(options) {
	            this.options = options || {};
	            this.suggesters = [];
	        };

	        ////////////////////////////////////////////////////////////////
	        // Mixin additional Config functionality to Engine's prototype
	        ////////////////////////////////////////////////////////////////
	        lpCoreUtils.mixin(SmartSuggest, SmartSuggestConfig);

	        //////////////////////////////////////////////
	        // Built in suggestion pre-configured types
	        //////////////////////////////////////////////
	        SmartSuggest.types = SmartSuggestConfig.TYPES;

	        ////////////////////////////////////////////////////
	        // Built in suggestion pre-configured type labels
	        ////////////////////////////////////////////////////
	        SmartSuggest.labels = SmartSuggestConfig.LABELS;

	        /////////////////////////////////////////////////////////
	        // Built in suggestion pre-configured type icon classes
	        /////////////////////////////////////////////////////////
	        SmartSuggest.icons = SmartSuggestConfig.ICONS;

	        ////////////////////////////////////////
	        // Utilities
	        ////////////////////////////////////////
	        SmartSuggest.util = SmartSuggestEngineUtil;

	        ////////////////////////////////////////
	        // Built-In Suggesters
	        ////////////////////////////////////////
	        SmartSuggest.builtIn = SmartSuggestEngineBuiltInSuggesters;

	        /**
	                                                                     * Returns a list of suggestions for a search
	                                                                     * @param term
	                                                                     * @returns {Array}
	                                                                     */
	        SmartSuggest.prototype.getSuggestions = function (term) {

	            var self = this;

	            //escape html
	            term = lpCoreUtils.stripHtml(term);

	            //single value or 'value to value' range
	            var terms = [];
	            if (SmartSuggest.util.isRange(term)) {
	                terms = term.match(RANGE_REGEX);
	            } else {
	                terms[1] = term;
	            }

	            //iterate through suggesters accumulating suggestion results
	            var suggestions = [];
	            this.suggesters.forEach(function (suggester) {
	                var newSuggestions = suggester.suggest.call({
	                    data: suggester.data || null,
	                    type: suggester.type,
	                    options: suggester.options || {} },
	                terms[1], terms[2]);
	                if (self.options.showTitles && newSuggestions.length > 0) {
	                    suggestions = suggestions.concat({
	                        type: SmartSuggest.types.TITLE,
	                        title: suggester.type });

	                }
	                suggestions = suggestions.concat(newSuggestions);
	            });

	            return suggestions;
	        };

	        /**
	            * Adds a suggester. Can be a built in or custom function
	            * @param suggester
	            */
	        SmartSuggest.prototype.addSuggester = function (suggester) {

	            // add suggest function from built-in list (if missing)
	            suggester = SmartSuggest.builtIn.addSuggestFunction(suggester);

	            //overwrite existing suggesters of the same type
	            var replaced = false;
	            for (var i = 0; i < this.suggesters.length && !replaced; i++) {
	                if (this.suggesters[i].type === suggester.type) {
	                    this.suggesters[i] = suggester;
	                    replaced = true;
	                }
	            }
	            if (!replaced) {
	                this.suggesters.push(suggester);
	            }

	            return this;
	        };

	        /**
	            * Remove all currently registered suggester functions
	            */
	        SmartSuggest.prototype.clearSuggesters = function () {
	            this.suggesters = [];
	        };

	        return SmartSuggest;
	    };

	    module.exports.factory('SmartSuggestEngine', SmartSuggestFactory);

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);
	    var datesAdvanced = __webpack_require__(72);

	    var regex = __webpack_require__(73);

	    module.name = 'ui.smartsuggest-engine-util';

	    module.exports = base.createModule(module.name, [
	    core.name,
	    datesAdvanced.name]);


	    // @ngInject
	    var utilFactory = function utilFactory(lpCoreUtils, SmartSuggestEngineUtilDatesAdvanced) {
	        var util = {};

	        var RANGE_REGEX = regex['RANGE_REGEX'];
	        var NUMBER_REGEX = regex['NUMBER_REGEX'];
	        //var STRIP_ACC_FORMATTING_REGEX = regex['STRIP_ACC_FORMATTING_REGEX'];

	        /***
	         *
	         * @param term
	         * @returns {boolean}
	         */
	        util.isRange = function (term) {
	            return RANGE_REGEX.test(term);
	        };

	        /**
	            * Special number parser for amounts
	            * @param toParse
	            * @returns {null}
	            */
	        util.parseAmount = function (toParse) {

	            var num = null;
	            if (toParse) {
	                var parseResult = toParse.match(NUMBER_REGEX);
	                if (parseResult && parseResult.length) {
	                    num = parseFloat(parseResult[0]);
	                }
	            }

	            return !isNaN(num) ? Math.abs(num) : null;
	        };

	        /**
	            * Return false if if the date is not a 4 digit numeric value between 1900 and 2100
	            * otherwise returns the parsed year
	            * @param toParse
	            * @returns {*}
	            */
	        util.isYearDate = function (toParse) {
	            var year = util.parseAmount(toParse);
	            return !isNaN(year) && year > 1900 && year < 2100 ? year : false;
	        };

	        /**
	            * Parses a date, with special rules for auto suggestions
	            * @param toParse
	            * @returns {*}
	            */
	        util.parseDate = function (toParse) {
	            var parsedDate;
	            var year = util.isYearDate(toParse);
	            var number = parseFloat(toParse);
	            if (year) {
	                parsedDate = new Date(year, 0, 1);
	            } else if (number <= 31) {
	                parsedDate = new Date(new Date().setDate(number));
	            } else {
	                parsedDate = null;
	            }
	            return parsedDate;
	        };

	        /**
	            * Get collection of dates based on advanced analysis
	            *
	            * @param term1
	            * @param term2
	            * @returns {Array}
	            */
	        util.getAdvancedDatesArray = function (term1, term2) {
	            return SmartSuggestEngineUtilDatesAdvanced.getDatesArray(term1, term2);
	        };

	        /**
	            *
	            * @param term
	            * @returns {*}
	            */
	        util.getDateTermSpecificity = function (term) {

	            var specificity;
	            var regexPatterns = regex.dateRegex;

	            //add year
	            var year = util.isYearDate(term);

	            //add a month
	            var month =
	            !year && (
	            term.match(regexPatterns.jan) ||
	            term.match(regexPatterns.feb) ||
	            term.match(regexPatterns.mar) ||
	            term.match(regexPatterns.apr) ||
	            term.match(regexPatterns.may) ||
	            term.match(regexPatterns.jun) ||
	            term.match(regexPatterns.jul) ||
	            term.match(regexPatterns.aug) ||
	            term.match(regexPatterns.sep) ||
	            term.match(regexPatterns.oct) ||
	            term.match(regexPatterns.nov) ||
	            term.match(regexPatterns.dec) !== null);

	            if (year) {
	                specificity = 'year';
	            } else if (month) {
	                specificity = 'month';
	            } else {
	                specificity = 'day';
	            }

	            return specificity;
	        };

	        /**
	            * Makes a date, inclusive specific to milliseconds.
	            * E.g. Thursday will be converted to 1 millisecond before midnight Friday
	            * @param term
	            * @param date
	            * @returns {*}
	            */
	        util.makeToDateInclusive = function (term, date) {

	            var dateSpecificity = util.getDateTermSpecificity(term);

	            var timeToAdd;
	            if (dateSpecificity === 'year') {
	                timeToAdd = { years: 1 };
	            } else if (dateSpecificity === 'month') {
	                timeToAdd = { months: 1 };
	            } else {
	                timeToAdd = { days: 1 };
	            }
	            // migrate to momentjs
	            var inclusiveDate = lpCoreUtils.date(date).clone().add(timeToAdd).subtract(1, 'ms');

	            return inclusiveDate.toDate();
	        };

	        /**
	            * Util for suggesting a to amount if a user types a single amount
	            * @param from
	            * @returns {number}
	            */
	        util.predictToDate = function (term, from) {

	            var dateSpecificity = util.getDateTermSpecificity(term);

	            var timeToAdd;
	            if (dateSpecificity === 'year') {
	                timeToAdd = { years: 1 };
	            } else if (dateSpecificity === 'month') {
	                timeToAdd = { months: 1 };
	            } else {
	                timeToAdd = { weeks: 1 };
	            }

	            var predictedDate = lpCoreUtils.date(from).clone().add(timeToAdd).subtract(1, 'ms');

	            return predictedDate.toDate();
	        };

	        /**
	            * Util for creating a fuzzy range search from a single amount
	            * @param from
	            * @returns {{from: number, to: number}}
	            */
	        util.makeNumberFuzzy = function (from) {

	            var deviation = from / 10 / 2;
	            var fuzzy = {
	                from: Math.floor(from - deviation),
	                to: Math.ceil(from + deviation) };


	            return fuzzy;
	        };

	        /**
	            * Util for suggesting a to amount if a user types a single amount
	            * @param from
	            * @returns {number}
	            */
	        util.predictToAmount = function (from) {
	            var to = Math.ceil(from + from / 2);
	            return to;
	        };

	        /**
	            * Get the name of type-dependent formatter function
	            *
	            * @param type
	            * @returns {*}
	            */
	        util.getFormatterFnName = function (type) {
	            return lpCoreUtils.camelCase('--format-' + (type || 'general'));
	        };

	        return util;
	    };

	    module.exports.factory('SmartSuggestEngineUtil', utilFactory);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    var regex = __webpack_require__(73);

	    module.name = 'ui.smartsuggest-engine-util-dates-advanced';

	    module.exports = base.createModule(module.name, [
	    core.name]);


	    // @ngInject
	    var datesAdvancedFactory = function datesAdvancedFactory() {
	        var methods = {};
	        //var DAYS_MAX = 31;
	        // var MONTHS_MAX = 12;
	        var DATE_PATTERN_SYMBOL = '-';
	        var YEAR_MAX = new Date().getFullYear();
	        // var datePatternMax = [DAYS_MAX, MONTHS_MAX, YEAR_MAX];
	        var dateRegex = regex.dateRegex;

	        /**
	                                          * Entry point: returns collection of dates based on analysis
	                                          * ----------------------------------------------------------
	                                          *
	                                          * @param term1
	                                          * @param term2
	                                          * @returns {Array}
	                                          */
	        methods.getDatesArray = function (term1, term2) {

	            // check if only one input param provided
	            if (term1 && !term2) {
	                return methods.getDatesSingleTerm(term1);
	            }

	            // default response
	            return [];
	        };

	        /**
	            * Get dates object in case we get only one input parameter
	            *
	            * @param term
	            * @returns {Array}
	            */
	        methods.getDatesSingleTerm = function (term) {
	            var month,res = [];

	            // not a pattern -- checking for month names
	            if (!methods.isDatePattern(term)) {

	                // check one month period (current year or previous)
	                month = methods.getMonthNumber(term);

	                if (month) {
	                    // month for Date object starts with 0, not 1 :(
	                    month -= 1;

	                    // current year (only if the month is current or already passed)
	                    if (month <= new Date().getMonth()) {
	                        res.push({
	                            from: new Date(YEAR_MAX, month, 1),
	                            to: new Date(YEAR_MAX, month, methods.daysInMonth(month, YEAR_MAX), 23, 59) });

	                    }

	                    // previous year
	                    res.push({
	                        from: new Date(YEAR_MAX - 1, month, 1),
	                        to: new Date(YEAR_MAX - 1, month, methods.daysInMonth(month, YEAR_MAX - 1), 23, 59) });

	                }

	            }
	            // else {
	            // TODO: handle date pattern like dd-mm-yyyy
	            // }

	            return res;
	        };

	        /**
	            * Check for date patterns like dd-mm-yyyy in input string
	            *
	            * @param term
	            * @returns {*}
	            */
	        methods.isDatePattern = function (term) {
	            var res = term.split(DATE_PATTERN_SYMBOL);
	            if (res.length < 2) {
	                // no pattern found
	                return false;
	            } else {
	                return res;
	            }
	        };

	        /**
	            * HELPER: Get Month number
	            *
	            * @param term
	            * @returns {*}
	            */
	        methods.getMonthNumber = function (term) {
	            var month = term.match(dateRegex.jan) ? 1 :
	            term.match(dateRegex.feb) ? 2 :
	            term.match(dateRegex.mar) ? 3 :
	            term.match(dateRegex.apr) ? 4 :
	            term.match(dateRegex.may) ? 5 :
	            term.match(dateRegex.jun) ? 6 :
	            term.match(dateRegex.jul) ? 7 :
	            term.match(dateRegex.aug) ? 8 :
	            term.match(dateRegex.sep) ? 9 :
	            term.match(dateRegex.oct) ? 10 :
	            term.match(dateRegex.nov) ? 11 :
	            term.match(dateRegex.dec) ? 12 : false;

	            return month;
	        };

	        /**
	            * HELPER: returns number of days in particular month of the specific year
	            *
	            * @param month
	            * @param year
	            * @returns {number}
	            */
	        methods.daysInMonth = function (month, year) {
	            return 32 - new Date(year, month, 32).getDate();
	        };

	        return methods;
	    };

	    module.exports.factory('SmartSuggestEngineUtilDatesAdvanced', datesAdvancedFactory);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /* eslint-disable */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	    'use strict';

	    var RANGE_REGEX = /^(.+)\sto\s?(.*)$/i;
	    var NUMBER_REGEX = /[\-+]?([0-9]*\.)?[0-9]+/;
	    var STRIP_ACC_FORMATTING_REGEX = /[\.+\s+\-]/g;
	    var dateRegex = { jan: /^jan(uary)?/i, feb: /^feb(ruary)?/i, mar: /^mar(ch)?/i, apr: /^apr(il)?/i, may: /^may/i, jun: /^jun(e)?/i, jul: /^jul(y)?/i, aug: /^aug(ust)?/i, sep: /^sep(t(ember)?)?/i, oct: /^oct(ober)?/i, nov: /^nov(ember)?/i, dec: /^dec(ember)?/i, sun: /^su(n(day)?)?/i, mon: /^mo(n(day)?)?/i, tue: /^tu(e(s(day)?)?)?/i, wed: /^we(d(nesday)?)?/i, thu: /^th(u(r(s(day)?)?)?)?/i, fri: /^fr(i(day)?)?/i, sat: /^sa(t(urday)?)?/i, future: /^next/i, past: /^last|past|prev(ious)?/i, add: /^(\+|aft(er)?|from|hence)/i, subtract: /^(\-|bef(ore)?|ago)/i, yesterday: /^yes(terday)?/i, today: /^t(od(ay)?)?/i, tomorrow: /^tom(orrow)?/i, now: /^n(ow)?/i, millisecond: /^ms|milli(second)?s?/i, second: /^sec(ond)?s?/i, minute: /^mn|min(ute)?s?/i, hour: /^h(our)?s?/i, week: /^w(eek)?s?/i, month: /^m(onth)?s?/i, day: /^d(ay)?s?/i, year: /^y(ear)?s?/i, shortMeridian: /^(a|p)/i, longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i, timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i, ordinalSuffix: /^\s*(st|nd|rd|th)/i, timeContext: /^\s*(\:|a(?!u|p)|p)/i };

	    return {
	        RANGE_REGEX: RANGE_REGEX,
	        NUMBER_REGEX: NUMBER_REGEX,
	        STRIP_ACC_FORMATTING_REGEX: STRIP_ACC_FORMATTING_REGEX,
	        dateRegex: dateRegex };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    var config = __webpack_require__(75);
	    var util = __webpack_require__(71);
	    var regex = __webpack_require__(73);

	    module.name = 'ui.smartsuggest-engine-built-in-suggesters';

	    module.exports = base.createModule(module.name, [
	    core.name,
	    util.name,
	    config.name]);


	    var STRIP_ACC_FORMATTING_REGEX = regex['STRIP_ACC_FORMATTING_REGEX'];

	    // @ngInject
	    var builtInFactory = function builtInFactory(lpCoreUtils, SmartSuggestConfig, SmartSuggestEngineUtil) {
	        var builtIn = {};
	        var types = SmartSuggestConfig.TYPES;
	        var getSuggesterFnName = function getSuggesterFnName(type) {
	            return lpCoreUtils.camelCase('--get-' + (type || 'general') + '-suggestions');
	        };

	        /**
	            * HELPER: Add a built-in suggest function to suggester
	            *
	            * @param suggester
	            * @returns {*}
	            */
	        builtIn.addSuggestFunction = function (suggester) {

	            // no suggest function provided -- adding here from built-in list
	            if (typeof suggester.suggest !== 'function') {
	                suggester.suggest = builtIn[getSuggesterFnName(suggester.type)];
	            }

	            // Comment: if the 'suggest' function is already in suggester, then we rely on it
	            // and presume it is ok (no validation for now)

	            return suggester;
	        };

	        // DATE
	        builtIn.getDateSuggestions = function (term1, term2) {
	            var self = this;
	            var suggestions = [];

	            var from = SmartSuggestEngineUtil.parseDate(term1);
	            var to = SmartSuggestEngineUtil.parseDate(term2);

	            //if user this is not a displayAsRange search, i.e. search on specific day or month, 'July'
	            if (from && !to) {
	                to = SmartSuggestEngineUtil.makeToDateInclusive(term1, from);
	                suggestions.push({
	                    terms: [term1, term2],
	                    type: this.type || types.DATE,
	                    displayAsRange: false,
	                    search: {
	                        from: from,
	                        to: to } });


	            }

	            var predicted = false;
	            //always provide a range suggestion (predicted or user specified)
	            if (from) {
	                if (!term2 || to && from.getTime() > to.getTime()) {
	                    to = SmartSuggestEngineUtil.predictToDate(term1, from);
	                    predicted = true;
	                } else {
	                    to = SmartSuggestEngineUtil.makeToDateInclusive(term2, to);
	                }
	                if (from.getTime() < to.getTime()) {
	                    suggestions.push({
	                        terms: [term1, term2],
	                        type: this.type,
	                        displayAsRange: true,
	                        predicted: predicted,
	                        search: {
	                            from: from,
	                            to: to } });


	                }
	            }

	            // Advanced Date suggestions
	            var dates = SmartSuggestEngineUtil.getAdvancedDatesArray(term1, term2) || [];
	            dates.forEach(function (item) {
	                if (lpCoreUtils.isDate(item.from)) {
	                    suggestions.push({
	                        terms: [term1, term2],
	                        type: self.type,
	                        displayAsRange: lpCoreUtils.isDate(item.to) ? true : false,
	                        search: {
	                            from: item.from,
	                            to: item.to } });


	                }
	            });

	            return suggestions;
	        };

	        // AMOUNT
	        builtIn.getAmountSuggestions = function (term1, term2) {

	            var suggestions = [];

	            var from = SmartSuggestEngineUtil.parseAmount(term1);
	            var to = SmartSuggestEngineUtil.parseAmount(term2);

	            //if user this is not a range search, make it a fuzzy range
	            if (from && !to) {
	                var fuzzyRange = SmartSuggestEngineUtil.makeNumberFuzzy(from);
	                suggestions.push({
	                    terms: [term1, term2],
	                    type: this.type || types.AMOUNT,
	                    displayAsRange: false,
	                    search: {
	                        original: from,
	                        from: fuzzyRange.from,
	                        to: fuzzyRange.to } });


	            }

	            var predicted = false;
	            //always provide a range suggestion (predicted or user specified)
	            if (from) {
	                //if it is a range suggestion predict the to number
	                if (!term2 || to && from > to) {
	                    to = SmartSuggestEngineUtil.predictToAmount(from);
	                    predicted = true;
	                }
	                if (from < to) {
	                    suggestions.push({
	                        terms: [term1, term2],
	                        type: this.type,
	                        displayAsRange: true,
	                        predicted: predicted,
	                        search: {
	                            from: from,
	                            to: to } });


	                }
	            }
	            return suggestions;
	        };

	        // ACCOUNT
	        builtIn.getAccountSuggestions = function (term) {
	            var self = this,
	            suggestions = [],
	            accounts = this.data || [];

	            if (term.length < 2 && !this.options.showAll) {
	                return suggestions;
	            }

	            accounts.forEach(function (account) {

	                var nameRegex = new RegExp('(' + term + ')', 'ig');
	                var nameMatch = account.name.match(nameRegex);
	                var bbanMatch = false;

	                if (!nameMatch) {
	                    var unformattedTerm = term.replace(STRIP_ACC_FORMATTING_REGEX, '');
	                    var accountRegex = new RegExp('^(' + unformattedTerm + ')', 'i');
	                    bbanMatch = (account.bban + '').match(accountRegex);
	                }
	                if (term.length < 2 && self.options.showAll || nameMatch || bbanMatch) {
	                    suggestions.push({
	                        terms: [term],
	                        type: self.type || types.ACCOUNT,
	                        matchType: bbanMatch ? 'number' : 'name',
	                        account: account,
	                        search: {
	                            account: account.id } });


	                }
	            });

	            return suggestions;
	        };

	        // CONTACT
	        builtIn.getContactSuggestions = function (term) {

	            var self = this;
	            var suggestions = [];

	            if (term.length < 2 && !this.options.showAll) {
	                return suggestions;
	            }

	            var contacts = this.data || [];
	            contacts.forEach(function (contact) {
	                var nameRegex = new RegExp('(' + term + ')', 'ig');
	                var nameMatch = lpCoreUtils.isString(contact.name) && contact.name.match(nameRegex);
	                var accountMatch = false;
	                if (!nameMatch) {
	                    var unformattedTerm = term.replace(STRIP_ACC_FORMATTING_REGEX, '');
	                    var accountRegex = new RegExp('^(' + unformattedTerm + ')', 'i');
	                    accountMatch = contact.account && (contact.account + '').match(accountRegex);
	                }
	                if (term.length < 2 && self.options.showAll || nameMatch || accountMatch) {
	                    suggestions.push({
	                        terms: [term],
	                        type: self.type || types.CONTACT,
	                        matchType: accountMatch ? 'account' : 'name',
	                        contact: contact,
	                        search: {
	                            contact: contact.account } });


	                }
	            });

	            return suggestions;
	        };

	        // CATEGORY
	        builtIn.getCategorySuggestions = function (rawTerm) {
	            var self = this;

	            var suggestions = [];
	            var categories = self.data || [];
	            var terms = rawTerm.split(',');
	            var minTermLength = 2;

	            var matches = [];
	            var ids = [];

	            var matchCategory = function matchCategory(aTerms, categoryName) {
	                var matched = false;

	                aTerms.forEach(function (term) {
	                    if (term.length >= minTermLength && categoryName.toLowerCase().indexOf(term.toLowerCase()) === 0) {
	                        matched = true;
	                    }
	                });

	                return matched;
	            };

	            categories.forEach(function (category) {
	                if (matchCategory(terms, category.name)) {
	                    matches.push(category);
	                    ids.push(category.id);
	                }
	            });

	            if (ids.length >= 1) {
	                suggestions.push({
	                    terms: [terms],
	                    type: self.type || types.CATEGORY,
	                    category: matches, // matched categories
	                    search: {
	                        category: ids.join(',') // category ids
	                    } });

	            }


	            return suggestions;
	        };

	        // GENERAL
	        builtIn.getGeneralSuggestions = function (term1, term2) {

	            var suggestions = [];

	            var term = term2 ? term1 + ' to ' + term2 : term1;

	            if (term.length >= 2) {
	                if (!SmartSuggestEngineUtil.isRange(term)) {
	                    suggestions.push({
	                        terms: [term],
	                        type: this.type || types.GENERAL,
	                        search: {
	                            query: term } });


	                }
	            }

	            return suggestions;
	        };

	        return builtIn;
	    };

	    module.exports.factory('SmartSuggestEngineBuiltInSuggesters', builtInFactory);

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    module.name = 'ui.smartsuggest-engine-config';

	    module.exports = base.createModule(module.name, [
	    core.name]);


	    /////////////////////
	    //   Main Config   //
	    /////////////////////
	    var list = {
	        DATE: {
	            type: 'date',
	            label: 'On',
	            icon: 'lp-icon-calendar' },

	        AMOUNT: {
	            type: 'amount',
	            label: 'Of',
	            icon: 'lp-icon-transactions-v1' },

	        ACCOUNT: {
	            type: 'account',
	            label: 'Account',
	            icon: 'lp-icon-search2' },

	        CONTACT: {
	            type: 'contact',
	            label: 'Contact',
	            icon: 'lp-icon-search2' },

	        CATEGORY: {
	            type: 'category',
	            label: 'Category',
	            icon: 'lp-icon-tag' },

	        GENERAL: {
	            type: 'general',
	            label: 'Description',
	            icon: 'lp-icon-search2' },

	        TITLE: {
	            type: 'title',
	            label: '' } };



	    // Factory function
	    // ----------------
	    // @ngInject
	    var configFactory = function configFactory(lpCoreUtils) {

	        /**
	                                                              * Get an object with same keys, but with single property as a value
	                                                              *
	                                                              * @param prop
	                                                              * @returns {Object}
	                                                              */
	        var getByValue = function getByValue(prop) {
	            return lpCoreUtils.mapValues(list, function (n) {
	                return n[prop];
	            });
	        };

	        /**
	            * Get an object where different properties create key-value object
	            *
	            * @param keyName
	            * @param valueName
	            * @returns {Object}
	            */
	        var getValuesPairs = function getValuesPairs(keyName, valueName) {
	            var res = {};
	            var keys = lpCoreUtils.pluck(list, keyName);
	            var values = lpCoreUtils.pluck(list, valueName);

	            lpCoreUtils.forEach(keys, function (k, index) {
	                res[k] = values[index];
	            });

	            return res;
	        };

	        /**
	            * Helper method, allowing customize properties in config lists for the respective type
	            *
	            * @param {Object} targetList
	            * @param {String} type
	            * @param {String} propName
	            * @param {String} newValue
	            * @returns {boolean}
	            */
	        var updateProp = function updateProp(targetList, type, propName, newValue) {
	            if (lpCoreUtils.isObject(targetList) &&
	            lpCoreUtils.isObject(targetList[type]) &&
	            lpCoreUtils.isString(propName) &&
	            lpCoreUtils.isString(newValue)) {

	                // update value
	                targetList[type][propName] = newValue;
	                return true;
	            } else {

	                // TODO: log properly
	                console.warn('updateProp: input arguments validation failed...');
	                return false;
	            }
	        };

	        // get config with types only
	        var getTypes = function getTypes() {
	            return getByValue('type');
	        };

	        // get type-label object
	        var getLabelsByType = function getLabelsByType() {
	            return getValuesPairs('type', 'label');
	        };

	        // get type-iconClassName object
	        var getIconsByType = function getIconsByType() {
	            return getValuesPairs('type', 'icon');
	        };

	        // Lists to be shared
	        var TYPES = getTypes(),LABELS = getLabelsByType(),ICONS = getIconsByType();

	        // Update lists (to apply recent changes)
	        var updateLists = function updateLists() {
	            TYPES = lpCoreUtils.assign(TYPES, getTypes());
	            LABELS = lpCoreUtils.assign(LABELS, getLabelsByType());
	            ICONS = lpCoreUtils.assign(ICONS, getIconsByType());
	        };

	        // update icon class name in a Config
	        var updateIcon = function updateIcon(targetList, type, iconClassName) {
	            if (updateProp(targetList, type, 'icon', iconClassName)) {
	                updateLists();
	            }
	        };

	        // update label name in a Config
	        var updateLabel = function updateLabel(targetList, type, newLabelValue) {
	            if (updateProp(targetList, type, 'label', newLabelValue)) {
	                updateLists();
	            }
	        };

	        // update type name in a Config
	        var updateType = function updateType(targetList, type, newTypeValue) {
	            if (updateProp(targetList, type, 'type', newTypeValue)) {
	                updateLists();
	            }
	        };

	        /**
	            * Add new Config prop (not to overwrite existing ones)
	            *
	            * @param {String} prop
	            * @param {Object} item
	            */
	        var addConfigItem = function addConfigItem(prop, item) {
	            if (lpCoreUtils.isObject(item) && lpCoreUtils.isString(item.type) && !list[prop]) {

	                // add new config item
	                list[prop] = item;

	                // update lists
	                updateLists();
	            } else {
	                // TODO: log properly
	                console.warn('addConfigItem: input arguments validation failed...');
	            }
	        };

	        // API
	        return {
	            TYPES: TYPES,
	            LABELS: LABELS,
	            ICONS: ICONS,
	            addConfigItem: addConfigItem,
	            updateConfigIcon: updateIcon,
	            updateConfigLabel: updateLabel,
	            updateConfigType: updateType };

	    };

	    module.exports.factory('SmartSuggestConfig', configFactory);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    module.name = 'ui.smartsuggest-formatter'; // launchpad/lib/ui/smartsuggest-formatter

	    module.exports = base.createModule(module.name, [
	    core.name]);


	    // @ngInject
	    module.exports.factory('SmartSuggestFormatter', function (SmartSuggestEngine, lpCoreI18n, lpCoreUtils) {

	        // shrotcut to getter function from util
	        var getFormatterFnName = SmartSuggestEngine.util.getFormatterFnName;

	        /**
	                                                                              * CONSTRUCTOR
	                                                                              *
	                                                                              * @param locale
	                                                                              * @constructor
	                                                                              */
	        var SmartSuggestFormatter = function SmartSuggestFormatter(options) {
	            this.locale = options.locale || null;
	            this.currency = options.currency || null;
	        };

	        /**
	            * Adds custom formatter.
	            * ----------------------
	            * Adds a new formatter of a certain type (or OVERWRITES existing of the type provided)
	            *
	            * @param type {string}
	            * @param formatter {function}
	            */
	        SmartSuggestFormatter.prototype.addFormatter = function (type, formatter) {
	            if (lpCoreUtils.isString(type) && lpCoreUtils.isFunction(formatter)) {
	                SmartSuggestFormatter.prototype[getFormatterFnName(type)] = formatter;
	            } else {
	                // TODO: add proper validation error handling
	                console.log('addFormatter: input arguments validation failure');
	            }
	        };

	        /**
	            *
	            */
	        SmartSuggestFormatter.prototype.format = function (suggestion) {

	            var values = [];

	            if (suggestion.displayAsRange) {
	                values[0] = this.formatValue(suggestion.search.from, suggestion.type);
	                values[1] = this.formatValue(suggestion.search.to, suggestion.type);
	            } else if (suggestion.type === SmartSuggestEngine.types.DATE) {
	                values[0] = this.formatValue(suggestion.search.from, suggestion.type);
	            } else if (suggestion.type === SmartSuggestEngine.types.AMOUNT) {
	                values[0] = this.formatValue(suggestion.search.original, suggestion.type);
	            } else if (suggestion.type === SmartSuggestEngine.types.CONTACT) {
	                values[0] = this.formatValue(suggestion.contact.name, suggestion.type);
	                values[1] = this.formatValue(suggestion.contact.account, suggestion.type);
	            } else if (suggestion.type === SmartSuggestEngine.types.CATEGORY) {
	                values[0] = this.formatValue(suggestion.category, suggestion.type);
	            } else if (suggestion.type === SmartSuggestEngine.types.ACCOUNT) {
	                values[0] = this.formatValue(suggestion.account.name, suggestion.type);
	                values[1] = this.formatValue(suggestion.account.iban, suggestion.type);
	                values[2] = this.formatAmount(suggestion.account.balance, suggestion.account.currency);
	            } else if (suggestion.type === SmartSuggestEngine.types.TITLE) {
	                values[0] = this.formatValue(suggestion.title, suggestion.type);
	            } else {
	                values[0] = this.formatValue(suggestion.search.query, suggestion.type);
	            }

	            values = lpCoreUtils.map(values, lpCoreUtils.stripHtml);

	            return values;
	        };

	        /**
	            * Format value, other then money amount
	            *
	            * IMPORTANT: formatter function name should be the following format: "formatType",
	            *            where Type is your suggester type (like 'date', 'contact', etc.)
	            *
	            * @param value
	            * @param type
	            * @returns {*}
	            */
	        SmartSuggestFormatter.prototype.formatValue = function (value, type) {
	            return lpCoreUtils.isFunction(this[getFormatterFnName(type)]) ? this[getFormatterFnName(type)](value) : value;
	        };

	        /**
	            * Format money amount (not a type-dependent)
	            *
	            * @param value
	            * @returns {*}
	            */
	        SmartSuggestFormatter.prototype.formatAmount = function (value, currency) {
	            return lpCoreI18n.formatCurrency(value, currency || this.currency);
	        };

	        /**
	            *
	            * @param value
	            * @returns {*}
	            */
	        SmartSuggestFormatter.prototype.formatDate = function (value) {
	            return lpCoreI18n.formatDate(value);
	        };

	        SmartSuggestFormatter.prototype.formatAccount = function (value) {
	            return value.name;
	        };

	        SmartSuggestFormatter.prototype.formatCategory = function (value) {
	            var categories = value;

	            return categories.map(function (category) {
	                return category.name;
	            }).join(', ');
	        };

	        /**
	            *
	            * @param value
	            * @returns {*}
	            */
	        SmartSuggestFormatter.prototype.formatGeneral = function (value) {
	            return value;
	        };

	        SmartSuggestFormatter.prototype.formatTitle = function (value) {
	            switch (value) {
	                case SmartSuggestEngine.types.ACCOUNT:
	                    return 'My accounts';
	                case SmartSuggestEngine.types.CONTACT:
	                    return 'Address Book';}

	            return value;
	        };

	        /**
	            *
	            * @param suggestion
	            * @returns {*}
	            */
	        SmartSuggestFormatter.prototype.getTypeLabel = function (suggestion) {
	            var label;

	            if (suggestion.displayAsRange) {
	                label = 'Between';
	            } else {
	                label = SmartSuggestEngine.labels[suggestion.type] || 'Description';
	            }

	            return lpCoreI18n.instant(label) + ': ';
	        };

	        /**
	            * Returns icon classes set
	            *
	            * @param suggestion
	            * @returns {*}
	            */
	        SmartSuggestFormatter.prototype.getSuggestionIcon = function (suggestion, small) {
	            return 'lp-icon lp-icon-' + (small ? 'small' : 'medium') + ' ' + SmartSuggestEngine.icons[suggestion.type];
	        };

	        /**
	            *
	            * @param suggestion
	            * @returns {string}
	            */
	        SmartSuggestFormatter.prototype.getSuggestionHtml = function (suggestion) {

	            var htmlClass = 'lp-smartsuggest-' + suggestion.type;
	            var values = this.format(suggestion);

	            var html = '<div class="lp-smartsuggest-result clearfix ' + htmlClass + '">';
	            var predictedClass = suggestion.predicted ? 'lp-smartsuggest-predicted' : '';

	            //image
	            if (suggestion.type !== SmartSuggestEngine.types.ACCOUNT && suggestion.type !== SmartSuggestEngine.types.TITLE) {
	                html += '<span class="lp-smartsuggest-icon">';
	                if (suggestion.type === SmartSuggestEngine.types.CONTACT && typeof suggestion.contact.photoUrl === 'string') {
	                    html += '<img src="' + decodeURIComponent(suggestion.contact.photoUrl) + '" width="35" height="35">';
	                } else if (suggestion.type === SmartSuggestEngine.types.CONTACT && suggestion.contact.initials) {
	                    html += '<span class="lp-smartsuggest-intials">' + suggestion.contact.initials + '</span>';
	                } else {
	                    var iconClass = this.getSuggestionIcon(suggestion);
	                    html += '<i class="' + iconClass + '"></i>';
	                }
	                html += '</span>';
	            }

	            html += '<div class="lp-smartsuggest-valuegroup">';
	            if (!suggestion.contact && !suggestion.account) {
	                html += '<span class="lp-smartsuggest-category">' + this.getTypeLabel(suggestion) + '</span>';
	            }
	            //formatting for contacts
	            if (suggestion.contact) {
	                html += '<span class="lp-smartsuggest-value ' + htmlClass + '-value">' + values[0] + '</span><br>';
	                html += '<span class="' + htmlClass + '-value">' + values[1] + '</span>';
	            } else if (suggestion.account) {
	                html += '<div class="lp-smartsuggest-value ' + htmlClass + '-value">' + values[0] + '</div>';
	                html += '<div><small class="' + htmlClass + '-value pull-left muted">' + values[1] + '</small>';
	                html += '<span class="' + htmlClass + '-value pull-right">' + values[2] + '</span></div>';
	            }
	            //formatting for ranges
	            else if (values.length === 2) {
	                    html += '<span class="lp-smartsuggest-from lp-smartsuggest-value ' + htmlClass + '-value">' + values[0] + '</span> ' + lpCoreI18n.instant('to');
	                    html += ' <span class="lp-smartsuggest-to lp-smartsuggest-value ' + htmlClass + '-value ' + predictedClass + '">' + values[1] + '</span>';

	                    //formatting for single values
	                } else {
	                    html += '<span class="lp-smartsuggest-value ' + htmlClass + '-value">' + values[0] + '</span>';
	                }
	            html += '</div>';
	            html += '</div>';

	            return html;
	        };

	        return SmartSuggestFormatter;
	    });
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.touch';

	    var base = __webpack_require__(20);

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(78).directives);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var Hammer = __webpack_require__(79);

	    /**
	                                       * Supported directives
	                                       * define Hammerjs EVENTS/RECOGNIZERS and turn them into angularjs directives
	                                       * http://hammerjs.github.io/getting-started/
	                                       * use them as human-case directive
	                                       * FOR Example <div on-swipe="mySwipeHandler">
	                                       */
	    // Hammer 2.x GestureEvents
	    var gestureDirectivesNames = [
	    // pan/drag events
	    'onPan', 'onPanUp', 'onPanDown', 'onPanLeft', 'onPanRight', 'onPanStart', 'onPanEnd', 'onPanMove', 'onPanCancel',
	    // swipe events
	    'onSwipe', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight',
	    // pinch events
	    'onPinch', 'onPinchIn', 'onPinchOut', 'onPinchStart', 'onPinchEnd', 'onPinchMove', 'onPinchCancel',
	    // rotate events
	    'onRotate', 'onRotateMove', 'onRotateStart', 'onRotateEnd', 'onRotateCancel',
	    // tap/press events
	    'onTap', 'onPress'];


	    // Store all Directives under a directives object
	    var directives = {};

	    /**
	                          * Linking method attach touch event only if the window supports touch events
	                          * @param  {string} dirName Directive name for example onSwipe... etc.
	                          * @return {array}         angularjs directive
	                          */
	    function linkGestureDirective(dirName) {

	        var isTouch = 'ontouchstart' in window;

	        return ['$parse', function ($parse) {

	            var eventType = dirName.substr(2).toLowerCase();

	            return {
	                link: function link(scope, element, attrs) {

	                    var gesture,
	                    mc = element.data('touch'),
	                    fn = $parse(attrs[dirName]),
	                    opts = $parse(attrs.onGestureOptions)(scope, {}),
	                    listener;

	                    listener = function listener(ev) {
	                        scope.$apply(function () {
	                            fn(scope, { $event: event, $element: element });
	                        });
	                    };

	                    // creatxe only one instance;
	                    if (typeof Hammer !== 'undefined' && isTouch) {

	                        if (!mc) {
	                            mc = new Hammer(element[0], opts);
	                            element.data('touch', mc);
	                        }

	                        gesture = mc.on(eventType, listener);

	                        scope.$on('$destroy', function () {
	                            gesture.off(eventType, listener);
	                        });
	                    }

	                } };

	        }];
	    }

	    gestureDirectivesNames.forEach(function (dirName) {
	        directives[dirName] = linkGestureDirective(dirName);
	    });

	    exports.directives = directives;

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_79__;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.placeholder';

	    var base = __webpack_require__(20);

	    // Plugin needed for placeholder
	    __webpack_require__(81);

	    var deps = [];

	    module.exports = base.createModule(module.name, deps).
	    directive(__webpack_require__(82));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /* eslint-disable */
	/*! http://mths.be/placeholder v2.1.1 by @mathias */
	(function (factory) {
		if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Browser globals
			factory(window.jQuery);
		}
	})(function ($) {


		// Opera Mini v7 doesn't support placeholder although its DOM seems to indicate so
		var isOperaMini = Object.prototype.toString.call(window.operamini) == '[object OperaMini]';
		var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini;
		var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini;
		var valHooks = $.valHooks;
		var propHooks = $.propHooks;
		var hooks;
		var placeholder;

		if (isInputSupported && isTextareaSupported) {

			placeholder = $.fn.placeholder = function () {
				return this;
			};

			placeholder.input = placeholder.textarea = true;

		} else {

			var settings = {};

			placeholder = $.fn.placeholder = function (options) {

				var defaults = { customClass: 'placeholder' };
				settings = $.extend({}, defaults, options);

				var $this = this;
				$this.
				filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]').
				not('.' + settings.customClass).
				bind({
					'focus.placeholder': clearPlaceholder,
					'blur.placeholder': setPlaceholder }).

				data('placeholder-enabled', true).
				trigger('blur.placeholder');
				return $this;
			};

			placeholder.input = isInputSupported;
			placeholder.textarea = isTextareaSupported;

			hooks = {
				'get': function get(element) {
					var $element = $(element);

					var $passwordInput = $element.data('placeholder-password');
					if ($passwordInput) {
						return $passwordInput[0].value;
					}

					return $element.data('placeholder-enabled') && $element.hasClass(settings.customClass) ? '' : element.value;
				},
				'set': function set(element, value) {
					var $element = $(element);

					var $passwordInput = $element.data('placeholder-password');
					if ($passwordInput) {
						return $passwordInput[0].value = value;
					}

					if (!$element.data('placeholder-enabled')) {
						return element.value = value;
					}
					if (value === '') {
						element.value = value;
						// Issue #56: Setting the placeholder causes problems if the element continues to have focus.
						if (element != safeActiveElement()) {
							// We can't use `triggerHandler` here because of dummy text/password inputs :(
							setPlaceholder.call(element);
						}
					} else if ($element.hasClass(settings.customClass)) {
						clearPlaceholder.call(element, true, value) || (element.value = value);
					} else {
						element.value = value;
					}
					// `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
					return $element;
				} };


			if (!isInputSupported) {
				valHooks.input = hooks;
				propHooks.value = hooks;
			}
			if (!isTextareaSupported) {
				valHooks.textarea = hooks;
				propHooks.value = hooks;
			}

			$(function () {
				// Look for forms
				$(document).delegate('form', 'submit.placeholder', function () {
					// Clear the placeholder values so they don't get submitted
					var $inputs = $('.' + settings.customClass, this).each(clearPlaceholder);
					setTimeout(function () {
						$inputs.each(setPlaceholder);
					}, 10);
				});
			});

			// Clear placeholder values upon page reload
			$(window).bind('beforeunload.placeholder', function () {
				$('.' + settings.customClass).each(function () {
					this.value = '';
				});
			});

		}

		function args(elem) {
			// Return an object of element attributes
			var newAttrs = {};
			var rinlinejQuery = /^jQuery\d+$/;
			$.each(elem.attributes, function (i, attr) {
				if (attr.specified && !rinlinejQuery.test(attr.name)) {
					newAttrs[attr.name] = attr.value;
				}
			});
			return newAttrs;
		}

		function clearPlaceholder(event, value) {
			var input = this;
			var $input = $(input);
			if (input.value == $input.attr('placeholder') && $input.hasClass(settings.customClass)) {
				if ($input.data('placeholder-password')) {
					$input = $input.hide().nextAll('input[type="password"]:first').show().attr('id', $input.removeAttr('id').data('placeholder-id'));
					// If `clearPlaceholder` was called from `$.valHooks.input.set`
					if (event === true) {
						return $input[0].value = value;
					}
					$input.focus();
				} else {
					input.value = '';
					$input.removeClass(settings.customClass);
					input == safeActiveElement() && input.select();
				}
			}
		}

		function setPlaceholder() {
			var $replacement;
			var input = this;
			var $input = $(input);
			var id = this.id;
			if (input.value === '') {
				if (input.type === 'password') {
					if (!$input.data('placeholder-textinput')) {
						try {
							$replacement = $input.clone().attr({ 'type': 'text' });
						} catch (e) {
							$replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
						}
						$replacement.
						removeAttr('name').
						data({
							'placeholder-password': $input,
							'placeholder-id': id }).

						bind('focus.placeholder', clearPlaceholder);
						$input.
						data({
							'placeholder-textinput': $replacement,
							'placeholder-id': id }).

						before($replacement);
					}
					$input = $input.removeAttr('id').hide().prevAll('input[type="text"]:first').attr('id', id).show();
					// Note: `$input[0] != input` now!
				}
				$input.addClass(settings.customClass);
				$input[0].value = $input.attr('placeholder');
			} else {
				$input.removeClass(settings.customClass);
			}
		}

		function safeActiveElement() {
			// Avoid IE9 `document.activeElement` of death
			// https://github.com/mathiasbynens/jquery-placeholder/pull/99
			try {
				return document.activeElement;
			} catch (exception) {}
		}

	});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var $ = __webpack_require__(69);

	    // @ngInject
	    exports.placeholder = function ($timeout) {
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                var placeholder = attrs.placeholder;
	                if (placeholder) {
	                    $timeout(function () {
	                        $(element).placeholder();
	                    }, 0, false);
	                }
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.color-picker';

	    var base = __webpack_require__(20);

	    var deps = [];

	    module.exports = base.createModule(module.name, deps).
	    constant(__webpack_require__(84)).
	    directive(__webpack_require__(85));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.COLORS = [
	    { name: 'Cantaloupe', value: '#FFD479' },
	    { name: 'Honeydew', value: '#D4FB79' },
	    { name: 'Spindrift', value: '#73FCD6' },
	    { name: 'Sky', value: '#76D6FF' },
	    { name: 'Lavender', value: '#D783FF' },
	    { name: 'Carnation', value: '#FF8AD8' },
	    { name: 'Licorice', value: '#000000' },
	    { name: 'Snow', value: '#FFFFFF' },
	    { name: 'Salmon', value: '#FF7E79' },
	    { name: 'Banana', value: '#FFFC79' },
	    { name: 'Flora', value: '#73FA79' },
	    { name: 'Ice', value: '#73FDFF' },
	    { name: 'Orchid', value: '#7A81FF' },
	    { name: 'Bubblegum', value: '#FF85FF' },
	    { name: 'Lead', value: '#212121' },
	    { name: 'Mercury', value: '#EBEBEB' },
	    { name: 'Tangerine', value: '#FF9300' },
	    { name: 'Lime', value: '#8EFA00' },
	    { name: 'Sea Foam', value: '#00FA92' },
	    { name: 'Aqua', value: '#0096FF' },
	    { name: 'Grape', value: '#9437FF' },
	    { name: 'Strawberry', value: '#FF2F92' },
	    { name: 'Tungsten', value: '#424242' },
	    { name: 'Silver', value: '#D6D6D6' },
	    { name: 'Maraschino', value: '#FF2600' },
	    { name: 'Lemon', value: '#FFFB00' },
	    { name: 'Spring', value: '#00F900' },
	    { name: 'Turquoise', value: '#00FDFF' },
	    { name: 'Blueberry', value: '#0433FF' },
	    { name: 'Iron', value: '#5E5E5E' },
	    { name: 'Magnesium', value: '#C0C0C0' },
	    { name: 'Mocha', value: '#945200' },
	    { name: 'Fern', value: '#4F8F00' }];

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.lpColorPicker = function ($timeout, COLORS) {
	        function lpColorPickerCtrl(scope, el, attrs) {
	            scope.colors = COLORS;

	            // focus first color
	            $timeout(function () {
	                el.find('li')[0].focus();
	            }, 0);

	            scope.keyDown = function (event, color) {
	                if (event.which === 13 || event.which === 32) {
	                    event.preventDefault();
	                    event.stopPropagation();

	                    scope.selectColor(color);
	                }
	            };
	        }

	        var tmpl = [
	        '<ul class="color-picker clearfix">',
	        '<li ng-repeat="color in colors" tabIndex="0" class="color cursor-pointer" title="{{color.name}}" ng-click="selectColor(color.value)" ng-keydown="keyDown($event, color.value)">',
	        '<div ng-style="{\'background-color\':color.value}"></div>',
	        '</li>',
	        '</ul>'].
	        join('');

	        function compileFn() {
	            return lpColorPickerCtrl;
	        }

	        return {
	            scope: {
	                selectColor: '=' },

	            restrict: 'AE',
	            compile: compileFn,
	            template: tmpl };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.infinite-scroll';

	    module.exports = base.createModule(module.name, []).
	    directive(__webpack_require__(87));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.lpInfiniteScroll = function ($parse) {
	        function linkFn(scope, element, attr) {
	            var raw = element[0];
	            var isDisabled = $parse(attr.lpInfiniteScrollDisabled);
	            var isEnd = $parse(attr.lpInfiniteScrollEnd);

	            var handler = function handler(event) {
	                var scrollTop, yMax;
	                var disabled = isDisabled(scope);
	                if (!isEnd(scope)) {
	                    if (!disabled) {
	                        scrollTop = raw.scrollTop;
	                        yMax = raw.scrollHeight - raw.offsetHeight;
	                        if (scrollTop === yMax) {
	                            scope.$apply(attr.lpInfiniteScroll);
	                        }
	                    }
	                }
	            };

	            var wheelHandler = function wheelHandler(event) {
	                var scrollTop, yMax;

	                if (!isEnd(scope)) {
	                    scrollTop = raw.scrollTop;
	                    yMax = raw.scrollHeight - raw.offsetHeight;
	                    if (scrollTop === yMax) {
	                        return isDisabled(scope) ? undefined : event.preventDefault();
	                    }
	                }
	            };

	            scope.$on('$destroy', function () {
	                element.unbind('scroll', handler);
	                return element.unbind('mousewheel', wheelHandler);
	            });

	            element.bind('scroll', handler);
	            element.bind('mousewheel', wheelHandler);
	        }

	        return {
	            restrict: 'A',
	            link: linkFn };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.element-resize';

	    var base = __webpack_require__(20);

	    var deps = [];

	    module.exports = base.createModule(module.name, deps).
	    directive(__webpack_require__(89));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var angular = __webpack_require__(20).ng;

	    /**
	                                       * Uses the correct implementation of requestAnimationFrame,
	                                       *     or uses setTimeout as a fallback.
	                                       *
	                                       * @param   {Function} fn The callback function to be called
	                                       * @returns Returns the requestAnimationFrame function result
	                                       */
	    var requestFrame = function requestFrame(fn) {
	        var raf = window.requestAnimationFrame ||
	        window.mozRequestAnimationFrame ||
	        window.webkitRequestAnimationFrame ||
	        function () {return window.setTimeout(fn, 20);};

	        return raf(fn);
	    };

	    /**
	        * Funtion that cancels the requestAnimationFrame callback or it's setTimeout fallback.
	        *
	        * @param  id {Object} The id of the requestAnimationFrame to be canceled
	        * @return    Returns the cancelAnimationFrame function result
	        */
	    var cancelFrame = function cancelFrame(id) {
	        var cancel = window.cancelAnimationFrame ||
	        window.mozCancelAnimationFrame ||
	        window.webkitCancelAnimationFrame ||
	        window.clearTimeout;

	        return cancel(id);
	    };

	    // @ngInject
	    exports.lpElementResize = function ($parse) {
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                // function to be called when a resize happens (passed in as the value for the directive attribute)
	                var callback = $parse(attrs.elementResize || attrs.lpElementResize); // 'elementResize' for backwards compat.

	                var shadowElement;
	                var resizeTarget = element[0];
	                var resizeId;
	                var previousSize = {};
	                // Interval id for initializing the shadow element when the element is visible
	                var initializeInterval;
	                // boolean value defining attachEvent/addEventListener support
	                var hasAttachEvent = false;

	                // Returns true if the size of the element has changed
	                var checkResize = function checkResize() {
	                    return resizeTarget.offsetWidth !== previousSize.width ||
	                    resizeTarget.offsetHeight !== previousSize.height;
	                };

	                // Resets the size of the resize elements after size change
	                var resetTriggers = function resetTriggers() {
	                    var triggers = shadowElement[0];
	                    var expand = triggers.querySelector('.expand-trigger');
	                    var contract = triggers.querySelector('.contract-trigger');
	                    var expandChild = triggers.querySelector('.expand-trigger > div');

	                    // move the scroll to it's maximum so in case of a resize it will trigger a scroll event
	                    contract.scrollLeft = contract.scrollWidth;
	                    contract.scrollTop = contract.scrollHeight;
	                    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	                    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	                    expand.scrollLeft = expand.scrollWidth;
	                    expand.scrollTop = expand.scrollHeight;
	                };

	                // The "resize" event callback function
	                var resizeListener = function resizeListener(event) {
	                    // no need to reset the elements on IE
	                    if (!hasAttachEvent) {
	                        resetTriggers();
	                    }

	                    // if the previous callback hasn't fired yet, cancel it in favour of the new one
	                    if (resizeId) {
	                        cancelFrame(resizeId);
	                    }
	                    // schedule the callback to be called during the next browser repaint cycle
	                    resizeId = requestFrame(function () {
	                        if (checkResize()) {
	                            previousSize.width = resizeTarget.offsetWidth;
	                            previousSize.height = resizeTarget.offsetHeight;

	                            // fire the callback function with width and height as params
	                            callback(scope, { data: { element: element, width: resizeTarget.offsetWidth, height: resizeTarget.offsetHeight } });
	                        }
	                    });
	                };

	                var resizeEventInit = function resizeEventInit() {
	                    previousSize.width = resizeTarget.offsetWidth;
	                    previousSize.height = resizeTarget.offsetHeight;

	                    // for IE lt 11 use the native element resize event
	                    resizeTarget.attachEvent('onresize', resizeListener);

	                    // fire the callback function when the directive is initialized
	                    callback(scope, { data: { element: element, width: resizeTarget.offsetWidth, height: resizeTarget.offsetHeight } });
	                };

	                var scrollEventInit = function scrollEventInit() {
	                    // create and append to the DOM the resize helper elements
	                    shadowElement = angular.element('<div class="responsive-shadow">' +
	                    '<div class="expand-trigger"><div></div></div>' +
	                    '<div class="contract-trigger"></div>' +
	                    '</div>');
	                    element.append(shadowElement);

	                    resetTriggers();
	                    previousSize.width = resizeTarget.offsetWidth;
	                    previousSize.height = resizeTarget.offsetHeight;

	                    // for IE11 and other browsers, use scroll event to for fire the resize check
	                    resizeTarget.addEventListener('scroll', resizeListener, true);

	                    // fire the callback function when the directive is initialized
	                    callback(scope, { data: { element: element, width: resizeTarget.offsetWidth, height: resizeTarget.offsetHeight } });
	                };

	                var initialize = function initialize() {
	                    // set the existance of attachEvent (only on IE lt 11)
	                    hasAttachEvent = !!document.attachEvent;

	                    if (hasAttachEvent) {
	                        resizeEventInit();
	                    } else {
	                        if (resizeTarget.offsetWidth === 0 && resizeTarget.offsetHeight === 0) {
	                            if (!initializeInterval) {
	                                initializeInterval = window.setInterval(function () {
	                                    if (resizeTarget.offsetWidth !== 0 && resizeTarget.offsetHeight !== 0) {
	                                        window.clearInterval(initializeInterval);
	                                        scrollEventInit();
	                                    }
	                                }, 250);
	                            }
	                        } else {
	                            scrollEventInit();
	                        }
	                    }
	                };

	                // initialization function
	                initialize();
	            } };

	    };

	    /*
	        * @deprecated, will remove in LP 0.13.0
	        */
	    exports.elementResize = exports.lpElementResize; // backwards compatible.
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.custom-select';

	    var base = __webpack_require__(20);

	    module.exports = base.
	    createModule(module.name, []).
	    directive(__webpack_require__(91));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(20).utils;

	    // @ngInject
	    exports.lpCustomSelect = function () {
	        function linkFn(scope, elem) {
	            var $root = elem.find('[data-role="select"]');
	            var $select = elem.find('select');

	            scope.getSelected = function () {
	                return utils.find(scope.options, function (option) {
	                    return option.value === scope.value;
	                });
	            };

	            $select.on('focus', function () {
	                $root.addClass('focus');
	            });

	            $select.on('blur', function () {
	                $root.removeClass('focus');
	            });
	        }

	        function templateFn(elem, attrs) {
	            var required = utils.parseBoolean(attrs.required);
	            var placeholder = utils.escape(attrs.placeholder);
	            var name = utils.escape(attrs.name);

	            return (
	                '<div class="custom-select btn btn-default form-control" data-role="select" ng-class="{disabled: ngDisabled}">' +
	                '<span class="custom-select-placeholder" ng-show="!value">' + placeholder + '</span>' +
	                '<span class="custom-select-value" ng-show="value">{{getSelected().text}}</span>' +
	                '<span class="custom-select-caret caret"></span>' +
	                '<select class="custom-select-input"' +
	                ' name="' + name + '"' +
	                ' ng-model="value"' +
	                ' ng-disabled="ngDisabled"' +
	                ' ng-options="option.value as option.text for option in options"' +
	                ' ' + (required ? 'required="required"' : '') + '>' +
	                '<option style="display: none;" value=""></option>>' +
	                '</select>' +
	                '</div>');

	        }

	        return {
	            restrict: 'EA',
	            link: linkFn,
	            template: templateFn,
	            scope: {
	                ngDisabled: '=',
	                options: '=',
	                value: '=' } };


	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.custom-radio';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    var deps = [
	    core.name];


	    return base.createModule(module.name, deps).
	    directive(__webpack_require__(93));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(20).utils;

	    /**
	                                        * @ngdoc directive
	                                        * @module ui.custom-radio
	                                        * @name lpCustomRadio
	                                        *
	                                        * @restrict EA
	                                        *
	                                        * @description
	                                        * The `<lp-custom-radio>` directive wraps native input type radio and hides it,
	                                        * allowing to style it and apply animations.
	                                        *
	                                        * @param {string} ng-model Assignable angular expression to data-bind to.
	                                        * @param {boolean} ng-disabled Used to disable the component.
	                                        * @param {string} name Identifies the input.
	                                        * @param {string} value Will be stored in `ngModel` when this radio is selected.
	                                        * @param {string} ngValue Assignable angular expression for radio button value.
	                                        *
	                                        * @usage
	                                        *
	                                        *   <lp-custom-radio
	                                        *        ng-model="radioModel"
	                                        *        value="{{ numbers.value }}"
	                                        *        name="numbers">
	                                        *
	                                        *          {{ numbers.value }}
	                                        *
	                                        *   </lp-custom-radio>
	                                        *
	                                        */
	    exports.lpCustomRadio = function () {
	        function linkFn(scope, elem, attrs) {
	            var $root = elem.find('label');
	            var $input = elem.find('input');

	            $input.on('focus', function () {
	                $root.addClass('focus');
	            });

	            $input.on('blur', function () {
	                $root.removeClass('focus');
	            });

	            scope.isChecked = function () {
	                if (!utils.isUndefined(scope.ngValue)) {
	                    return scope.ngModel === scope.ngValue;
	                } else if (!utils.isUndefined(scope.value)) {
	                    /*eslint eqeqeq:0*/
	                    return scope.ngModel == scope.value;
	                } else {
	                    return false;
	                }
	            };
	        }

	        function templateFn(elem, attrs) {
	            var name = utils.isUndefined(attrs.name) ? '' : utils.escape(attrs.name);

	            return (
	                '<label class="custom-radio" ng-class="{disabled: ngDisabled, checked: isChecked()}">' +
	                '<span class="custom-radio-wrapper"></span>' +
	                '<span class="custom-radio-check" ng-show="isChecked()"></span>' +
	                '<input class="custom-radio-input"' +
	                ' type="radio" ' + (
	                name ? ' name="' + name + '" ' : '') + (
	                !utils.isUndefined(attrs.value) ? ' value="{{ value }}" ' : '') + (
	                !utils.isUndefined(attrs.ngValue) ? ' ng-value="ngValue" ' : '') +
	                ' ng-model="ngModel" ' +
	                ' ng-disabled="ngDisabled" ' +
	                ' aria-label="{{ value }}" />' +
	                '<span ng-transclude class="custom-radio-label"></span>' +
	                '</label>');

	        }

	        return {
	            restrict: 'EA',
	            link: linkFn,
	            require: '^?ngModel',
	            transclude: true,
	            template: templateFn,
	            scope: {
	                ngDisabled: '=',
	                ngModel: '=',
	                value: '@',
	                ngValue: '=' } };


	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.custom-checkbox';

	    var base = __webpack_require__(20);
	    var core = __webpack_require__(26);

	    var deps = [
	    core.name];


	    return base.createModule(module.name, deps).
	    directive(__webpack_require__(95));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var utils = __webpack_require__(20).utils;

	    /**
	                                        * @ngdoc directive
	                                        * @module ui.custom-checkbox
	                                        * @name lpCustomCheckbox
	                                        *
	                                        * @restrict EA
	                                        *
	                                        * @description
	                                        * The `<lp-custom-checkbox>` directive wraps native input type checkbox and hides it,
	                                        * allowing to style it and apply animations.
	                                        *
	                                        * @param {string} ng-model Assignable angular expression to data-bind to.
	                                        * @param {boolean} ng-disabled Used to disable the component.
	                                        * @param {string} name Identifies the input.
	                                        * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	                                        * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	                                        * @param {string=} ngChange Angular expression to be executed when input changes due to user
	                                        *    interaction with the input element.
	                                        *
	                                        * @usage
	                                        *
	                                        *   <lp-custom-checkbox
	                                        *        ng-model="sendNotification"
	                                        *        name="notification">
	                                        *
	                                        *          Send notification
	                                        *
	                                        *   </lp-custom-checkbox>
	                                        */
	    exports.lpCustomCheckbox = function () {
	        function linkFn(scope, elem, attrs, ctrl) {
	            var $root = elem.find('label');
	            var $input = elem.find('input');

	            $input.on('focus', function () {
	                $root.addClass('focus');
	            });

	            $input.on('blur', function () {
	                $root.removeClass('focus');
	            });

	            ctrl.$isEmpty = function (value) {
	                if (attrs.ngFalseValue) {
	                    return value === scope.ngFalseValue;
	                }

	                return value === false;
	            };

	            scope.isChecked = function () {
	                if (attrs.ngTrueValue) {
	                    return scope.ngModel === attrs.ngTrueValue;
	                }
	                return scope.ngModel;
	            };

	            scope.onChange = function () {
	                ctrl.$setViewValue(scope.ngModel);
	            };
	        }

	        function templateFn(elem, attrs) {
	            var required = utils.parseBoolean(attrs.required);
	            var name = utils.isUndefined(attrs.name) ? '' : utils.escape(attrs.name);
	            var ariaLabel = utils.isUndefined(attrs.ariaLabel) ? '' : utils.escape(attrs.ariaLabel);
	            var ngTrueValue = attrs.ngTrueValue ? ' ng-true-value="' + attrs.ngTrueValue + '" ' : '';
	            var ngFalseValue = attrs.ngFalseValue ? ' ng-false-value="' + attrs.ngFalseValue + '" ' : '';

	            return (
	                '<label class="custom-checkbox" ng-class="{\'disabled\': ngDisabled, \'checked\': isChecked()}">' +
	                '<div class="custom-checkbox-box"></div>' +
	                '<div class="custom-checkbox-checkmark" ng-show="ngModel">' +
	                '<div class="custom-checkbox-stem"></div>' +
	                '<div class="custom-checkbox-kick"></div>' +
	                '</div>' +
	                '<input class="custom-checkbox-input"' +
	                ' type="checkbox" ' + (
	                name ? ' name="' + name + '" ' : '') +
	                ' ng-model="ngModel" ' +
	                ' ng-disabled="ngDisabled" ' +
	                ngTrueValue +
	                ngFalseValue + (
	                !utils.isUndefined(attrs.ngChange) ? 'ng-change="onChange()" ' : '') + (
	                required ? 'required="required"' : '') + (
	                ariaLabel ? ' aria-label="' + ariaLabel + '" ' : ' ') + '/>' +
	                '<span ng-transclude class="custom-checkbox-label"></span>' +
	                '</label>');

	        }

	        return {
	            restrict: 'EA',
	            link: linkFn,
	            require: 'ngModel',
	            transclude: true,
	            template: templateFn,
	            scope: {
	                ngModel: '=',
	                ngDisabled: '=?',
	                ngTrueValue: '=?',
	                ngFalseValue: '=?',
	                ngChange: '&?' } };


	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'ui.floating-label';

	    var base = __webpack_require__(20);

	    var deps = [];


	    return base.createModule(module.name, deps).
	    directive(__webpack_require__(97));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	                   * @ngdoc directive
	                   * @module ui.floating-label
	                   * @name lpFloatingLabel
	                   *
	                   * @restrict A
	                   *
	                   * @description
	                   * The `<label floating-label for="inputId">Name</label>` directive transforms regular input label to floating label.
	                   * Label moves up when input field is focused.
	                   *
	                   * @param {string} for Assignable angular expression to data-bind to.
	                   *
	                   * @usage
	                   *   <form name="demoForm">
	                   *       <label floating-label for="memo">Memo</label>
	                   *       <input id="memo" name="memo" type="text" ng-model="memo" />
	                   *   </form>
	                   *
	                   * @ngInject
	                   */
	    exports.lpFloatingLabel = function ($timeout) {
	        function linkFn(scope, label, attrs) {
	            var inputCtrl = null;
	            var wrapperTemplate = '<div class="lp-floating-label"></div>';
	            var $input = label.next('[id=' + attrs['for'] + ']');
	            var $wrapper;

	            var onModelUpdate = function onModelUpdate(value) {
	                // Move label to default state if input is empty
	                if (!inputCtrl.$modelValue) {
	                    label.removeClass('float-top');
	                    $wrapper.removeClass('input-error');
	                } else {
	                    label.addClass('float-top');
	                }

	                return value;
	            };

	            var onInputViewUpdate = function onInputViewUpdate() {
	                $wrapper.toggleClass('input-error', !inputCtrl.$valid);
	            };

	            $timeout(function () {
	                //get input controller
	                inputCtrl = $input.controller('ngModel');
	                //watch for model value changes
	                inputCtrl.$formatters.push(onModelUpdate);
	                //watch for view value changes
	                inputCtrl.$viewChangeListeners.push(onInputViewUpdate);

	                //move label to top if input is preinitialized with value
	                if ($input.val()) {
	                    label.addClass('float-top');
	                }
	            }, 0, false);

	            $input.on('focus', function () {
	                // Move label to top on input focus
	                label.addClass('float-top');
	            });

	            $input.on('blur', function () {
	                // Don't move label to default state if input is not empty
	                if (!inputCtrl.$viewValue) {
	                    label.removeClass('float-top');
	                }
	            });

	            //wrap label
	            label.wrap(wrapperTemplate);

	            //add input field to the wrapper
	            $wrapper = label.parent();
	            $wrapper.append($input);
	        }

	        return {
	            restrict: 'A',
	            link: linkFn };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.datepicker';

	    module.exports = base.createModule(module.name, ['ui.bootstrap']).
	    constant(__webpack_require__(99)).
	    service(__webpack_require__(100)).
	    controller(__webpack_require__(101)).
	    directive(__webpack_require__(102)).
	    run(__webpack_require__(103));

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.datepickerConfig = {
	        formatDay: 'dd',
	        formatMonth: 'MMMM',
	        formatYear: 'yyyy',
	        formatDayHeader: 'EEE',
	        formatDayTitle: 'MMMM yyyy',
	        formatMonthTitle: 'yyyy',
	        datepickerMode: 'day',
	        minMode: 'day',
	        maxMode: 'year',
	        showWeeks: false,
	        startingDay: 0,
	        yearRange: 20,
	        minDate: null,
	        maxDate: null };


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    exports.dateParser = function ($locale, orderByFilter) {

	        this.parsers = {};

	        var formatCodeToRegex = {
	            'yyyy': {
	                regex: '\\d{4}',
	                apply: function apply(value) {this.year = +value;} },

	            'yy': {
	                regex: '\\d{2}',
	                apply: function apply(value) {this.year = +value + 2000;} },

	            'y': {
	                regex: '\\d{1,4}',
	                apply: function apply(value) {this.year = +value;} },

	            'MMMM': {
	                regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	                apply: function apply(value) {this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);} },

	            'MMM': {
	                regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	                apply: function apply(value) {this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);} },

	            'MM': {
	                regex: '0[1-9]|1[0-2]',
	                apply: function apply(value) {this.month = value - 1;} },

	            'M': {
	                regex: '[1-9]|1[0-2]',
	                apply: function apply(value) {this.month = value - 1;} },

	            'dd': {
	                regex: '[0-2][0-9]{1}|3[0-1]{1}',
	                apply: function apply(value) {this.date = +value;} },

	            'd': {
	                regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	                apply: function apply(value) {this.date = +value;} },

	            'EEEE': {
	                regex: $locale.DATETIME_FORMATS.DAY.join('|') },

	            'EEE': {
	                regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|') } };



	        this.createParser = function (format) {
	            var map = [],regex = format.split('');

	            angular.forEach(formatCodeToRegex, function (data, code) {
	                var index = format.indexOf(code);

	                if (index > -1) {
	                    format = format.split('');

	                    regex[index] = '(' + data.regex + ')';
	                    format[index] = '$'; // Custom symbol to define consumed part of format
	                    for (var i = index + 1, n = index + code.length; i < n; i++) {
	                        regex[i] = '';
	                        format[i] = '$';
	                    }
	                    format = format.join('');

	                    map.push({ index: index, apply: data.apply });
	                }
	            });

	            return {
	                regex: new RegExp('^' + regex.join('') + '$'),
	                map: orderByFilter(map, 'index') };

	        };

	        this.parse = function (input, format) {
	            if (!angular.isString(input)) {
	                return input;
	            }

	            format = $locale.DATETIME_FORMATS[format] || format;

	            if (!this.parsers[format]) {
	                this.parsers[format] = this.createParser(format);
	            }

	            var parser = this.parsers[format],
	            regex = parser.regex,
	            map = parser.map,
	            results = input.match(regex);

	            if (results && results.length) {
	                var fields = { year: 1900, month: 0, date: 1, hours: 0 },dt;

	                for (var i = 1, n = results.length; i < n; i++) {
	                    var mapper = map[i - 1];
	                    if (mapper.apply) {
	                        mapper.apply.call(fields, results[i]);
	                    }
	                }

	                if (isValid(fields.year, fields.month, fields.date)) {
	                    dt = new Date(fields.year, fields.month, fields.date, fields.hours);
	                }

	                return dt;
	            }
	        };

	        // Check if date is valid for specific month (and year for February).
	        // Month: 0 = Jan, 1 = Feb, etc
	        function isValid(year, month, date) {
	            if (month === 1 && date > 28) {
	                return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	            }

	            if (month === 3 || month === 5 || month === 8 || month === 10) {
	                return date < 31;
	            }

	            return true;
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';
		var base = __webpack_require__(20);
		var angular = base.ng;

		// @ngInject
		exports.DatepickerController = function ($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
			var self = this,
			ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

			// Modes chain
			this.modes = ['day', 'month', 'year'];

			// Configuration attributes
			angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
			'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange'], function (key, index) {
				self[key] = angular.isDefined($attrs[key]) ? index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];
			});

			// Watchable attributes
			angular.forEach(['minDate', 'maxDate'], function (key) {
				if ($attrs[key]) {
					$scope.$parent.$watch($parse($attrs[key]), function (value) {
						self[key] = value ? new Date(value) : null;
						self.refreshView();
					});
				} else {
					self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
				}
			});

			$scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;

			$scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
			this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();

			$scope.isActive = function (dateObject) {
				if (self.compare(dateObject.date, self.activeDate) === 0) {
					$scope.activeDateId = dateObject.uid;
					return true;
				}
				return false;
			};

			this.init = function (ngModelCtrl_) {
				ngModelCtrl = ngModelCtrl_;

				ngModelCtrl.$render = function () {
					self.render();
				};
			};

			this.render = function () {
				if (ngModelCtrl.$modelValue) {
					var date = new Date(ngModelCtrl.$modelValue),
					isValid = !isNaN(date);

					if (isValid) {
						this.activeDate = date;
					} else {
						$log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
					}
					ngModelCtrl.$setValidity('date', isValid);
				}
				this.refreshView();
			};

			this.refreshView = function () {
				if (this.element) {
					this._refreshView();

					var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
					ngModelCtrl.$setValidity('date-disabled', !date || this.element && !this.isDisabled(date));
				}
			};

			this.createDateObject = function (date, format) {
				var model = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
				return {
					date: date,
					label: dateFilter(date, format),
					selected: model && this.compare(date, model) === 0,
					disabled: this.isDisabled(date),
					current: this.compare(date, new Date()) === 0 };

			};

			this.isDisabled = function (date) {
				return this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
			};

			// Split array into smaller arrays
			this.split = function (arr, size) {
				var arrays = [];
				while (arr.length > 0) {
					arrays.push(arr.splice(0, size));
				}
				return arrays;
			};

			$scope.select = function (date) {
				if ($scope.datepickerMode === self.minMode) {
					var dt = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date(0, 0, 0, 0, 0, 0, 0);
					dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
					ngModelCtrl.$setViewValue(dt);
					ngModelCtrl.$render();
				} else {
					self.activeDate = date;
					$scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
				}
			};

			$scope.move = function (direction) {
				var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
				month = self.activeDate.getMonth() + direction * (self.step.months || 0);
				self.activeDate.setFullYear(year, month, 1);
				self.refreshView();
			};

			$scope.toggleMode = function (direction) {
				direction = direction || 1;

				if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
					return;
				}

				$scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
			};

			// Key event mapper
			$scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

			var focusElement = function focusElement() {
				$timeout(function () {
					self.element[0].focus();
				}, 0, false);
			};

			// Listen for focus requests from popup directive
			$scope.$on('datepicker.focus', focusElement);

			$scope.keydown = function (evt) {
				var key = $scope.keys[evt.which];

				if (!key || evt.shiftKey || evt.altKey) {
					return;
				}

				evt.preventDefault();
				evt.stopPropagation();

				if (key === 'enter' || key === 'space') {
					if (self.isDisabled(self.activeDate)) {
						return; // do nothing
					}
					$scope.select(self.activeDate);
					focusElement();
				} else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
					$scope.toggleMode(key === 'up' ? 1 : -1);
					focusElement();
				} else {
					self.handleKeyDown(key, evt);
					self.refreshView();
				}
			};
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var angular = base.ng;

	    // @ngInject
	    exports.datepicker = function () {
	        return {
	            restrict: 'EA',
	            replace: true,
	            templateUrl: 'template/datepicker/datepicker.html',
	            scope: {
	                datepickerMode: '=?',
	                dateDisabled: '&' },

	            require: ['datepicker', '?^ngModel'],
	            controller: 'DatepickerController',
	            link: function link(scope, element, attrs, ctrls) {

	                var datepickerCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	                if (attrs.datepickerMode) {
	                    scope.datepickerMode = attrs.datepickerMode;
	                }

	                if (ngModelCtrl) {
	                    datepickerCtrl.init(ngModelCtrl);
	                }
	            } };

	    };

	    // @ngInject
	    exports.daypicker = function (dateFilter) {
	        return {
	            restrict: 'EA',
	            replace: true,
	            templateUrl: 'template/datepicker/day.html',
	            require: '^datepicker',
	            link: function link(scope, element, attrs, ctrl) {
	                scope.showWeeks = ctrl.showWeeks;

	                ctrl.step = { months: 1 };
	                ctrl.element = element;

	                function getDaysInMonth(year, month) {
	                    return 32 - new Date(year, month, 32).getDate();
	                }

	                function getDates(startDate, n) {
	                    var dates = new Array(n),current = new Date(startDate),i = 0;
	                    current.setHours(12); // Prevent repeated dates because of timezone bug
	                    while (i < n) {
	                        dates[i++] = new Date(current);
	                        current.setDate(current.getDate() + 1);
	                    }
	                    return dates;
	                }

	                ctrl._refreshView = function () {
	                    var year = ctrl.activeDate.getFullYear(),
	                    month = ctrl.activeDate.getMonth(),
	                    firstDayOfMonth = new Date(year, month, 1),
	                    difference = ctrl.startingDay - firstDayOfMonth.getDay(),
	                    numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
	                    firstDate = new Date(firstDayOfMonth),numDates = 0;

	                    if (numDisplayedFromPreviousMonth > 0) {
	                        firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	                        numDates += numDisplayedFromPreviousMonth; // Previous
	                    }
	                    numDates += getDaysInMonth(year, month); // Current
	                    numDates += (7 - numDates % 7) % 7; // Next

	                    var days = getDates(firstDate, numDates);
	                    for (var i = 0; i < numDates; i++) {
	                        days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
	                            secondary: days[i].getMonth() !== month,
	                            uid: scope.uniqueId + '-' + i });

	                    }

	                    scope.labels = new Array(7);
	                    for (var j = 0; j < 7; j++) {
	                        scope.labels[j] = {
	                            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
	                            full: dateFilter(days[j].date, 'EEEE') };

	                    }

	                    scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
	                    scope.rows = ctrl.split(days, 7);

	                    if (scope.showWeeks) {
	                        scope.weekNumbers = [];
	                        var weekNumber = getISO8601WeekNumber(scope.rows[0][0].date),
	                        numWeeks = scope.rows.length;
	                        while (scope.weekNumbers.push(weekNumber++) < numWeeks) {}
	                    }
	                };

	                ctrl.compare = function (date1, date2) {
	                    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	                };

	                function getISO8601WeekNumber(date) {
	                    var checkDate = new Date(date);
	                    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	                    var time = checkDate.getTime();
	                    checkDate.setMonth(0); // Compare with Jan 1
	                    checkDate.setDate(1);
	                    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	                }

	                ctrl.handleKeyDown = function (key, evt) {
	                    var date = ctrl.activeDate.getDate();

	                    if (key === 'left') {
	                        date = date - 1; // up
	                    } else if (key === 'up') {
	                        date = date - 7; // down
	                    } else if (key === 'right') {
	                        date = date + 1; // down
	                    } else if (key === 'down') {
	                        date = date + 7;
	                    } else if (key === 'pageup' || key === 'pagedown') {
	                        var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
	                        ctrl.activeDate.setMonth(month, 1);
	                        date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
	                    } else if (key === 'home') {
	                        date = 1;
	                    } else if (key === 'end') {
	                        date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
	                    }
	                    ctrl.activeDate.setDate(date);
	                };

	                ctrl.refreshView();
	            } };

	    };

	    // @ngInject
	    exports.monthpicker = function (dateFilter) {
	        return {
	            restrict: 'EA',
	            replace: true,
	            templateUrl: 'template/datepicker/month.html',
	            require: '^datepicker',
	            link: function link(scope, element, attrs, ctrl) {
	                ctrl.step = { years: 1 };
	                ctrl.element = element;

	                ctrl._refreshView = function () {
	                    var months = new Array(12),
	                    year = ctrl.activeDate.getFullYear();

	                    for (var i = 0; i < 12; i++) {
	                        months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {
	                            uid: scope.uniqueId + '-' + i });

	                    }

	                    scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
	                    scope.rows = ctrl.split(months, 3);
	                };

	                ctrl.compare = function (date1, date2) {
	                    return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
	                };

	                ctrl.handleKeyDown = function (key, evt) {
	                    var date = ctrl.activeDate.getMonth();

	                    if (key === 'left') {
	                        date = date - 1; // up
	                    } else if (key === 'up') {
	                        date = date - 3; // down
	                    } else if (key === 'right') {
	                        date = date + 1; // down
	                    } else if (key === 'down') {
	                        date = date + 3;
	                    } else if (key === 'pageup' || key === 'pagedown') {
	                        var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
	                        ctrl.activeDate.setFullYear(year);
	                    } else if (key === 'home') {
	                        date = 0;
	                    } else if (key === 'end') {
	                        date = 11;
	                    }
	                    ctrl.activeDate.setMonth(date);
	                };

	                ctrl.refreshView();
	            } };

	    };

	    // @ngInject
	    exports.yearpicker = function (dateFilter) {
	        return {
	            restrict: 'EA',
	            replace: true,
	            templateUrl: 'template/datepicker/year.html',
	            require: '^datepicker',
	            link: function link(scope, element, attrs, ctrl) {
	                var range = ctrl.yearRange;

	                ctrl.step = { years: range };
	                ctrl.element = element;

	                function getStartingYear(year) {
	                    return parseInt((year - 1) / range, 10) * range + 1;
	                }

	                ctrl._refreshView = function () {
	                    var years = new Array(range);

	                    for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
	                        years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {
	                            uid: scope.uniqueId + '-' + i });

	                    }

	                    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	                    scope.rows = ctrl.split(years, 5);
	                };

	                ctrl.compare = function (date1, date2) {
	                    return date1.getFullYear() - date2.getFullYear();
	                };

	                ctrl.handleKeyDown = function (key, evt) {
	                    var date = ctrl.activeDate.getFullYear();

	                    if (key === 'left') {
	                        date = date - 1; // up
	                    } else if (key === 'up') {
	                        date = date - 5; // down
	                    } else if (key === 'right') {
	                        date = date + 1; // down
	                    } else if (key === 'down') {
	                        date = date + 5;
	                    } else if (key === 'pageup' || key === 'pagedown') {
	                        date += (key === 'pageup' ? -1 : 1) * ctrl.step.years;
	                    } else if (key === 'home') {
	                        date = getStartingYear(ctrl.activeDate.getFullYear());
	                    } else if (key === 'end') {
	                        date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
	                    }
	                    ctrl.activeDate.setFullYear(date);
	                };

	                ctrl.refreshView();
	            } };

	    };


	    // @ngInject
	    exports.datepickerPopup = function ($compile, $parse, $document, $position, dateFilter, datepickerPopupConfig, dateParser) {
	        return {
	            restrict: 'EA',
	            require: 'ngModel',
	            scope: {
	                isOpen: '=?',
	                currentText: '@',
	                clearText: '@',
	                closeText: '@',
	                dateDisabled: '&' },

	            link: function link(scope, element, attrs, ngModel) {
	                var dateFormat,
	                closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
	                appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;

	                scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	                scope.datepickerMode = angular.isDefined(attrs.datepickerMode) ? attrs.datepickerMode : 'day';
	                scope.showWeeks = angular.isDefined(attrs.showWeeks) ? attrs.showWeeks : false;

	                scope.getText = function (key) {
	                    return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	                };

	                attrs.$observe('datepickerPopup', function (value) {
	                    dateFormat = value || datepickerPopupConfig.datepickerPopup;
	                    ngModel.$render();
	                });

	                // popup element used to display calendar
	                var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
	                popupEl.attr({
	                    'ng-model': 'date',
	                    'ng-change': 'dateSelection()' });


	                function cameltoDash(string) {
	                    return string.replace(/([A-Z])/g, function ($1) {return '-' + $1.toLowerCase();});
	                }

	                // datepicker element
	                var datepickerEl = angular.element(popupEl.children()[0]);

	                if (attrs.datepickerOptions) {
	                    angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function (value, option) {
	                        datepickerEl.attr(cameltoDash(option), value);
	                    });
	                }

	                angular.forEach(['minDate', 'maxDate'], function (key) {
	                    if (attrs[key]) {
	                        scope.$parent.$watch($parse(attrs[key]), function (value) {
	                            scope[key] = value;
	                        });
	                        datepickerEl.attr(cameltoDash(key), key);
	                    }
	                });
	                if (attrs.dateDisabled) {
	                    datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	                }

	                function parseDate(viewValue) {
	                    if (!viewValue) {
	                        ngModel.$setValidity('date', true);
	                        return null;
	                    } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	                        ngModel.$setValidity('date', true);
	                        return viewValue;
	                    } else if (angular.isString(viewValue)) {
	                        var date = dateParser.parse(viewValue, dateFormat);
	                        if (isNaN(date)) {
	                            ngModel.$setValidity('date', false);
	                            return undefined;
	                        } else {
	                            ngModel.$setValidity('date', true);
	                            return date;
	                        }
	                    } else {
	                        ngModel.$setValidity('date', false);
	                        return undefined;
	                    }
	                }
	                ngModel.$parsers.unshift(parseDate);

	                // Inner change
	                scope.dateSelection = function (dt) {
	                    if (angular.isDefined(dt)) {
	                        scope.date = dt;
	                    }
	                    ngModel.$setViewValue(scope.date);
	                    ngModel.$render();

	                    if (closeOnDateSelection) {
	                        scope.isOpen = false;
	                        element[0].focus();
	                    }
	                };

	                element.bind('input change keyup', function () {
	                    scope.$apply(function () {
	                        scope.date = ngModel.$modelValue;
	                    });
	                });

	                // Outter change
	                ngModel.$render = function () {
	                    var currentValue = ngModel.$viewValue;
	                    if (currentValue && typeof currentValue === 'string') {
	                        currentValue = new Date(currentValue);
	                    }
	                    var date = currentValue ? dateFilter(currentValue, dateFormat) : '';
	                    element.val(date);
	                    scope.date = parseDate(ngModel.$modelValue);
	                };

	                var documentClickBind = function documentClickBind(event) {
	                    if (scope.isOpen && event.target !== element[0]) {
	                        scope.$apply(function () {
	                            scope.isOpen = false;
	                        });
	                    }
	                };

	                var addButtonAndInputListeners = function addButtonAndInputListeners() {
	                    $document.find("input").bind('click', documentClickBind);
	                    $document.find("button").bind('click', documentClickBind);

	                    $popup.find("input").unbind('click', documentClickBind);
	                    $popup.find("button").unbind('click', documentClickBind);
	                };

	                var removeButtonAndInputListeners = function removeButtonAndInputListeners() {
	                    $document.find("input").unbind('click', documentClickBind);
	                    $document.find("button").unbind('click', documentClickBind);
	                };

	                var keydown = function keydown(evt, noApply) {
	                    scope.keydown(evt);
	                };
	                element.bind('keydown', keydown);

	                scope.keydown = function (evt) {
	                    if (evt.which === 27) {
	                        evt.preventDefault();
	                        evt.stopPropagation();
	                        scope.close();
	                    } else if (evt.which === 40 && !scope.isOpen) {
	                        scope.isOpen = true;
	                    }
	                };

	                scope.$watch('isOpen', function (value) {
	                    if (value) {
	                        scope.$broadcast('datepicker.focus');
	                        scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	                        scope.position.top = scope.position.top + element.prop('offsetHeight');

	                        $document.bind('click', documentClickBind);
	                        addButtonAndInputListeners();
	                    } else {
	                        $document.unbind('click', documentClickBind);
	                        removeButtonAndInputListeners();
	                    }
	                });

	                scope.select = function (date) {
	                    if (date === 'today') {
	                        var today = new Date();
	                        if (angular.isDate(ngModel.$modelValue)) {
	                            date = new Date(ngModel.$modelValue);
	                            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	                        } else {
	                            date = new Date(today.setHours(0, 0, 0, 0));
	                        }
	                    }
	                    scope.dateSelection(date);
	                };

	                scope.close = function () {
	                    scope.isOpen = false;
	                    element[0].focus();
	                };

	                var $popup = $compile(popupEl)(scope);


	                if (appendToBody) {
	                    $document.find('body').append($popup);
	                } else {
	                    element.after($popup);
	                }

	                scope.$on('$destroy', function () {
	                    $popup.remove();
	                    element.unbind('keydown', keydown);
	                    $document.unbind('click', documentClickBind);
	                    removeButtonAndInputListeners();
	                });
	            } };

	    };

	    exports.datepickerPopupWrap = function () {
	        return {
	            restrict: 'EA',
	            replace: true,
	            transclude: true,
	            templateUrl: 'template/datepicker/popup.html',
	            link: function link(scope, element, attrs) {
	                element.bind('click', function (event) {
	                    event.preventDefault();
	                    event.stopPropagation();
	                });

	                element.bind('keydown', function (event) {
	                    if (event.which === 9) {
	                        scope.$apply(function () {
	                            scope.isOpen = false;
	                        });
	                    }
	                });
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    module.exports = function ($templateCache) {
	        $templateCache.put("template/datepicker/datepicker.html",
	        "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	        "  <div daypicker=\"daypicker\" ng-switch-when=\"day\" tabindex=\"0\"></div>\n" +
	        "  <div monthpicker=\"monthpicker\" ng-switch-when=\"month\" tabindex=\"0\"></div>\n" +
	        "  <div yearpicker=\"yearpicker\" ng-switch-when=\"year\" tabindex=\"0\"></div>\n" +
	        "</div>");

	        $templateCache.put("template/datepicker/day.html",
	        "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	        "  <thead>\n" +
	        "    <tr>\n" +
	        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"lp-icon lp-icon-angle-left\"></i></button></th>\n" +
	        "      <th colspan=\"{{5 + showWeeks}}\"><button style=\"width:100%;\" id=\"{{uniqueId}}-title\" role=\"heading\"       aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"lp-icon lp-icon-angle-right\"></i></button></th>\n" +
	        "    </tr>\n" +
	        "    <tr>\n" +
	        "      <th ng-show=\"showWeeks\" class=\"text-center\"></th>\n" +
	        "      <th ng-repeat=\"label in labels track by $index\" class=\"text-center\"><small aria-label=\"{{label.full}}\">{{label.abbr}}</small></th>\n" +
	        "    </tr>\n" +
	        "  </thead>\n" +
	        "  <tbody>\n" +
	        "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	        "      <td ng-show=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	        "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	        "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-muted': dt.secondary, 'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	        "      </td>\n" +
	        "    </tr>\n" +
	        "  </tbody>\n" +
	        "</table>\n" +
	        "");

	        $templateCache.put("template/datepicker/month.html",
	        "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	        "  <thead>\n" +
	        "    <tr>\n" +
	        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"lp-icon lp-icon-angle-left\"></i></button></th>\n" +
	        "      <th><button style=\"width:100%;\" id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"lp-icon lp-icon-angle-right\"></i></button></th>\n" +
	        "    </tr>\n" +
	        "  </thead>\n" +
	        "  <tbody>\n" +
	        "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	        "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	        "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	        "      </td>\n" +
	        "    </tr>\n" +
	        "  </tbody>\n" +
	        "</table>\n" +
	        "");

	        $templateCache.put("template/datepicker/year.html",
	        "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	        "  <thead>\n" +
	        "    <tr>\n" +
	        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"lp-icon lp-icon-angle-left\"></i></button></th>\n" +
	        "      <th colspan=\"3\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-click=\"toggleMode()\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"lp-icon lp-icon-angle-right\"></i></button></th>\n" +
	        "    </tr>\n" +
	        "  </thead>\n" +
	        "  <tbody>\n" +
	        "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	        "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	        "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	        "      </td>\n" +
	        "    </tr>\n" +
	        "  </tbody>\n" +
	        "</table>\n" +
	        "");

	        $templateCache.put("template/datepicker/popup.html",
	        "<ul class=\"dropdown-menu lp-datepicker\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" +
	        " <li ng-transclude></li>\n" +
	        " <li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
	        "   <span class=\"btn-group\">\n" +
	        "     <button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" +
	        "     <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
	        "   </span>\n" +
	        "   <button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
	        " </li>\n" +
	        "</ul>\n" +
	        "");
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);

	    module.name = 'ui.dropdown';

	    module.exports = base.createModule(module.name, ['ui.bootstrap']).
	    constant(__webpack_require__(105)).
	    service(__webpack_require__(106)).
	    controller(__webpack_require__(107)).
	    directive(__webpack_require__(108)).
	    run(__webpack_require__(109));

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.dropdownSelectConfig = {
	        emptyPlaceholderText: 'Nothing selected' };


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    exports.dropdownService = function ($document) {
	        var openScope = null;

	        this.open = function (dropdownScope) {
	            if (!openScope) {
	                $document.bind('click', closeDropdown);
	                $document.bind('keydown', escapeKeyBind);
	            }

	            if (openScope && openScope !== dropdownScope) {
	                openScope.isOpen = false;
	            }

	            openScope = dropdownScope;
	        };

	        this.close = function (dropdownScope) {
	            if (openScope === dropdownScope) {
	                openScope = null;
	                $document.unbind('click', closeDropdown);
	                $document.unbind('keydown', escapeKeyBind);
	            }
	        };

	        var closeDropdown = function closeDropdown() {
	            openScope.$apply(function () {
	                openScope.isOpen = false;
	            });
	        };

	        var escapeKeyBind = function escapeKeyBind(evt) {
	            if (evt.which === 27) {
	                closeDropdown();
	            }
	        };
	    };

	    // @ngInject
	    exports.optionsParser = function ($parse) {
	        var DROPDOWN_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;

	        this.parse = function (input) {
	            var match = input.match(DROPDOWN_REGEXP);
	            if (!match) {
	                throw new Error(
	                'Expected dropdown specification in form of "_viewValue_ (as _label_)? (group by _groupname_)? for _item_ in _collection_"' +
	                ' but got "' + input + '".');
	            }

	            var valueName = match[4] || match[6];
	            return {
	                displayFn: $parse(match[2] || match[1]),
	                valueName: valueName,
	                keyName: match[5],
	                groupByFn: $parse(match[3] || ''),
	                valueFn: $parse(match[2] ? match[1] : valueName),
	                valuesFn: $parse(match[5]) };

	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';
		var base = __webpack_require__(20);
		var angular = base.ng;

		// @ngInject
		exports.DropdownController = function ($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate) {
			var self = this,
			scope = $scope.$new(), // create a child scope so we are not polluting original one
			openClass = dropdownConfig.openClass,
			getIsOpen,
			setIsOpen = angular.noop,
			toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;

			this.init = function (element) {
				self.$element = element;

				if ($attrs.isOpen) {
					getIsOpen = $parse($attrs.isOpen);
					setIsOpen = getIsOpen.assign;

					$scope.$watch(getIsOpen, function (value) {
						scope.isOpen = !!value;
					});
				}
			};

			this.toggle = function (open) {
				return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
			};

			// Allow other directives to watch status
			this.isOpen = function () {
				return scope.isOpen;
			};

			scope.focusToggleElement = function () {
				if (self.triggerElement) {
					self.triggerElement[0].focus();
				}
			};

			scope.$watch('isOpen', function (isOpen, wasOpen) {
				$animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);

				if (isOpen) {
					dropdownService.open(scope);
				} else {
					dropdownService.close(scope);

					if (wasOpen) {
						scope.focusToggleElement();
					}
				}

				setIsOpen($scope, isOpen);
				toggleInvoker($scope, { open: !!isOpen });
			});

			$scope.$on('$locationChangeSuccess', function () {
				scope.isOpen = false;
			});

			$scope.$on('$destroy', function () {
				scope.$destroy();
			});
		};

		// @ngInject
		exports.DropdownSelectController = function ($scope, $attrs, $parse, optionsParser, dropdownSelectConfig, filterFilter, $timeout) {
			var self = this,
			parserResult = optionsParser.parse($attrs.options || $attrs.ngOptions),
			ngModelCtrl = { $setViewValue: angular.noop },
			element,
			toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;

			$scope.wasOpen = false;
			$scope.multiple = angular.isDefined($attrs.multiple) ? $scope.$parent.$eval($attrs.multiple) : false;
			$scope.filter = {
				enabled: angular.isDefined($attrs.filter) ? $scope.$parent.$eval($attrs.filter) : false,
				value: '',
				key: $scope.filterKey };

			$scope.options = [];

			this.init = function (ngModelCtrl_, element_) {
				ngModelCtrl = ngModelCtrl_;
				element = element_;

				ngModelCtrl.$render = function () {
					self.render();
				};
			};

			this.onOptionsChange = function (sourceValues) {
				var locals = {};
				$scope.groups = {};
				$scope.options.length = 0;

				angular.forEach(sourceValues, function (value, index) {
					locals[parserResult.valueName] = value;

					var groupName = parserResult.groupByFn($scope, locals) || '',
					group;

					if (!(group = $scope.groups[groupName])) {
						group = $scope.groups[groupName] = { options: [] };
					}

					var option = {
						label: parserResult.displayFn($scope, locals),
						value: parserResult.valueFn($scope, locals),
						id: $scope.uniqueId + '-' + index };


					if ($scope.filter.key) {
						option[$scope.filter.key] = value[$scope.filter.key];
					}

					group.options.push(option);
					$scope.options.push(option);
				});

				$scope.filterOptions();
				this.render();
			};

			$scope.filterOptions = function () {
				if (!$scope.filter.value) {
					$scope.validOptions = $scope.options;
					angular.forEach($scope.options, function (option) {
						option.valid = true;
					});
				} else {
					var filter = {},filterKey = $scope.filter.key || 'label';
					filter[filterKey] = $scope.filter.value;

					$scope.validOptions = filterFilter($scope.options, filter);
					angular.forEach($scope.options, function (option) {
						option.valid = $scope.validOptions.indexOf(option) > -1;
					});
				}
			};

			this.render = function () {
				if ($scope.multiple) {
					renderMultiple();
				} else {
					renderSingle();
				}
			};

			$scope.isActive = function (option) {
				return option === $scope.activeOption;
			};

			function renderSingle() {
				$scope.selectedOption = null;
				$scope.activeOption = null;
				var found = false;
				angular.forEach($scope.options, function (option) {
					option.selected = !found && angular.equals(ngModelCtrl.$viewValue, option.value);
					if (option.selected) {
						$scope.selectedOption = option;
						$scope.activeOption = option;
						found = true;
					}
				});
			}

			function renderMultiple() {
				$scope.selectedOption = [];

				var viewValue = angular.isArray(ngModelCtrl.$viewValue) ? ngModelCtrl.$viewValue : [];
				angular.forEach($scope.options, function (option) {
					option.selected = viewValue.indexOf(option.value) > -1;

					if (option.selected) {
						$scope.selectedOption.push(option);
					}
				});
			}

			this.selectSingle = function (option) {
				ngModelCtrl.$setViewValue(option.value);
				ngModelCtrl.$render();
			};

			this.selectMultiple = function (option) {
				var values = ngModelCtrl.$viewValue || [];

				option.selected = !option.selected;
				if (option.selected) {
					values.push(option.value);
				} else {
					values.splice(values.indexOf(option.value), 1);
				}
				ngModelCtrl.$setViewValue(values);
				ngModelCtrl.$render();
			};

			$scope.select = function (option, e) {
				if ($scope.multiple) {
					self.selectMultiple(option);
				} else {
					self.selectSingle(option);
					$scope.isopen = false;
				}
			};

			$scope.isEmpty = function () {
				return !$scope.selectedOption || $scope.multiple && $scope.selectedOption.length === 0;
			};

			$scope.prevent = function (evt) {
				evt.preventDefault();
				evt.stopPropagation();
			};

			$scope.$parent.$watchCollection(parserResult.valuesFn, function (sourceValues) {
				self.onOptionsChange(sourceValues);
			});

			$scope.onKeydown = function (evt) {
				if (!$scope.isopen) {
					return;
				}

				if (/^(38|40|13|32|9)$/.test(evt.which)) {
					evt.preventDefault();
					evt.stopPropagation();

					var options = $scope.validOptions,
					index = options.indexOf($scope.activeOption);

					var listItems = element.find("li");

					for (var i = 0; i < listItems.length; i++) {
						var el = angular.element(listItems[i]);

						if (el.attr("role") !== "option") {
							listItems.splice(i, 1);
							i--;
						}
					}

					if ((evt.which === 13 || evt.which === 32 || evt.which === 9) && index > -1) {
						$scope.select(options[index]);
						return;
					}

					if (evt.which === 38 && index > 0) {
						index--; // up
					} else if (evt.which === 40 && index < options.length - 1) {
						index++; // down
					}

					listItems[index].focus();

					$scope.activeOption = options[index];
				}
			};

			// Respond on ng-disabled changes
			if ($attrs.ngDisabled || $attrs.disabled) {
				$attrs.$observe('disabled', function (value) {
					if (angular.isDefined(value)) {
						$scope.isDisabled = value;
					}
				});
			}
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    exports.dropdown = function () {
	        return {
	            restrict: 'CA',
	            controller: 'DropdownController',
	            link: function link(scope, element, attrs, dropdownCtrl) {
	                dropdownCtrl.init(element);
	            } };

	    };

	    // @ngInject
	    exports.dropdownToggle = function () {
	        return {
	            restrict: 'CA',
	            require: '?^dropdown',
	            link: function link(scope, element, attrs, dropdownCtrl) {
	                if (!dropdownCtrl) {
	                    return;
	                }

	                dropdownCtrl.triggerElement = element;

	                element.bind('click', function (event) {
	                    event.preventDefault();
	                    event.stopPropagation();

	                    if (!element.hasClass('disabled') && !element.prop('disabled')) {
	                        scope.$apply(function () {
	                            dropdownCtrl.toggle();
	                        });
	                    }
	                });

	                // WAI-ARIA
	                element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	                    element.attr('aria-expanded', !!isOpen);
	                });
	            } };

	    };

	    // @ngInject
	    exports.dropdownSelect = function () {
	        var instance = 0;
	        return {
	            require: ['dropdownSelect', '?^ngModel'],
	            restrict: 'EA',
	            replace: true,
	            scope: {
	                type: '@',
	                size: '@',
	                emptyPlaceholderText: '@',
	                filterPlaceholderText: '@',
	                optionTemplateUrl: '@',
	                filterKey: '@',
	                label: '@' },

	            templateUrl: 'template/dropdownSelect/select.html',
	            controller: 'DropdownSelectController',
	            link: function link(scope, element, attrs, ctrls) {
	                var dropdownSelectCtrl = ctrls[0],ngModelCtrl = ctrls[1];

	                scope.uniqueId = 'select-' + instance++ + '-' + Math.floor(Math.random() * 10000);

	                if (ngModelCtrl) {
	                    dropdownSelectCtrl.init(ngModelCtrl, element);
	                }
	            } };

	    };

	    // @ngInject
	    exports.selectOption = function ($http, $templateCache, $compile, $parse) {
	        return {
	            require: '^dropdownSelect',
	            restrict: 'A',
	            scope: {
	                option: '=selectOption' },

	            compile: function compile(elem, attrs) {
	                var templateUrlExpr = $parse(attrs.templateUrl);
	                return function (scope, element, attrs) {
	                    var templateUrl = templateUrlExpr(scope.$parent) || 'template/dropdownSelect/option.html';

	                    $http.get(templateUrl, { cache: $templateCache }).success(function (tplContent) {
	                        tplContent = tplContent.replace(/(^\s+|\s+$)/g, '');
	                        element.append($compile(tplContent)(scope));
	                    });
	                };
	            } };

	    };

	    // @ngInject
	    exports.placeholderEmpty = function (dropdownSelectConfig) {
	        return {
	            restrict: 'EA',
	            scope: {
	                emptyPlaceholderText: '@' },

	            replace: true,
	            templateUrl: 'template/dropdownSelect/placeholder-empty.html',
	            link: function link(scope, element, attrs) {
	                scope.getEmptyText = function () {
	                    return scope.emptyPlaceholderText || dropdownSelectConfig.emptyPlaceholderText;
	                };
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    module.exports = function ($templateCache) {
	        $templateCache.put("template/dropdown/dropdown-multiple.html",
	        "<a tabindex=\"-1\">\n" +
	        " <i class=\"icon-ok pull-right\" ng-show=\"option.selected\"></i>\n" +
	        " <div bind-html-unsafe=\"option.label\" style=\"overflow: hidden;\"></div>\n" +
	        "</a>");

	        $templateCache.put("template/dropdown/dropdown-option.html",
	        "<a tabindex=\"-1\" bind-html-unsafe=\"option.label\"></a>");

	        $templateCache.put("template/dropdown/dropdown.html",
	        "<div class=\"btn-group dropdown\">\n" +
	        "    <button class=\"btn btn-block dropdown-toggle\" ng-class=\"[type && 'btn-' + type, disabled && 'disabled']\" style=\"text-align: left; padding-left:5px;\">\n" +
	        "        <span bind-html-unsafe=\"label || emptyLabel\"></span>\n" +
	        "        <span class=\"caret\" style=\"position: absolute; right: 12px\"></span>\n" +
	        "    </button>\n" +
	        "    <ul class=\"dropdown-menu\" style=\"min-width:100%;\">\n" +
	        "        <li ng-show=\"header\" ng-click=\"prevent($event)\"><h3 class=\"popover-title\" >{{header}}</h3></li>\n" +
	        "        <li ng-repeat-start=\"(group, options) in groups\" ng-click=\"prevent($event)\" style=\"padding-left:5px;\"><dt>{{group}}</dt></li>\n" +
	        "        <li ng-repeat=\"option in options\" ng-click=\"select($event, option)\" ng-class=\"{ disabled: option.disabled }\">\n" +
	        "            <div dropdown-option=\"dropdown-option\" option=\"option\" template-url=\"templateUrl\" multiple=\"multiple\"></div>\n" +
	        "        </li>\n" +
	        "        <li class=\"divider\" ng-hide=\"$index === numGroups - 1\" ng-repeat-end></li>\n" +
	        "    </ul>\n" +
	        "</div>\n" +
	        "");

	        $templateCache.put("template/dropdownSelect/option.html",
	        "<span>{{option}}</span>");

	        $templateCache.put("template/dropdownSelect/placeholder-empty.html",
	        "<span>{{getEmptyText()}}</span>");

	        $templateCache.put("template/dropdownSelect/select.html",
	        "<div class=\"btn-group dropdown\" ng-keydown=\"onKeydown($event)\" is-open=\"isopen\" role=\"combobox\" aria-activedescendant=\"{{activeOption.id}}\">\n" +
	        "    <button tabindex=\"0\" type=\"button\" class=\"btn dropdown-toggle\" ng-class=\"['btn-' + (type || 'default'), size && ('btn-' + size)]\" ng-disabled=\"isDisabled\" style=\"width:100%;\" aria-label=\"{{label}}\" >\n" +
	        "        <span placeholder-empty ng-if=\"isEmpty()\" empty-placeholder-text=\"{{emptyPlaceholderText}}\"></span>\n" +
	        "        <span ng-if=\"!isEmpty() && !multiple\" select-option=\"selectedOption.label\" template-url=\"optionTemplateUrl\"></span>\n" +
	        "        <span ng-if=\"!isEmpty() && multiple\" ng-repeat=\"option in selectedOption track by $index\"><span select-option=\"option.label\" template-url=\"optionTemplateUrl\"></span><span ng-if=\"!$last\">, </span></span>\n" +
	        "        <span class=\"caret\"></span>\n" +
	        "    </button>\n" +
	        "    <ul class=\"dropdown-menu\" ng-click=\"prevent($event)\" role=\"listbox\" ng-if=\"isopen\">\n" +
	        "        <li ng-if=\"filter.enabled\" style=\"padding:5px\"><input tabindex=\"-1\" type=\"search\" class=\"form-control\" style=\"width: 100%\" ng-model=\"filter.value\" ng-change=\"filterOptions()\" aria-readonly=\"true\" aria-activedescendant=\"{{activeOption.id}}\" placeholder=\"{{filterPlaceholderText}}\"></li>\n" +
	        "        <li ng-repeat-start=\"(groupName, group) in groups track by $index\" class=\"dropdown-header\" ng-if=\"groupName\">{{groupName}}</li>\n" +
	        "        <li tabindex=\"{{isActive(option) ? 0 : -1}}\" ng-repeat=\"option in group.options track by $index\" ng-class=\"{active: isActive(option)}\" role=\"option\" ng-click=\"select(option, $event)\" ng-if=\"option.valid\" aria-selected=\"{{!!option.selected}}\" aria-labelledby=\"{{option.id}}\" >\n" +
	        "            <a href tabindex=\"-1\" select-option=\"option.label\" template-url=\"optionTemplateUrl\" id=\"{{option.id}}\">\n" +
	        "                <i ng-if=\"multiple && option.selected\" class=\"glyphicon glyphicon-ok pull-right\"></i>\n" +
	        "            </a>\n" +
	        "        </li>\n" +
	        "        <li class=\"divider\" ng-if=\"!$last\" ng-repeat-end></li>\n" +
	        "    </ul>\n" +
	        "</div>\n" +
	        "");
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var base = __webpack_require__(20);
	    module.name = 'ui.tabs';

	    module.exports = base.createModule(module.name, ['ui.bootstrap']).
	    controller(__webpack_require__(111)).
	    directive(__webpack_require__(112)).
	    run(__webpack_require__(113));

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

		'use strict';
		var base = __webpack_require__(20);
		var angular = base.ng;

		// @ngInject
		exports.TabsetController = function TabsetCtrl($scope) {
			var ctrl = this,
			tabs = ctrl.tabs = $scope.tabs = [],
			activeIndex;

			ctrl.select = function (tab) {
				angular.forEach(tabs, function (tab) {
					tab.active = false;
				});
				tab.active = true;
				activeIndex = tabs.indexOf(tab);
			};

			ctrl.addTab = function addTab(tab) {
				tabs.push(tab);
				if (tabs.length === 1 || tab.active) {
					ctrl.select(tab);
				}
			};

			ctrl.removeTab = function removeTab(tab) {
				var index = tabs.indexOf(tab);
				//Select a new tab if the tab to be removed is selected
				if (tab.active && tabs.length > 1) {
					//If this is the last tab, select the previous tab. else, the next tab.
					var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
					ctrl.select(tabs[newActiveIndex]);
				}
				tabs.splice(index, 1);
			};

			$scope.onKeydown = function (evt) {
				if (!/(37|38|39|40)/.test(evt.which) || evt.shiftKey || evt.altKey) return;
				evt.preventDefault();
				evt.stopPropagation();

				// up & left = previous, down & right = next
				var step = evt.which > 38 ? 1 : -1;

				// Search the rest of the tabs for the closest not disabled
				for (var i = 1, n = tabs.length; i < n; i++) {
					var tabindex = (activeIndex + i * step + n) % n,
					tab = tabs[tabindex];

					if (!tab.disabled) {
						// Activate & focus it's trigger element
						tab.active = true;
						tab.$element.find('a')[0].focus();
						break;
					}
				}
			};
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var base = __webpack_require__(20);
	    var angular = base.ng;

	    exports.tabset = function () {
	        return {
	            restrict: 'EA',
	            transclude: true,
	            replace: true,
	            scope: {},
	            controller: 'TabsetController',
	            templateUrl: 'template/tabs/tabset.html',
	            link: function link(scope, element, attrs) {
	                scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	                scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	                scope.type = angular.isDefined(attrs.type) ? scope.$parent.$eval(attrs.type) : 'tabs';
	            } };

	    };

	    exports.tabContentTransclude = function () {
	        return {
	            restrict: 'A',
	            require: '^tabset',
	            link: function link(scope, elm, attrs) {
	                var tab = scope.$eval(attrs.tabContentTransclude);

	                //Now our tab is ready to be transcluded: both the tab heading area
	                //and the tab content area are loaded.  Transclude 'em both.
	                tab.$transcludeFn(tab.$parent, function (contents) {
	                    angular.forEach(contents, function (node) {
	                        if (isTabHeading(node)) {
	                            //Let tabHeadingTransclude know.
	                            tab.headingElement = node;
	                        } else {
	                            elm.append(node);
	                        }
	                    });
	                });
	            } };


	        function isTabHeading(node) {
	            return node.tagName && (
	            node.hasAttribute('tab-heading') ||
	            node.hasAttribute('data-tab-heading') ||
	            node.hasAttribute('x-tab-heading') ||
	            node.tagName.toLowerCase() === 'tab-heading' ||
	            node.tagName.toLowerCase() === 'data-tab-heading' ||
	            node.tagName.toLowerCase() === 'x-tab-heading');

	        }
	    };

	    // @ngInject
	    exports.tab = function ($parse) {
	        var instance = 0;
	        return {
	            require: '^tabset',
	            restrict: 'EA',
	            replace: true,
	            templateUrl: 'template/tabs/tab.html',
	            transclude: true,
	            scope: {
	                heading: '@',
	                onSelect: '&select', //This callback is called in contentHeadingTransclude
	                //once it inserts the tab's content into the dom
	                onDeselect: '&deselect' },

	            controller: function controller() {
	                //Empty controller so other directives can require being 'under' a tab
	            },
	            compile: function compile(elm, attrs, transclude) {
	                return function postLink(scope, elm, attrs, tabsetCtrl) {
	                    scope.$element = elm;

	                    scope.uniqueId = 'select-' + instance++ + '-' + Math.floor(Math.random() * 10000);

	                    var getActive, setActive;
	                    if (attrs.active) {
	                        getActive = $parse(attrs.active);
	                        setActive = getActive.assign;
	                        scope.$parent.$watch(getActive, function updateActive(value, oldVal) {
	                            // Avoid re-initializing scope.active as it is already initialized
	                            // below. (watcher is called async during init with value ===
	                            // oldVal)
	                            if (value !== oldVal) {
	                                scope.active = !!value;
	                            }
	                        });
	                        scope.active = getActive(scope.$parent);
	                    } else {
	                        setActive = getActive = angular.noop;
	                    }

	                    scope.$watch('active', function (active) {
	                        // Note this watcher also initializes and assigns scope.active to the
	                        // attrs.active expression.
	                        setActive(scope.$parent, active);
	                        if (active) {
	                            tabsetCtrl.select(scope);
	                            scope.onSelect();
	                        } else {
	                            scope.onDeselect();
	                        }
	                    });

	                    scope.disabled = false;
	                    if (attrs.disabled) {
	                        scope.$parent.$watch($parse(attrs.disabled), function (value) {
	                            scope.disabled = !!value;
	                        });
	                    }

	                    scope.select = function () {
	                        if (!scope.disabled) {
	                            scope.active = true;
	                        }
	                    };

	                    tabsetCtrl.addTab(scope);
	                    scope.$on('$destroy', function () {
	                        tabsetCtrl.removeTab(scope);
	                        scope.$element = null;
	                    });


	                    //We need to transclude later, once the content container is ready.
	                    //when this link happens, we're inside a tab heading.
	                    scope.$transcludeFn = transclude;
	                };
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    module.exports = function ($templateCache) {
	        $templateCache.put("template/tabs/tabset.html",
	        "<div>\n" +
	        "  <ul ng-keydown=\"onKeydown($event)\" class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" role=\"tablist\" ng-transclude></ul>\n" +
	        "  <div class=\"tab-content\">\n" +
	        "    <div class=\"tab-pane\" ng-repeat=\"tab in tabs\" ng-class=\"{active: tab.active}\"\n" +
	        "         role=\"tabpanel\" aria-hidden=\"{{!tab.active}}\"\n" +
	        "         tab-content-transclude=\"tab\">\n" +
	        "    </div>\n" +
	        "  </div>\n" +
	        "</div>\n" +
	        "");

	        $templateCache.put("template/tabs/tab.html",
	        "<li ng-class=\"{active: active, disabled: disabled}\" id=\"{{uniqueId}}\" role=\"presentation\" ng-click=\"select()\">\n" +
	        "  <a href role=\"tab\" tabindex=\"0\" aria-labelledby=\"{{uniqueId}}\" aria-expanded=\"{{!!active}}\" aria-selected=\"{{!!active}}\" tab-heading-transclude>{{heading}}</a>\n" +
	        "</li>\n" +
	        "");
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               * UI utilities module exposed as `lpUIUtils` angular constant object.
	               * @name utils
	               * @memberof ui
	               * @ngModule
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	  'use strict';

	  module.name = 'ui.utils';
	  var base = __webpack_require__(20);

	  /**
	                               * @name lpUIUtils
	                               * @memberof ui.utils
	                               * @ngConstant
	                               */

	  var utils = base.utils;

	  utils.mixin(__webpack_require__(115));
	  utils.mixin(__webpack_require__(116));
	  utils.mixin(__webpack_require__(117));
	  utils.mixin(__webpack_require__(118));

	  module.exports = base.createModule(module.name, []).
	  constant({ 'lpUIUtils': utils });
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Input helpers.
	               * @module input
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	                   * Get the selection position of an input field
	                   * @param {element} input the input field to get the caret position
	                   * @param {Function} formatter function to handle formatting of input field
	                   */
	    exports.getSelectionPositionOfInput = function (input, formatter) {
	        var textSelection = [];
	        if (!formatter) {
	            formatter = function formatter(_input) {
	                return _input;
	            };
	        }

	        // get the selection start and end values
	        if ('selectionStart' in input) {
	            textSelection = [formatter(input.selectionStart), formatter(input.selectionEnd)];
	        } else {
	            // < IE9 version
	            var range = document.selection.createRange();
	            if (range && range.parentElement() === input) {
	                var textInputRange = input.createTextRange();
	                textInputRange.moveToBookmark(range.getBookmark());
	                textSelection[0] = formatter(textInputRange.moveStart('character', -input.value.length));
	                textSelection[1] = formatter(textInputRange.moveEnd('character', -input.value.length));
	            }
	        }

	        return textSelection;
	    };

	    /**
	        * Gets the caret position of an input field after it has been updated
	        * @param {element} input        The input field
	        * @param {Array}   previousTextSelection  The previous selection on the input before the update
	        * @param {Number}  lengthDiff   The difference in length between the previous value and the new value
	        * @param {Boolean} isBackspace  If the last keypress was a backspace
	        */
	    exports.getNewCaretPosition = function (input, previousTextSelection, lengthDiff, isBackspace) {
	        var cursorPosition = previousTextSelection[0];

	        lengthDiff = previousTextSelection[1] - previousTextSelection[0] + lengthDiff;
	        if (lengthDiff <= 0) {
	            lengthDiff = 1;
	        }
	        // reset the selection values if input field is empty
	        if (!input.value.length) {
	            previousTextSelection = [0, 0];
	        }

	        if (previousTextSelection[0] === previousTextSelection[1]) {
	            // if the nothing is selected in the input field
	            if (isBackspace) {
	                cursorPosition = previousTextSelection[0] === 0 ? 0 : previousTextSelection[0] - 1;
	            } else {
	                cursorPosition = previousTextSelection[0] + lengthDiff;
	            }
	        } else {
	            // if something is selected
	            if (isBackspace) {
	                cursorPosition = previousTextSelection[0];
	            } else {
	                cursorPosition = previousTextSelection[0] + lengthDiff;
	            }
	        }

	        return cursorPosition;
	    };

	    /**
	        * Sets the caret position of input field an handles the scroll to have the caret centered
	        * @param {Element} input the input field to set the caret position of
	        * @param {Number} cursorPosition numeric value representing the desired caret position
	        * @param {String} content content of input field
	        * @param {Element} dummyField dummy field to measure length of text
	        */
	    exports.setCaretPositionOfInput = function (input, cursorPosition, content, dummyField) {

	        var scroll;

	        // set the correct cursor position
	        if ('setSelectionRange' in input) {
	            input.setSelectionRange(cursorPosition, cursorPosition);
	        } else {
	            // < IE9 version
	            var range = input.createTextRange();
	            range.collapse(true);
	            range.moveEnd('character', cursorPosition);
	            range.moveStart('character', cursorPosition);
	            range.select();
	        }
	        //handle input scroll
	        if (content && dummyField) {
	            if (content) {
	                dummyField.text(content.substr(0, cursorPosition));
	            } else {
	                dummyField.text('');
	            }
	            scroll = dummyField.width() - input.offsetWidth / 2;
	            input.scrollLeft = scroll;
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Images helpers.
	               * @module images
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.extractInitials = function (name) {
	        var initials = '';
	        name = name.split(' ');
	        for (var i = 0; i < name.length; i++) {
	            initials += name[i].substr(0, 1);
	        }
	        initials = initials.toUpperCase();
	        return initials;
	    };

	    exports.getColorFromInitials = function (initials) {
	        var a = initials.charCodeAt(0) - 64;
	        var x = a + 120;
	        var i = Math.floor((a - 1) / (26 - 1) * (5 - 1) + 1 - 1);
	        var colors = [
	        [x, 210, 210],
	        [x, x, 210],
	        [210, x, x],
	        [x, 210, x],
	        [210, x, 210]];

	        return colors[i];
	    };

	    var defaultProfileImage = 'data:image/png;base64,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';

	    exports.getDefaultProfileImage = function (name, width, height, color) {
	        var canvas = document.createElement('canvas');

	        if (!canvas.getContext || !canvas.getContext('2d')) {
	            return defaultProfileImage;
	        }

	        var initials = exports.extractInitials(name);
	        color = color || exports.getColorFromInitials(initials);

	        canvas.setAttribute('width', width);
	        canvas.setAttribute('height', height);
	        var ctx = canvas.getContext('2d');

	        var isArray = Object.prototype.toString.call(color) === '[object Array]';
	        ctx.fillStyle = isArray ? 'rgb(' + color.join(',') + ')' : color;
	        ctx.fillRect(0, 0, width, height);
	        ctx.fillStyle = 'rgb(250,250,250)';

	        var scale;
	        switch (initials.length) {
	            case 1:
	                scale = 0.6;
	                break;

	            case 2:
	                scale = 0.5;
	                break;

	            case 3:
	                scale = 0.45;
	                break;

	            default:
	                scale = 0.3;
	                break;}


	        var fontSize = parseInt(scale * height, 10);
	        var marginBottom = Math.floor(0.15 * height);
	        ctx.font = fontSize + 'px Proxima Regular, Helvetica Nueue, Helvetica, Arial, sans-serif';
	        ctx.textAlign = 'right';
	        ctx.fillText(initials, width - 3, height - marginBottom);

	        var dataUri = canvas.toDataURL('image/png');
	        return dataUri;
	    };

	    /**
	        * @param {String} photoUrl Photo Url
	        * @returns {String|Null}
	        */
	    exports.decodePhotoUrl = function (photoUrl) {
	        return photoUrl ? decodeURIComponent(photoUrl) : null;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * General DOM helpers.
	               * @module dom
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    /**
	                   * Moves attributes from srcElem to destElem, using values from attrs, excluding the blacklist.
	                   *
	                   * @param {Element} srcElem
	                   * @param {Element} destElem
	                   * @param {Object} blacklist
	                   */
	    exports.moveAttributes = function (srcElem, destElem, blacklist) {
	        // Transfer attributes from srcElem to the destElem.
	        var moveAttrs = srcElem.prop('attributes');
	        var i;

	        for (i = 0; i < moveAttrs.length; i++) {
	            if (blacklist.indexOf(moveAttrs[i].name) === -1) {
	                destElem.attr(moveAttrs[i].name, moveAttrs[i].value);
	                srcElem.attr(moveAttrs[i].name, null);
	            }
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * String mask helpers.
	               * @module string-mask
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var StringMask = __webpack_require__(119);

	    function clearDelimitersAndLeadingZeros(value) {
	        var cleanValue = value.replace(/^-/, '').replace(/^0*/, '');
	        cleanValue = cleanValue.replace(/[^0-9]/g, '');
	        return cleanValue;
	    }

	    module.exports = {
	        StringMask: StringMask,

	        prepareNumberToFormatter: function prepareNumberToFormatter(value, decimals) {
	            return clearDelimitersAndLeadingZeros(parseFloat(value).toFixed(decimals));
	        },

	        /* todo: move these
	                   maxNumber: function maxValidator(ctrl, value, limit) {
	                       var max = parseFloat(limit);
	                       var validity = ctrl.$isEmpty(value) || isNaN(max)|| value <= max;
	                       ctrl.$setValidity('max', validity);
	                       return value;
	                   },
	           
	                   minNumber: function minValidator(ctrl, value, limit) {
	                       var min = parseFloat(limit);
	                       var validity = ctrl.$isEmpty(value) || isNaN(min) || value >= min;
	                       ctrl.$setValidity('min', validity);
	                       return value;
	                   }
	           */

	        numberMask: function numberMask(decimals, decimalDelimiter, thousandsDelimiter) {
	            var mask = '#' + thousandsDelimiter + '##0';

	            if (decimals > 0) {
	                mask += decimalDelimiter;
	                for (var i = 0; i < decimals; i++) {
	                    mask += '0';
	                }
	            }

	            return new StringMask(mask, {
	                reverse: true });

	        },

	        decimalMask: function decimalMask(decimals) {
	            var mask = '###0';

	            if (decimals > 0) {
	                mask += '.';
	                for (var i = 0; i < decimals; i++) {
	                    mask += '0';
	                }
	            }

	            return new StringMask(mask, {
	                reverse: true });

	        } };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.StringMask = factory();
		}
	})(undefined, function () {
		var tokens = {
			'0': { pattern: /\d/, _default: '0' },
			'9': { pattern: /\d/, optional: true },
			'#': { pattern: /\d/, optional: true, recursive: true },
			'S': { pattern: /[a-zA-Z]/ },
			'U': { pattern: /[a-zA-Z]/, transform: function transform(c) {return c.toLocaleUpperCase();} },
			'L': { pattern: /[a-zA-Z]/, transform: function transform(c) {return c.toLocaleLowerCase();} },
			'$': { escape: true } };


		function isEscaped(pattern, pos) {
			var count = 0;
			var i = pos - 1;
			var token = { escape: true };
			while (i >= 0 && token && token.escape) {
				token = tokens[pattern.charAt(i)];
				count += token && token.escape ? 1 : 0;
				i--;
			}
			return count > 0 && count % 2 === 1;
		}

		function calcOptionalNumbersToUse(pattern, value) {
			var numbersInP = pattern.replace(/[^0]/g, '').length;
			var numbersInV = value.replace(/[^\d]/g, '').length;
			return numbersInV - numbersInP;
		}

		function concatChar(text, character, options, token) {
			if (token && typeof token.transform === 'function') character = token.transform(character);
			if (options.reverse) return character + text;
			return text + character;
		}

		function hasMoreTokens(pattern, pos, inc) {
			var pc = pattern.charAt(pos);
			var token = tokens[pc];
			if (pc === '') return false;
			return token && !token.escape ? true : hasMoreTokens(pattern, pos + inc, inc);
		}

		function insertChar(text, char, position) {
			var t = text.split('');
			t.splice(position >= 0 ? position : 0, 0, char);
			return t.join('');
		}

		function StringMask(pattern, opt) {
			this.options = opt || {};
			this.options = {
				reverse: this.options.reverse || false,
				usedefaults: this.options.usedefaults || this.options.reverse };

			this.pattern = pattern;
		}

		StringMask.prototype.process = function proccess(value) {
			if (!value) {
				return { result: '', valid: false };
			}
			value = value + '';
			var pattern2 = this.pattern;
			var valid = true;
			var formatted = '';
			var valuePos = this.options.reverse ? value.length - 1 : 0;
			var optionalNumbersToUse = calcOptionalNumbersToUse(pattern2, value);
			var escapeNext = false;
			var recursive = [];
			var inRecursiveMode = false;

			var steps = {
				start: this.options.reverse ? pattern2.length - 1 : 0,
				end: this.options.reverse ? -1 : pattern2.length,
				inc: this.options.reverse ? -1 : 1 };


			function continueCondition(options) {
				if (!inRecursiveMode && hasMoreTokens(pattern2, i, steps.inc)) {
					return true;
				} else if (!inRecursiveMode) {
					inRecursiveMode = recursive.length > 0;
				}

				if (inRecursiveMode) {
					var pc = recursive.shift();
					recursive.push(pc);
					if (options.reverse && valuePos >= 0) {
						i++;
						pattern2 = insertChar(pattern2, pc, i);
						return true;
					} else if (!options.reverse && valuePos < value.length) {
						pattern2 = insertChar(pattern2, pc, i);
						return true;
					}
				}
				return i < pattern2.length && i >= 0;
			}

			for (var i = steps.start; continueCondition(this.options); i = i + steps.inc) {
				var pc = pattern2.charAt(i);
				var vc = value.charAt(valuePos);
				var token = tokens[pc];
				if (!inRecursiveMode || vc) {
					if (this.options.reverse && isEscaped(pattern2, i)) {
						formatted = concatChar(formatted, pc, this.options, token);
						i = i + steps.inc;
						continue;
					} else if (!this.options.reverse && escapeNext) {
						formatted = concatChar(formatted, pc, this.options, token);
						escapeNext = false;
						continue;
					} else if (!this.options.reverse && token && token.escape) {
						escapeNext = true;
						continue;
					}
				}

				if (!inRecursiveMode && token && token.recursive) {
					recursive.push(pc);
				} else if (inRecursiveMode && !vc) {
					if (!token || !token.recursive) formatted = concatChar(formatted, pc, this.options, token);
					continue;
				} else if (recursive.length > 0 && token && !token.recursive) {
					// Recursive tokens most be the last tokens of the pattern
					valid = false;
					continue;
				} else if (!inRecursiveMode && recursive.length > 0 && !vc) {
					continue;
				}

				if (!token) {
					formatted = concatChar(formatted, pc, this.options, token);
					if (!inRecursiveMode && recursive.length) {
						recursive.push(pc);
					}
				} else if (token.optional) {
					if (token.pattern.test(vc) && optionalNumbersToUse) {
						formatted = concatChar(formatted, vc, this.options, token);
						valuePos = valuePos + steps.inc;
						optionalNumbersToUse--;
					} else if (recursive.length > 0 && vc) {
						valid = false;
						break;
					}
				} else if (token.pattern.test(vc)) {
					formatted = concatChar(formatted, vc, this.options, token);
					valuePos = valuePos + steps.inc;
				} else if (!vc && token._default && this.options.usedefaults) {
					formatted = concatChar(formatted, token._default, this.options, token);
				} else {
					valid = false;
					break;
				}
			}

			return { result: formatted, valid: valid };
		};

		StringMask.prototype.apply = function (value) {
			return this.process(value).result;
		};

		StringMask.prototype.validate = function (value) {
			return this.process(value).valid;
		};

		StringMask.process = function (value, pattern, options) {
			return new StringMask(pattern, options).process(value);
		};

		StringMask.apply = function (value, pattern, options) {
			return new StringMask(pattern, options).apply(value);
		};

		StringMask.validate = function (value, pattern, options) {
			return new StringMask(pattern, options).validate(value);
		};

		return StringMask;
	});

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js